export default {
  // Common
  'common.am': 'AM',
  'common.pm': 'PM',
  'common.unit.h': 'h',
  'common.unit.m': 'm',
  'common.unit.hour': 'Hour',
  'common.unit.hours': 'Hours',
  'common.unit.minute': 'Minute',
  'common.unit.minutes': 'Minutes',
  'common.smart vision': 'Smart Vision',
  'common.success': 'Success',
  'common.error': 'Error',
  'common.ok': 'OK',
  'common.run': 'Run',
  'common.dashboard': 'Dashboard',
  'common.sorrySomethingWentWrong': 'Sorry, something went wrong',
  'common.requestFailed': 'We could not connect to the server. Please try again later.',
  'common.connectionError': 'We could not connect to the server. Please try again later.',
  'common.operationSuccess': 'Operation completed successfully.',
  'common.saveFailed': 'Save Failed',
  'common.thisItem': 'this item',
  'common.createdSuccessfully': 'Created successfully',
  'common.updatedSuccessfully': 'Updated successfully',
  'common.deletedSuccessfully': 'Deleted successfully',
  'common.updateSuccess': 'Updated successfully',
  'common.recordDeletedSuccessfully': 'Record deleted successfully',
  'common.requestSubmitted': 'Request submitted successfully',
  'workflow.bulkInvalidRequest': 'Some selected requests cannot be processed because required information is missing for the current approval stage. Please review the failed requests and try again.',
  // Workflow bulk actions - explicit error-code messages
  'workflow.bulk.successfullyProcessed': 'Successfully processed',
  'workflow.bulk.invalidOrInactiveAction': 'Invalid or inactive action.',
  'workflow.bulk.requiredFieldsNotCompleted': 'One or more selected requests have required fields that have not been completed.',
  'workflow.bulk.noLongerPending': 'One or more selected requests are no longer pending your approval.',
  'workflow.bulk.noValidPending': 'No valid pending requests were found to process.',
  'workflow.bulk.unexpectedNoChanges': 'An unexpected error occurred while processing the requests. No changes were applied.',
  'workflow.bulk.databaseError': 'Database Error',
  'workflow.bulk.alreadyApproved': 'Already approved',
  'workflow.bulk.alreadyRejected': 'Already rejected',
  'common.approved': 'Approved',
  'common.rejected': 'Rejected',
  'common.pending': 'Pending',
  'common.absent': 'Absent',
  'common.violation': 'Violation',
  'common.noviolation': 'No Violation',
  'common.rest_day': 'Rest Day',
  'common.restday': 'Rest Day',
  'common.holiday': 'Holiday',
  'common.eidAlAdha': 'Eid Al Adha',
  'common.present': 'Present',
  'common.present(no_violation)': 'Present (No Violation)',
  'common.wfh': 'WFH',
  'common.punchOut': 'Punch Out',
  'common.overtime': 'Overtime',
  'common.early_out': 'Early Out',
  'common.step_out': 'Step Out',
  'common.remote': 'Remote',
  'common.leave': 'Leave',
  'common.afternoon shift': 'Afternoon Shift',
  'common.morning shift': 'Morning Shift',
  'common.night shift': 'Night Shift',
  'tenant.error.workspaceNotResolved': 'Workspace could not be resolved. Please verify the workspace URL and try again.',
  'tenant.error.tenantCodeRequired': 'Tenant code is required. Please open the login page using your workspace URL.',
  'tenant.error.tenantConfigurationNotFound': 'Tenant configuration was not found. Please contact your administrator.',
  'common.weekdays.sun': 'Sun',
  'common.weekdays.mon': 'Mon',
  'common.weekdays.tue': 'Tue',
  'common.weekdays.wed': 'Wed',
  'common.weekdays.thu': 'Thu',
  'common.weekdays.fri': 'Fri',
  'common.weekdays.sat': 'Sat',
  'common.employeesNoPlaceHolder': 'employee no 1, employee no 2',
  'common.by': 'By',
  'common.download': 'Download',
  'common.readMore': 'Read more',
  'common.readLess': 'Read less',
  'common.rawHtml': 'Raw HTML',
  'common.richText': 'Rich Text',
  'common.workDays': 'Work Days',
  'common.dailyScheduleType': 'Daily Schedule Type',
  'common.duration': 'Duration',
  'common.pageName': 'Page Name',
  'common.referenceId': 'Reference ID',
  'common.copy': 'Copy',
  'common.consumed':'Consumed',
  'notification.dropdown.title': 'Notifications',
  'notification.dropdown.readAll': 'Read All',
  'notification.dropdown.clear': 'Clear',
  'notification.dropdown.empty': 'No notifications',
  'notification.dropdown.loadingMore': 'Loading more…',
  'notification.dropdown.scrollForMore': 'Scroll to load more',
  'common.searchBy(EmployeeName,EmployeeNO)':
    'Search By (EmployeeName,EmployeeNO)',
  'common.show': 'Show',
  'common.from': 'From',
  'common.pleaseSelect': '-- Please Select --',
  'common.cardTemplate': 'Card Template',
  'common.selectTemplateToPreview': 'Select a Card Template to preview',
  'common.noPreviewAvailable': 'No preview available',
  'common.print': 'Print',
  'common.printCard': 'Print card',
  'common.notification': 'Notification Type',
  'common.fromDate': 'From Date',
  'common.toDate': 'To Date',
  'common.to': 'To',
  'common.toTime': 'To Time',
  'common.workInfo': 'Work Information',
  'common.assignment': 'Assignment',
  'common.Ramdan-Period': 'Ramdan Period',
  'common.Holiday-Period': 'Holiday Period',
  'common.permissionType': 'Permission Type',
  'common.permission': 'Permission',
  'common.employee': 'Employee',
  'common.employeeType': 'Employee Type',
  'common.requiredField': 'Required',
  'common.entity': 'Department',
  'employee.region': 'Region',
 
  'common.categoryID': 'Category',
  'common.employeeCategory': 'Employee Category',
  'common.designationID': 'Designation',
  'common.montlyLimitHH': 'Monthly Limit (HH)',
  'common.montlyLimitMM': 'Monthly Limit (MM)',
  'common.subEntity': 'Sub Entity',
  'common.subDepartment': 'Sub Department',
  'common.company': 'Company',
  'common.department': 'Department',
  'common.grade': 'Grade',
  'common.status': 'Status',
  'common.requestInformation': 'Request Information',
  'common.dayCounts': 'Day Counts',
  'common.noDataFound': 'No Data Found',
  'common.noDataMatchesSelectedFilters': 'No data matches the selected filters. Please adjust the filters and try again.',
  'common.requestType': 'Request Type',
  'common.groupTab': 'Group',
  'common.edit': 'Edit',
  'common.refresh': 'Refresh',
  'common.serverTime': 'Server UTC',
  'common.save': 'Save',
  'common.saveChanges': 'Save changes',
  'common.comingSoon': 'Coming soon',
  'common.saving': 'Saving',
  'common.unsavedChanges': 'Unsaved Changes',
  'common.unsavedChangesMessage': 'You have unsaved changes. Are you sure you want to leave?',
  'common.testing': 'Testing',
  'common.reset': 'Reset',
  'common.fieldRequired': 'This field is required',
  'common.validPortRequired': 'Please enter a valid port number',
  'common.validEmailRequired': 'Please enter a valid email address',
  'common.emailConfigurationSaved': 'Email configuration saved successfully',
  'common.configurationSaved': 'Configuration saved successfully',
  'common.emailTestSuccessful': 'Email test sent successfully',
  'error.passwordOrApiKeyRequired': 'Password or API Key is required',
  'error.invalidEmailFormat': 'Invalid email format',
  'error.invalidEmail': 'Invalid email address',
  'error.requiredField': 'This field is required',
  'emailTestConnection.EMAIL_SENT': 'Test email sent successfully.',
  'emailTestConnection.SMTP_AUTH_FAILED': 'Authentication failed. Check your username and password.',
  'emailTestConnection.SMTP_HOST_UNREACHABLE': 'Cannot reach the SMTP server. Check the host and port.',
  'emailTestConnection.SMTP_SSL_ERROR': 'SSL/TLS handshake failed. Check the SSL setting and port.',
  'emailTestConnection.SMTP_TIMEOUT': 'Connection timed out. The server did not respond in time.',
  'emailTestConnection.SMTP_MESSAGE_REJECTED': 'The server rejected the message. Check SPF/DKIM or sender policy.',
  'emailTestConnection.SMTP_MAILBOX_UNAVAILABLE': 'The recipient mailbox is unavailable or does not exist.',
  'emailTestConnection.SMTP_ERROR': 'An SMTP error occurred. Check your configuration.',
  'emailTestConnection.INVALID_EMAIL_FORMAT': 'One or more email addresses are invalid.',
  'emailTestConnection.UNEXPECTED_ERROR': 'An unexpected error occurred. Please try again.',
  'error.failedToSave': 'Failed to save',
  'error.failedToSaveEmailConfiguration': 'Failed to save email configuration',
  'error.couldNotLoadEmailConfiguration': 'Could not load email configuration',
  'error.emailTestFailed': 'Email test failed',
  'common.delete': 'Delete',
  'common.view':'View',
  'lookup.dashboardConfiguration': 'Dashboard Configuration',
  'dashboard.configurationSaved': 'Configuration saved successfully',
  'dashboard.configurationSaveFailed': 'Failed to save configuration',
  'dashboard.layoutConfigSaved': 'Dashboard layout configuration saved successfully',
  'dashboard.layoutConfigSaveFailed': 'Failed to save dashboard layout configuration',
  'common.remove': 'Remove',
  'common.back': 'Back',
  'common.viewUser' :'View Employee',
  'common.typeID': 'Type ID',
  'common.intervalID': 'Interval Id',
  'common.copy': 'Copy',
  'common.cancel': 'Cancel',
  'common.confirm': 'Confirm',
  'common.ok': 'OK',
  'common.minute': 'Minute',
  'common.minutes': 'Minutes',
  'common.pleaseSelectFile': 'Please select file',
  'common.onlyExcelFilesAllowed': 'Only Excel files (.xlsx, .xls) are allowed',
  'common.downloadTemplateError': 'Failed to download template. Please try again.',
  'common.downloadExcelTemplate': 'Download Excel Template',
  'common.loadingTemplate': 'Loading template...',
  'common.fileParseError': 'Failed to parse Excel file',
  'common.fileReadError': 'Failed to read file',
  'common.verify': 'Verify',
  'common.verifying': 'Verifying...',
  'common.allRecordsVerified': 'All records verified',
  'common.noDataToImport': 'No data to import',
  'common.importError': 'Import failed',
  'common.importSuccess': 'Data imported successfully',
  'common.importSuccessWithCount': '{successCount}/{totalRows} records imported.',
  'common.hour': 'Hour',
  'common.uploadedFile': 'Uploaded File',
  'common.excelFile': 'Excel File',
  'common.records': 'records',
  'common.templateNotFound': 'Template not found. Please contact administrator to set up the template.',
  'common.hours': 'Hours',
  'common.next': 'Next',
  'common.previous': 'Previous',
  'common.page': 'Page',
  'common.of': 'of',
  'common.login': 'Login',
  'common.logout': 'Logout',
  'common.loginConfigurationSaved': 'Login configuration saved successfully',
  'common.email': 'Email',
  'common.companyEmail': 'Company Email',
  'common.employeeOnboardingWelcomeMessage': 'Employee Onboarding Welcome Message',
  'common.sendEmployeeWelcomeEmail': 'Send Employee Welcome Email',
  'common.sms': 'SMS',
  'common.pushNotification': 'Push Notification',
  'common.recordDeleted': 'Record Deleted',
  'common.deleteFailed': 'Delete Failed',
  'common.successfullyDeletedRecords': 'Successfully deleted {count} record(s)',
  'common.someDeletesFailed': 'Some deletes failed',
  'common.missingId': 'Missing ID.',
  'common.managerName': 'Manager Name',
  'common.avatar': 'Avatar',
  'common.error': 'Error',
  'common.unknown': 'Unknown',
  'common.search': 'Search',
  'common.searchPlaceholder': 'Search...',
  'common.employeeList': 'Employee List',
  'common.selectedEmployee': 'Selected Employee',
  'common.add': 'Add',
  'common.thisItem': 'this item',
  'common.import': 'Import',
  'common.validationError': 'Validation Error',
  'common.selectAtLeastOneField': 'Please select at least one field to update',
  'common.by': 'by',
  'common.to': 'to',
  'common.employees': 'Employees',
  'common.manager': 'Manager',
  'common.confirmation': 'Confirmation',
  'common.pleaseSelectAtLeastOneRecordToDelete': 'Please select at least one record to delete',
  'common.downloadConfirmMsg': 'Do you want to download the following items?',
  'common.itemsWillBeDownloaded': 'Successfully downloading {count} record(s)',
  'common.exportPDF': 'Export PDF',
  'common.addCompany': 'Add Company',
  'common.editCompany': 'Edit Company',
  'common.logo': 'Logo',
  'common.reportLogo': 'Report Logo',
  'common.noImage': 'No Image',
  'common.startRecording': 'Start Recording',
  'common.loading': 'Loading...',
  'common.exportCSV': 'Export Excel',
  'common.importData': 'Import Data',
  'common.allRecordExportPDF': 'All items will be exported to PDF.',
  'common.allRecordExportCSV': 'All items will be exported to .csv',
  'common.allRecordImport': 'All items will be Imported.',
  'common.confirmActionMsg': 'Are you sure you want to perform this action?',
  'common.itemsWillBeDownloaded': '{count} items will be downloaded.',
  'common.itemWillBeCopied': '{count} item will be Copied.',
  'common.areYouSure': 'Are You Sure ?',
  'common.deleteConfirm': 'Delete Confirmation',
  'common.deleteConfirmMsg': 'Are you sure you want to delete {name}?',
  'common.bulkDeleteConfirmMsg': 'Are you sure you want to delete {count} record(s)?',
  'common.add schedule': 'Add Schedule',
  'common.employeeNo': 'Employee No',
  'common.duration': 'Duration',
  'common.retrieve': 'Retrieve',
  'common.close': 'Close',
  'common.ok': 'OK',
  'common.pendingWith': 'Pending With',
  'common.workLocation': 'Work Location',
  'common.lat': 'Lat',
  'common.long': 'Long',
  'common.mapUrl': 'Map Url',
  'common.fieldsToUpdate':'Fields To Update',
  'common.radius': 'Radius',
  'common.time': 'Time',
  'common.submit': 'Submit',
  'common.tryAgain': 'Try Again',
  'common.workedHours': 'Worked Hours',
  'common.maxStepOutDuration': 'Max Step Out Duration',
  'common.numOutAttempts': 'Number of Out Attempts',
  'common.priority': 'Priority',
  'common.considerAsAbsent': 'Consider as Absent',
  'common.workingHourLess': 'If working hours less than',
  'common.punchInAfter': 'If first punch in after',
  'common.lastPunchOutBefore': 'If last punch out before',
  'common.absentRuleDurationPlaceholder': 'Duration (HH:MM)',
  'common.absentRuleDurationTooltipExample': 'Enter duration (HH:MM), e.g. 01:30 = 1 hour 30 minutes',
  'common.absentRuleDurationTooltip': 'Enter duration (HH:MM), not a clock time',
  'common.minDurApply': 'Min duration to apply',
  'common.maxDurApply': 'Max duration to apply',
  'common.minWorkingHoursApply': 'Min working hours to apply',
  'common.beforeSchedule': 'Calculate Overtime Before Schedule',
  'common.afterSchedule': 'Calculate Overtime After Schedule',
  'common.overtimeBefore': 'Overtime Before',
  'common.overtimeUntil': 'Overtime Until',
  'common.selectColor': 'Select color',
  'common.checkIn': 'Check In',
  'common.checkOut': 'Check Out',
  'common.showMore': 'Show More',
  'common.showLess': 'Show Less',
  'common.viewAll': 'View All',
  'common.remoteWork': 'Remote Work',
  'common.addRemoteEntry': 'Add Remote Entry',
  'common.count': 'Count',
  'common.roleID': 'User Role',
  'common.id': 'ID',
  'common.companyID': 'Company Name',
  'common.count>=': 'Count >=',
  'common.totalDays': 'Total Days',
  'common.manager': 'Manager',
  'common.delegation': 'Delegation',
  'common.startDate': 'Start Date',
  'common.endDate': 'End Date',
  'common.keyword': 'Keyword',
  'common.icon': 'Icon',
  'common.nameArabic': 'Name Arabic',
  'common.nameEnglish': 'Name English',
  'common.nameAr': 'Name (Arabic)',
  'common.nameEn': 'Name (English)',
  'common.na': 'N/A',
  'common.timeZone': 'Time Zone',
  'unauthorized.title': 'Unauthorized Access Attempt',
  'unauthorized.detail': 'You are not authorized to view the page you are trying to access.',
  'attendanceDuration.iconDefault': 'Default',
  'attendanceDuration.iconEvening': 'Evening',
  'attendanceDuration.iconMorning': 'Morning',
  'attendanceDuration.iconAfternoon': 'Afternoon',
  'attendanceDuration.iconMidnight': 'Midnight',
  'Go back to Home': 'Go back to Home',
  'common.scheduleType': 'Schedule Type',
  'common.isActive': 'Is Active',
  'common.isDefault': 'Is Default',
  'common.Monday': 'Monday',
  'employee.terminationDate': 'Termination Date',
  'common.joiningDate': 'Join Date',
  'common.serviceTenure': 'Service Tenure',
  'common.showDetails': 'Show Details',
  'common.designation': 'Designation',
  'common.jobGrade': 'Job Grade',
  'common.notAvailable': 'N/A',
  'common.nextActionBy': 'Next Action By',
  'common.branding_AppName': 'App Name',
  'common.branding_PrimaryColor': 'Primary Color',
  'common.branding_LogoUrl': 'Logo',
  'common.reportLogo': 'Report Logo',
  'common.backDateBuffer': 'Back Date Buffer',
  'common.companyType': 'Company Type',
  'common.noOfLocations': 'No Of Locations',
  'common.companySize': 'Company Size',
  'common.addCompany': 'Add Company',
  'common.editCompany': 'Edit Company',
  'common.Tuesday': 'Tuesday',
  'common.Wednesday': 'Wednesday',
  'common.Thursday': 'Thursday',
  'common.Friday': 'Friday',
  'common.Saturday': 'Saturday',
  'common.Sunday': 'Sunday',
  'common.mon': 'Mon',
  'common.tue': 'Tue',
  'common.wed': 'Wed',
  'common.thu': 'Thu',
  'common.fri': 'Fri',
  'common.sat': 'Sat',
  'common.sun': 'Sun',
  'common.workHours': 'Work Hours',
  'common.day': 'Day',
  'common.flexDuration': 'Flex Duration',
  'common.graceIn': 'Grace In',
  'common.graceOut': 'Grace Out',
  'common.bufferBeforeStartTimeHhMm': 'Buffer Before Start Time (HH:MM)',
  'common.bufferAfterEndTimeHhMm': 'Buffer After End Time (HH:MM)',
  'common.minutes': 'Minutes',
  'common.remainingDuration': 'Remaining Duration',
  'common.update': 'Update',
  'common.updating': 'Updating',
  'common.employees': 'Employees',
  'common.temporary': 'Temporary',
  'common.assign': 'Assign',
  'common.schedules': 'Schedules',
  'common.date': 'Date',
  'common.workdate': 'Work Date',
  'common.fromTime': 'From Time',
  'common.action': 'Action',
  'common.missingReaderTransaction': 'Attendance correction by E-Gate',
  'common.missingInOut': 'Missing In/Out',
  'common.transaction': 'Transaction',
  'common.violation': 'Violation',
  'common.absentPolicy': 'Absent Policy',
  'common.calendar': 'Calendar',
  'calendar.fromLabel': 'From',
  'calendar.toLabel': 'To',
  'calendar.today': 'Today',
  'calendar.yesterday': 'Yesterday',
  'calendar.thisWeek': 'This Week',
  'calendar.lastWeek': 'Last Week',
  'calendar.thisMonth': 'This Month',
  'calendar.lastMonth': 'Last Month',
  'calendar.daysUpToToday': 'days up to today',
  'calendar.daysStartingToday': 'days starting today',
  'common.enabled': 'Enabled',
  'common.type': 'Type',
  'common.reader': 'Reader',
  'common.absent': 'Absent',
  'common.leave': 'Leave',
  'common.late': 'Late',
  'common.earlyOut': 'Early Out',
  'common.offDay': 'Off Day',
  'common.nationality': 'Nationality',
  'common.remarks': 'Remarks',
  'common.employeeName': 'Employee Name',
  'common.employeeId': 'Employee ID',
  'common.code': 'Code',
  'common.transactionType': 'Transaction Type',
  'common.dateTime': 'Date Time',
  'common.exceptionType': 'Exception Type',
  'common.clear': 'Clear',
  'common.clearAll': 'Clear All',
  'common.filters': 'Filters',
  'common.addFilter': 'Add Filter',
  'common.clearFilters': 'Clear Filters',
  'common.dynamicTableColumn': 'Dynamic Table Column',
  'common.applyFilters': 'Apply Filters',
  'common.enableAllColumns': 'Enable All Columns',
  'common.fixToLeft': 'Fix to Left',
  'common.unnamedColumn': 'Unnamed Column',
  'common.descending': 'Descending',
  'common.ascending': 'Ascending',
  'common.sortBy': 'Sort By',
  'common.noData': 'No data',
  'common.noDataAvailable': 'No data available.',
  'common.itemsRange': 'Showing {start} to {end} of {total}',
  'common.showingDataCount': 'Showing {count} of {total} data',
  'common.loadMore': 'Load more',
  'common.selectedOutOf': 'Selected: {selected} out of {total}',
  'common.selected': 'Selected',
  'common.name': 'Name',
  'common.lang': 'Language',
  'common.durationDays': 'Duration Days',
  'common.ok': 'OK',
  'common.cancel': 'Cancel',
  'common.lastUpdatedDate': 'Last Updated Date',
  'common.createdDate': 'Created Date',
  'common.createdOn': 'Created on',
  'common.trackingRequest': 'Tracking Request',
  'common.leaveRequest': 'Leave Request',
  'common.permissionRequest': 'Permission Request',
  'common.remoteWorkRequest': 'Remote Work Request',
  'common.manualEntryRequest': 'Manual Entry Request',
  'common.fromDate': 'From Date',
  'common.toDate': 'To Date',
  'common.timeDuration': 'Duration',
  'common.remark': 'Remark',
  'common.fromYear': 'From Year',
  'common.toYear': 'To Year',
  'common.exportData': 'Export Data',
  'common.subject': 'Subject',
  'common.subjectEn': 'Subject English',
  'common.subjectAr': 'Subject Arabic',
  'common.schedule': 'Schedule',
  'common.dob': 'Date of Birth',
  'common.email': 'Email',
  'common.department': 'Department',
  'common.currentDepartment': 'Current Department',
  'common.userTypeID': 'User Role',
  'common.submissionDate': 'Submission Date',
  'common.active': 'Active',
  'common.inactive': 'Inactive',
  'common.notAvailable': 'NA',
  'common.downloadData': 'Download Data',
  'common.error': 'Error',
  'common.requestFailed': 'Request failed',
  'common.loading': 'Loading...',
  'common.saving': 'Saving...',
  'common.worked': 'Worked',
  'common.remaining': 'Remaining',
  'common.violations': 'Violations',
  'common.delay': 'Delay',
  'common.stepOut': 'Step Out',
  'common.overtime': 'Overtime',
  'common.ongoing': 'Ongoing',
  'common.work': 'Work',
  'common.present': 'Present',
  'common.count': 'Count',
  'common.percentage': 'Percentage',
  'common.date': 'Date',
  'common.showDetails': 'Show Details',
  'common.violation': 'Violations',
  'common.transaction': 'Transactions',
  'common.details': 'Details',
  'common.history': 'History',
  'common.requestName': 'Request Name',
  'common.daysCount': 'Days Count',
  'common.actions': 'Actions',
  'common.first': 'First',
  'common.last': 'Last',
  'common.selectAll': 'Select All',
  'common.itemsPerPage': 'Items per page',
  'dashboard.quickActions.type': 'Type',
  'dashboard.quickActions.from': 'From',
  'dashboard.quickActions.to': 'To',
  'dashboard.quickActions.duration': 'Duration',
  'dashboard.quickActions.action': 'Action',
  'dashboard.quickActions.violations': 'Violations',
  'dashboard.quickActions.transactions': 'Transactions',
  'dashboard.quickActions.inOuts': 'In/Out',
  'dashboard.quickActions.leaves': 'Leaves',
  'dashboard.quickActions.permissions': 'Permissions',
  'dashboard.quickActions.remoteWork': 'Remote Work',
  'dashboard.quickActions.gridView': 'Grid view',
  'dashboard.quickActions.listView': 'List view',
  'dashboard.quickActions.reader': 'Reader',
  'dashboard.quickActions.leaveName': 'Leave Name',
  'dashboard.quickActions.permissionName': 'Permission',
  'dashboard.quickActions.stepOut': 'Step Out',
  'dashboard.quickActions.violation': 'Violation',
  'dashboard.quickActions.earlyOut': 'Early Out',
  'dashboard.quickActions.delay': 'Delay',
  'dashboard.customizeLayout': 'Customize Dashboard Layout',
  'dashboard.customizeLayoutDescription': 'Toggle the switches below to show or hide cards on your dashboard. Your preferences are saved automatically.',
  'dashboard.shiftScheduleBar': 'Shift / Schedule Bar',
  'dashboard.overviewCards': 'Overview Cards',
  'dashboard.attendanceTimeline': 'Attendance Timeline',
  'dashboard.shiftOverview': 'Shift Overview',
  'dashboard.attendanceOverview': 'Attendance overview',
  'dashboard.addonCards': 'Addon cards',
  'dashboard.quickActions': 'Quick Actions',
  'dashboard.attendanceCalendar': 'Attendance Calendar',
  'dashboard.stateSelected': 'Selected',
  'dashboard.stateAllowed': 'Allowed',
  'dashboard.stateDisabled': 'Disabled',
  'dashboard.wfh.title': 'Work From Home (WFH)',
  'dashboard.wfh.subtitle': 'You are approved to work from home today.',
  'dashboard.wfh.approved': 'WFH Approved',
  'dashboard.wfh.validFor': 'Valid for',
  'dashboard.wfh.requestDate': 'Request Date',
  'dashboard.wfh.approvedBy': 'Approved By',
  'dashboard.wfh.validDate': 'Valid Date',
  'dashboard.wfh.clockIn': 'Clock In',
  'dashboard.wfh.clockInSubtitle': 'Start your workday',
  'dashboard.wfh.clockOut': 'Clock Out',
  'dashboard.wfh.clockOutSubtitle': 'End your workday',
  'dashboard.wfh.completedForToday': 'Punch completed for today',
  'dashboard.wfh.punchInSuccess': 'Checked in successfully',
  'dashboard.wfh.punchOutSuccess': 'Checked out successfully',
  'dashboard.wfh.error.invalidPunchType': 'Invalid punch type.',
  'dashboard.wfh.error.punchTodayOnly': 'Punch is allowed for today only.',
  'dashboard.wfh.error.noApprovedRequest': 'No approved remote work request for today.',
  'dashboard.wfh.error.onlinePunchDisabled': 'Online punch in/out is not enabled.',
  'dashboard.wfh.error.noWorkingSchedule': 'No working schedule found for today.',
  'dashboard.wfh.error.outsideSchedule': "Punch time is outside today's schedule.",
  'dashboard.wfh.error.alreadyCheckedIn': 'Check-in already recorded for today.',
  'dashboard.wfh.error.alreadyCheckedOut': 'Check-out already recorded for today.',
  'dashboard.wfh.error.checkOutRequired': 'Already checked in. Check-out is required.',
  'dashboard.wfh.error.checkInRequired': 'Check-in is required before check-out.',
  'dashboard.wfh.error.alreadyCompleted': 'Punch in/out already completed for today.',
  'dashboard.wfh.error.recalcNotConfigured': 'This feature is not fully set up yet. Please contact your administrator.',
  'dashboard.wfh.error.databaseError': 'Something went wrong. Please try again.',
  'dashboard.component': 'Component',
  'appLayout.resetConfiguration': 'Reset Configuration',
  'appLayout.submit': 'Submit',
  'common.trackingEmployeeRequests': 'Tracking Employee Requests',
  'common.stakeholder': 'Stakeholder',
  'common.approved': 'Approved',
  'common.pendingApproval': 'Pending Approval',
  'common.all': 'All',
  'common.pending': 'Pending',
  'common.rejected': 'Rejected',
  'common.requested': 'Requested',
  'common.reject': 'Reject',
  'common.approve': 'Approve',
  'common.items': 'Items',
  'common.page': 'Page',
  'common.of': 'Of',
  'common.selectSupervisor': 'Select Manager',
  'common.leaveType': 'Leave Type',
  'common.limitation': 'Limitation',
  'common.workflow': 'Work Flow',
  "common.workflowFor":"Work Flow For",
  'common.workflowID': 'Work Flow',
  'common.notificationType': 'Notification Type',
  'common.escalateType': 'Escalate',
  'common.gender': 'Gender',
  'common.list': 'List',
  'common.toTargetGroupEmp': 'To Target Group/Emp',
  'common.toAssignType': 'To Assign Type',
  'common.dailyScheduleType': 'Daily Schedule Type',
  'common.scheduleTypeID': 'Daily Schedule Type',
  'common.apply': 'Apply',
  'common.applied': 'Applied',
  'common.hide': 'Hide',
  'common.deleteEntryConfirmMsg': 'Are you sure to delete this record?',
  'common.downloadConfirmMsg': 'Are you sure to download this record?',
  'common.OK': 'Ok',
  'common.cancel': 'Cancel',
  'common.friday': 'Friday',
  'common.saturday': 'Saturday',
  'common.sunday': 'Sunday',
  'common.monday': 'Monday',
  'common.tuesday': 'Tuesday',
  'common.wednesday': 'Wednesday',
  'common.thursday': 'Thursday',
  'common.transactionTime': 'Transaction Time',
  'common. pendingApproval': 'Pending Approval',
  'common.targetEmployees': 'Target Employees',
  'common.location': 'Location',
  'common.locationID': 'Location',
  'common.employeeStatusID': 'Employee Status',
  'common.designationID': 'Designation',
  'common.managerID': 'Manager',
  'common.gradeID': 'Job Grade',
  'common.cardTypeID': 'Card Type',
  'common.reason': 'Reason',
  'common.reasonID': 'Reason',
  'common.serialNumber': 'Serial Number',
  'common.martialStatus': 'Marital Status',
  'common.absentBypolicy': 'Absent By Policy',
  'common.year': 'Year',
  'common.week': 'Week',
  'common.month': 'Month',
  'common.january': 'January',
  'common.february': 'February',
  'common.march': 'March',
  'common.april': 'April',
  'common.may': 'May',
  'common.june': 'June',
  'common.july': 'July',
  'common.august': 'August',
  'common.september': 'September',
  'common.october': 'October',
  'common.november': 'November',
  'common.december': 'December',
  'common.requestStatus': 'Request Status',
  'common.supervisorName': 'Supervisor Name',
  'common.supervisorRemark': 'Supervisor Remark',
  'common.Officialpermissioncomments':
    "* Official permission's comments must have minimum 15 characters",
  'common.minimum': 'Minimum',
  'common.maximum': 'Maximum',
  'common.permissionHoursPerDayIs': 'Permission Hours per days is',
  'common.hoursPerMonth': 'Hours Per Month',
  'common.consumedHours': 'Consumed Hours',
  'common.pendingHours': 'Pending Hours',
  'common.flxi': 'Flxi',
  'common.Hours>=': 'Hour(s) >= (HH:MM)',
  'common.Minutes': 'Minute(s)',
  'common.permission': 'Permissions',
  'common.permissionTypeID': 'Permission Type',
  'common.remainingHours': 'Remaining Hours',
  'common.sn': 'S/N',
  'common.missingIn': 'Missing In',
  'common.missingOut': 'Missing Out',
  'common.exception': 'Exception',
  'common.toMonth': 'To Month',
  'common.fromMonth': 'From Month',
  'common.employeeList': 'Employee List',
  'common.selectedEmployeeList': 'Selected Employee List',
  'common.total': 'Total',
  'common.lastActionBy': 'Last Action By',
  'common.lastActionDate': 'Last Action Date',
  'common.hours': 'hours',
  'common.remoteWork': 'Remote Work',
  'common.checkInConfirm': 'Are you sure you want to check in',
  'common.checkOutConfirm': 'Are you sure you want to check out',
  'common.note': 'Note',
  'common.days': 'Days',
  'common.times': 'Times',
  'common.description': 'Description',
  'common.yearlyRepeated': 'Yearly Repeated',
  'common.doYouWantToProceed': 'Do you want to proceed?',
  'common.sector': 'Sector',
  'common.section': 'Section',
  'common.groupHeader': 'Group',
  'common.shiftHeader': 'Shift',
  'common.isManager': 'IsManager',
  'common.male': 'Male',
  'common.female': 'Female',
  'common.legalAge': 'Legal Age',
  'common.workedDayAnnualNonAnnual':
    'WorkedDays/Annual, Non-Annual, National-Service Leaves',
  'common.quarter': 'Quarter',
  'common.userName': 'Username',
  'common.organizationHierarchy': 'Organization Hierarchy',
  'common.columnName': 'Column Name',
  'common.create': 'Create',
  'common.entityName': 'Entity Name',
  'common.enterKeyword': 'Enter Keyword',
  'common.select': 'Please Select',
  'common.selectDate': 'Select Date',
  'common.selectTime': 'Select Time',
  'common.selectHour': 'Select Hour',
  'common.selectMinute': 'Select Minute',
  'common.selectMonth': 'Select Month',
  'common.selectYear': 'Select Year',
  'common.enableAll': 'Enable All',
  'common.enterEmail': 'Enable Email',
  'common.enterPhone': 'Enable Phone',
  'common.enterUrl': 'Enable URL',
  'common.enterValue': 'Enable Value',
  'common.employeeName': 'Employee Name',
  'common.filter': 'Filter',
  'common.filterby': 'Filter by',
  'common.list-view': 'List View',
  'common.grid-view': 'Grid View',
  'common.calendarView': 'Calendar View',
  'common.noDataFound': 'No Data Found',
  'common.present': 'Present',
  'common.full-request': 'View Full Request',
  'common.ArrowToTop': 'Fix row to top',
  'common.ArrowFromTop': 'Fix row to bottom',
  'common.rowToggle': 'Toggle row details',
  'common.last-updated-on': 'Last Update On',
  'common.reason': 'Reason',
  'common.reasonID': 'Reason',
  'common.cardNo': 'Visitor Card Details',
  'common.attachment': 'Attachment',
  'common.missingDate': 'Missing Date',
  'common.missingCard': 'Missing Card',
  'common.readerIn': 'Reader In',
  'common.readerOut': 'Reader Out',
  'common.phone': 'Phone',
  'common.mobile': 'Mobile',
  'common.mobileNo': 'Mobile',
  'common.position': 'Position',
  'common.reportingManager': 'My Reporting Manager',
  'employee.reportingManager': 'My Reporting Manager',
  'employee.employeeId': 'Employee ID',
  'employee.employee': 'Employee',
  'common.startTime': 'Start Time',
  'common.endTime': 'End Time',
  'common.duration': 'Duration',
  'common.color': 'Color',
  'common.flexDuration': 'Flex Duration',
  'common.flexStartTime': 'Flex Start Time',
  'common.flexEndTime': 'Flex End Time',
  'common.coreStartTime': 'Core Start Time',
  'common.coreEndTime': 'Core End Time',
  'common.workscheduletype': 'Work Schedule Type',
  'common.flexStartTime': 'Flex Start Time',
  'common.flexEndTime': 'Flex End Time',
  'common.coreStartTime': 'Core Start Time',
  'common.coreEndTime': 'Core End Time',
  'common.workscheduletype': 'Work Schedule Type',
  'common.shiftNameEn': 'Shift Name English',
  'common.shiftNameAr': 'Shift Name Arabic',
  'common.timeTable': 'Time Table',
  'common.unit': 'Unit',
  'common.cycle': 'Cycle',
  'common.autoShift': 'Auto Shift',
  'common.scheduleDuration': 'Duration',
  'common.minMonthlyDuration': 'Min Monthly Duration',
  'common.minWeeklyDuration': 'Min Weekly Duration',
  'common.pleaseSelectAtLeastOneRecordToDelete':
    'Please select at least one record to delete.',
  'common.deleteConfirmMessage':
    'Are you sure you want to delete {count} record(s)?',
  'common.deleteConfirmWithName': 'Are you sure you want to delete {name} ?',
  'common.deleteVerifyMessage':
    'Do you really want to delete these records?<br />This process cannot be undone.',
  'common.deleteConfirmTitle': 'Are you Sure ?',
  'common.confirmation': 'Confirmation',
  'common.areYouSure': 'Are you sure?',
  'common.confirmAction': 'Are you sure you want to perform this action?',
  'common.exportPdf': 'Export PDF',
  'common.exportExcel': 'Export Excel',
  'common.importData': 'Import Data',
  'common.allItemsWillBeExportedToPdf': 'All items will be exported to PDF.',
  'common.allItemsWillBeExportedToCsv': 'All items will be exported to .csv',
  'common.allItemsWillBeImported': 'All items will be Imported.',
  'common.itemsWillBeDownloaded': '{count} items will be downloaded.',
  'common.itemsWillBeCopied': '{count} item will be Copied.',
  'common.downloadConfirmMessage': 'Are you sure you want to download {count} record(s)?',
  'common.recordDeletedSuccessfully': 'Record deleted successfully.',
  'common.recordsDeletedSuccessfully': 'Records deleted successfully.',
  'success.deleteTitle': 'Success',
  'success.recordsDeleted': 'Records deleted successfully.',
  'common.unsavedChangesTitle': 'Unsaved Changes',
  'common.unsavedChangesBody': 'You have unsaved edits. Do you want to discard them?',
  'common.basicSettings': 'Basic Settings',
  'common.breakTimeSettings': 'Break Time Settings',
  'common.overtimeRule': 'Overtime Rule',
  'common.stepOutCon': 'Step out Rule',
  'common.permissionCon': 'Permission Rule',
  'common.policySettings': 'Absent Rule',
  'common.taPolicy': 'TA Policy',
  'common.maxStepOutDuration': 'Max Step Out Duration',
  'common.numOutAttempts': 'Number of Out Attempts',
  'common.minDurApply': 'Required Minimum Duration to apply',
  'common.maxDurApply': 'Allowed Maximum Duration to apply',
  'common.minWorkingHoursApply': 'Required Minimum Working Hours to apply',
  'common.workingHourLess': 'Working hours less than',
  'common.punchInAfter': 'Puch in After',
  'common.lastPunchOutBefore': 'Last Punch out before',
  'common.stepOutCon': 'Step out Rule',
  'common.permissionCon': 'Permission Rule',
  'common.absentRule': 'Absent Rule',
  'common.taPolicy': 'TA Policy',
  'common.afterSchedule': 'Calculate After Schedule',
  'common.overtimeUntil': 'Calculate Overtime Until',
  'common.beforeSchedule': 'Calculate Before Schedule',
  'common.overtimeBefore': 'Calculate Overtime Before',
  'common.maxStepOutDuration': 'Max Step Out Duration',
  'common.numOutAttempts': 'Number of Out Attempts',
  'common.priority': 'Give priority for',
  'common.workedHours': 'Consider as Worked Hours',
  'common.considerAsAbsent' :'Consider as Absent',
  'common.pleaseSelectValueForEnabledFields': 'Please select value for enabled fields',
  'pleaseSelectValueForEnabledFields': 'Please select value for enabled fields',
  'common.updateFailed': 'Update failed',

  'common.minDurApply': 'Required Minimum Duration to apply',
  'common.maxDurApply': 'Allowed Maximum Duration to apply',
  'common.minWorkingHoursApply': 'Required Minimum Working Hours to apply',
  'common.workingHourLess': 'Working hours less than',
  'common.punchInAfter': 'Puch in After',
  'common.lastPunchOutBefore': 'Last Punch out before',
  'common.groupType': 'Group Type',
  'common.employeeID' : 'Employee ID',
  'common.firstName' : 'First Name',
  'common.lastName' : 'Last Name',
  'common.date' : 'Date',
  'common.checkIn' : 'Check In',
  'common.checkOut' : 'Check Out',

  'common.fullCalendarView' : 'Full Calendar View',
  'common.searchEmployee' : 'Search Employee',
  'common.employeeListLabel': 'Employee List',
  'common.departmentListLabel': 'Department List',
  'common.entityListLabel': 'Entity List',
  'common.locationListLabel': 'Location List',
  'common.groupListLabel': 'Group List',
  'common.employeeList': 'Select the Employee',
  'common.pleaseSSearchTheTimeTable': 'Please Select Shift Pattern',
  'common.justification': 'Justification',
  'common.approval level': 'Approval Level',
  'common.purpose': 'Purpose',
  'common.notification': 'Notification Type',
  'common.yes': 'Yes',
  'common.selectColumn':'Select Column',
  'common.form':'Form',
  'common.for': 'for',
  'common.selectOperation':'Select Operation',
  'common.no': 'No',
  'common.true': 'True',
  'common.false': 'False',
  'common.escalate': 'Escalate',
  'common.afterDays':'After Days',
  'common.restDay':'Rest Day',
  'common.saving':'Saving...',
  'common.shiftPattern':'Shift Pattern',
  'common.halfCalendar':'Half Calendar View',
  'common.fullCalendar':'Full Calendar View',
  'common.selectGroup': 'Select Group',
  'common.selectLocation': 'Select Location',
  'common.selectEntity': 'Select Entity',

  'recalculateAttendance.error.dateRangeOverlap':
    'Date range overlaps with an existing recalculation action.',

  // Dashboard
  'dashboard.attendanceTimeline.title': 'Attendance Timeline',
  'dashboard.attendanceTimeline.subtitle': 'Dynamic scale – minute accurate',
  'dashboard.dailyOverview.title': 'Shift Overview',
  'dashboard.dailyOverview.groupPlanned': 'Planned',
  'dashboard.dailyOverview.groupActual': 'Actual',
  'dashboard.workday.goodMorning': 'Good morning',
  'dashboard.workday.goodAfternoon': 'Good afternoon',
  'dashboard.workday.goodEvening': 'Good evening',
  'dashboard.workday.title': 'My workday',
  'dashboard.workday.working': 'Working',
  'dashboard.workday.since': 'since',
  'dashboard.workday.completed': 'Completed',
  'dashboard.workday.shift': 'Shift',
  'dashboard.workday.flex': 'Flex',
  'dashboard.workday.remaining': 'Remaining',
  'dashboard.workday.workedToday': 'Worked',
  'dashboard.workday.headWorking': 'You\'re currently working',
  'dashboard.workday.headCompleted': 'Your workday is complete',
  'dashboard.workday.headNotIn': 'You haven\'t checked in yet',
  'dashboard.workday.headMissed': 'No attendance recorded',
  'dashboard.workday.headUpcoming': 'Upcoming shift',
  'dashboard.workday.headOff': 'Rest day',
  'dashboard.workday.headHoliday': 'Holiday',
  'dashboard.workday.headLeave': 'On leave',
  'dashboard.workday.flexOpens': 'Flex opens',
  'dashboard.workday.shiftStart': 'Shift start',
  'dashboard.workday.shiftEnd': 'Shift end',
  'dashboard.workday.flexCloses': 'Flex closes',
  'dashboard.workday.onTime': 'On time',
  'dashboard.workday.violationToday': 'Violation today',
  'dashboard.workday.noViolations': 'No violations',
  'dashboard.myAttendance.title': 'My attendance',
  'dashboard.myAttendance.attendance': 'attendance',
  'dashboard.myAttendance.onTrack': 'On track',
  'dashboard.myAttendance.needsAttention': 'Needs attention',
  'dashboard.myAttendance.atRisk': 'At risk',
  'dashboard.myAttendance.noDataYet': 'No data yet',
  'dashboard.myAttendance.noScheduledDays': 'No scheduled days recorded for this month yet.',
  'dashboard.myAttendance.attended': 'Attended',
  'dashboard.myAttendance.of': 'of',
  'dashboard.myAttendance.scheduledDays': 'scheduled days',
  'dashboard.myAttendance.soFar': 'so far this month',
  'dashboard.myAttendance.days': 'days',
  'dashboard.myAttendance.daysPresent': 'Days present',
  'dashboard.myAttendance.daysAbsent': 'Days absent',
  'dashboard.myAttendance.delaysViolations': 'Delays & violations',
  'dashboard.myAttendance.leaveDays': 'Leave days',
  'dashboard.myAttendance.remoteWork': 'Remote work',
  'dashboard.myAttendance.last6Months': 'Last 6 months',
  'dashboard.myAttendance.absences': 'Absences',
  'dashboard.myAttendance.absentDays': 'absent day(s)',
  'dashboard.myAttendance.pattern': 'Pattern',
  'dashboard.myAttendance.violationDays': 'day(s) with a delay, early out or violation this month',
  'dashboard.myAttendance.allGood': 'No absences, delays or early outs this month.',
  'dashboard.scheduleShiftBar.today': 'Today',
  'dashboard.scheduleShiftBar.thisWeek': 'This week',
  'dashboard.scheduleShiftBar.core': 'Core',
  'dashboard.scheduleShiftBar.total': 'Total',
  'dashboard.scheduleShiftBar.coreIn': 'core in',
  'dashboard.scheduleShiftBar.flexOpen': 'Flex time',
  'dashboard.scheduleShiftBar.inProgress': 'In progress',
  'dashboard.scheduleShiftBar.left': 'left',
  'dashboard.scheduleShiftBar.startsIn': 'Starts in',
  'dashboard.scheduleShiftBar.ended': 'Ended',
  'dashboard.scheduleShiftBar.upcoming': 'Upcoming',
  'dashboard.scheduleShiftBar.dayOff': 'Day off',
  'dashboard.scheduleShiftBar.noShiftTitle': 'No shift scheduled',
  'dashboard.scheduleShiftBar.noShiftText': 'Enjoy your day - nothing to check in for.',
  'dashboard.workday.noPunches': 'No punches recorded for this day yet',
  'dashboard.workday.outSince': 'Out since',
  'dashboard.workday.totalViolations': 'Total violations',
  'dashboard.workday.lateArrival': 'Late arrival',
  'dashboard.workday.onShift': 'On shift',
  'dashboard.workday.none': 'None',
  'dashboard.workday.break': 'Break',
  'dashboard.workday.nextShift': 'Next shift',
  'dashboard.workday.noDataYet': 'No data yet',
  'dashboard.workday.of': 'of',
  'dashboard.workday.now': 'Now',
  'dashboard.dailyOverview.groupAttendance': 'Attendance',
  'dashboard.dailyOverview.checkedIn': 'Checked in',
  'dashboard.dailyOverview.notCheckedIn': 'Not checked in yet',
  'dashboard.dailyOverview.worked': 'Worked',
  'dashboard.dailyOverview.shiftLength': 'Shift',
  'dashboard.dailyOverview.groupExceptions': 'Delays & Violations',
  'dashboard.dailyOverview.noShift': 'No shift scheduled for this date',
  'dashboard.dailyOverview.selectedDateStatus': 'Selected Schedule Status',
  'dashboard.dailyOverview.dayStatus': 'Shift Status',
  'dashboard.dailyOverview.shiftDate': 'Shift Date',
  'dashboard.dailyOverview.firstIn': 'First In',
  'dashboard.dailyOverview.lastOut': 'Last Out',
  'dashboard.dailyOverview.expectedOut': 'Expected Out',
  'dashboard.dailyOverview.delay': 'Delay',
  'dashboard.dailyOverview.earlyOut': 'Early Out',
  'dashboard.dailyOverview.violation': 'Violation',
  'dashboard.dailyOverview.actualWorkDuration': 'Actual Work Duration',
  'dashboard.dailyOverview.coreStartTime': 'Core Start Time',
  'dashboard.dailyOverview.coreEndTime': 'Core End Time',
  'dashboard.dailyOverview.flexStartTime': 'Flex Start Time',
  'dashboard.dailyOverview.flexEndTime': 'Flex End Time',
  'dashboard.dailyOverview.timeTable': 'Shift Pattern',
  'dashboard.dailyOverview.shiftTimesTitle': 'Shift Time',
  'dashboard.dailyOverview.core': 'Core',
  'dashboard.dailyOverview.flex': 'Flex',
  'dashboard.dailyOverview.coreShiftInOut': 'Core shift in/out',
  'dashboard.dailyOverview.flexShiftInOut': 'Flex shift in/out',
  'dashboard.scheduleShiftBar.shiftsScheduled': 'Shifts Scheduled',
  'dashboard.attendanceOverview.title': 'Attendance Overview',
  'dashboard.attendanceOverview.downloadTooltip': 'Download chart as PDF',
  'dashboard.attendanceOverview.noData': 'No data',
  'dashboard.calendar.title': 'Attendance Calendar',
  'dashboard.employeeCalendar.title': 'Employee Calendar',
  'dashboard.employeeCalendar.chips.present': 'Present',
  'dashboard.employeeCalendar.chips.absent': 'Absent',
  'dashboard.employeeCalendar.chips.absentBefore': 'Absent Before',
  'dashboard.employeeCalendar.chips.absentAfter': 'Absent After',
  'dashboard.employeeCalendar.chips.violation': 'Violation',
  'dashboard.employeeCalendar.chips.delay': 'Delay',
  'dashboard.employeeCalendar.chips.earlyOut': 'Early Out',
  'dashboard.employeeCalendar.chips.remoteWork': 'Remote Work',
  'dashboard.employeeCalendar.chips.leave': 'Leave',
  'dashboard.employeeCalendar.chips.holidays': 'Holidays',
  'dashboard.employeeCalendar.chips.restday': 'Restday',
  'dashboard.employeeCalendar.chips.permission': 'Permission',

  'dashboard.employeeCalendar.tabs.month': 'Month',
  'dashboard.employeeCalendar.tabs.week': 'Week',
  'dashboard.employeeCalendar.tabs.day': 'Day',
  'dashboard.calendar.applyLeave': 'Apply Leave',
  'dashboard.calendar.applyPermission': 'Apply Permission',
  'dashboard.calendar.applyRemoteRequest': 'Apply Remote Request',
  'dashboard.quickActions.violations': 'Violations',
  'roleAccessRemoved.title': 'Role Access Removed',
  'roleAccessRemoved.message': 'Your role access is no longer available. You will be logged out in {seconds} seconds.',
  'dashboard.quickActions.transactions': 'Transactions',
  'dashboard.quickActions.leaves': 'Leaves',
  'dashboard.quickActions.permissions': 'Permissions',
  'dashboard.quickActions.remoteWork': 'Remote Work',
  'dashboard.quickActions.gridView': 'Grid view',
  'dashboard.quickActions.listView': 'List view',
  'dashboard.addons.showDetails': 'Show Details',
  'dashboard.addons.details': 'Addon Details',
  'dashboard.addons.detailsPlaceholder': 'Details are not available.',
  'dashboard.addons.addMore': 'Add More',
  'dashboard.addons.addAddon': 'Add Addon',
  'dashboard.addons.leaveBalance': 'Leave Balance',
  'dashboard.addons.annualleavebalance': 'Annual Leave Balance',
  'dashboard.addons.sickleavebalance': 'Sick Leave Balance',
  'dashboard.addons.sickBalance': 'Sick Balance',
  'dashboard.addons.totalpermission': 'Total Permissions',
  'dashboard.addons.totalviolation': 'Total Violations',
  'dashboard.addons.totalremoteworkrequest': 'Total Remote Work Requests',
  'dashboard.addons.totalpendingremoteworkrequest': 'Total Pending Remote Work Requests',
  'dashboard.addons.totalleaverequest': 'Total Leave Requests',
  'dashboard.addons.totaldelay': 'Total Delay',
  'dashboard.addons.totalearlyout': 'Total Early Out',
  'dashboard.addons.totalViolationDays': 'Total Violation Days',
  'dashboard.addons.totalLeaveDays': 'Total Leave Days',
  'dashboard.addons.totalAbsentDays': 'Total Absent Days',
  'dashboard.addons.leavebalance': 'Leave Balance',
  'dashboard.addons.sickbalance': 'Sick Balance',
  'dashboard.addons.totalviolationdays': 'Total Violation Days',
  'dashboard.addons.totalleavedays': 'Total Leave Days',
  'dashboard.addons.totalabsentdays': 'Total Absent Days',
  'dashboard.addons.updateFailed': 'Failed to update addon',
  'dashboard.addons.updateSuccess': 'Dashboard addons updated successfully',
  'dashboard.loadingCalendar': 'Loading calendar data...',
  'dashboard.noData': 'No data available',
  'dashboard.status.active': 'Active',
  'dashboard.status.absent': 'Absent',
  'dashboard.status.outOfOffice': 'Out of office',
  'dashboard.status.remoteWork': 'Remote Work',
  'dashboard.status.onLeave': 'On Leave',
  'dashboard.status.present': 'Present',
  'dashboard.status.holiday': 'Holiday',
  'dashboard.status.violations': 'Violations',
  'dashboard.status.violation': 'Violation',
  'dashboard.status.off': 'OFF',
  'dashboard.status.inactive': 'Inactive',
  'dashboard.dailyStatus.title': 'Selected Schedule Status',
  'dashboard.dailyStatus.clickForDetails': 'Click here for more details',

  'dashboard.hr.employeeCountOverview.employeeDetailsTitle': 'Employee Details',
  'dashboard.hr.employeeCountOverview.showDetails': 'Show Details',
  'dashboard.hr.employeeCountOverview.status.present': 'Present',
  'dashboard.hr.employeeCountOverview.status.presentNoViolation': 'Present (No Violation)',
  'dashboard.hr.employeeCountOverview.status.absent': 'Absent',
  'dashboard.hr.employeeCountOverview.status.leave': 'Leave',
  'dashboard.hr.employeeCountOverview.status.delay': 'Delay',
  'dashboard.hr.employeeCountOverview.status.ontime': 'Ontime',
  'dashboard.hr.employeeCountOverview.status.remote': 'Remote Work',
  'dashboard.hr.employeeCountOverview.status.earlyOut': 'Early Out',
  'dashboard.hr.employeeCountOverview.status.violation': 'Violation',
  'dashboard.hr.employeeCountOverview.status.holiday': 'Holiday',
  'dashboard.hr.employeeCountOverview.status.restDay': 'Rest Day',
  'dashboard.hr.employeeCountOverview.status.permission': 'Permission',
  'dashboard.hr.overallStatistics.title': 'Overall Statistics',
  'dashboard.hr.weeklyAttendanceStatistics.title': 'Attendance Statistics',
  'dashboard.hr.todayPunchStatistics.title': 'Punch Statistics',
  'dashboard.hr.todayPunchStatistics.tooltipTitle': 'Summary',
  'dashboard.hr.todayPunchStatistics.labels.punchOut': 'Punch Out',
  'dashboard.hr.todayPunchStatistics.labels.present': 'Present',
  'dashboard.hr.todayPunchStatistics.labels.wfh': 'WFH',
  'dashboard.hr.todayPunchStatistics.labels.leave': 'Leave',
  'dashboard.hr.todayPunchStatistics.labels.absent': 'Absent',
  'dashboard.hr.todayPunchStatistics.labels.exception': 'Exception',
  'dashboard.hr.todayPermissionStatistics.title': 'Permission Statistics',
  'dashboard.hr.leaveStatistics.title': 'Leave Statistics',
  'dashboard.hr.leaveStatistics.description': 'Overview of leave requests by status.',
  'dashboard.hr.leaveStatistics.labels.approved': 'Approved',
  'dashboard.hr.leaveStatistics.labels.requested': 'Requested',
  'dashboard.hr.leaveStatistics.labels.pending': 'Pending',
  'dashboard.hr.punchInOutStatistics.title': 'Punch In/Out Statistics',
  'dashboard.hr.punchInOutStatistics.description': 'Overview of employees first-in and last-out records.',
  'dashboard.hr.punchInOutStatistics.labels.firstIn': 'Employee In',
  'dashboard.hr.punchInOutStatistics.labels.lastOut': 'Employee Out',
  'dashboard.hr.title': 'HR Dashboard',
  'dashboard.hr.calendar.showCalendar': 'Full Calendar View',
  'dashboard.hr.calendar.closeCalendar': 'Close Calendar',
  'dashboard.hr.calendar.filterProcess': 'FILTER PROCESS',
  'dashboard.hr.calendar.details': 'Details',
  'dashboard.hr.calendar.workLocation': 'Work Location',
  'dashboard.hr.calendar.group': 'Group',
  'dashboard.hr.calendar.entity': 'Entity',
  'dashboard.hr.employeeDetails.columns.employeeName': 'Employee Name',
  'dashboard.hr.employeeDetails.columns.workDate': 'Work Date',
  'dashboard.hr.employeeDetails.columns.employeeNo': 'Employee Number',

  'dashboard.absenteeism.overview.title': 'Absenteeism Overview (Executive / HR Head)',
  'dashboard.absenteeism.overview.subtitle': 'Monitor absenteeism KPIs, trends, and department performance using the latest attendance insights.',
  'dashboard.absenteeism.filters.targetGroupLabel': 'Absenteeism target filter',
  'dashboard.absenteeism.filters.entity': 'Entity',
  'dashboard.absenteeism.filters.location': 'Location',
  'dashboard.absenteeism.filters.from': 'From',
  'dashboard.absenteeism.filters.to': 'To',

  'dashboard.absenteeism.kpi.absenteeismRate': 'Absenteeism Rate (%)',
  'dashboard.absenteeism.kpi.totalAbsentDays': 'Total Absent Days',
  'dashboard.absenteeism.kpi.violations': 'Violations',
  'dashboard.absenteeism.kpi.avgAbsencePerEmployee': 'Avg Absence / Employee',
  'dashboard.absenteeism.kpi.policyVsActualGap': 'Policy vs Actual Gap',
  'dashboard.absenteeism.kpi.actualAbsentDays': 'Actual Absence Days',
  'dashboard.absenteeism.kpi.policyAbsentDays': 'Policy Absence Days',
  'dashboard.absenteeism.kpi.lateArrivalCount': 'Late Arrival Count',
  'dashboard.absenteeism.kpi.earlyDepartureCount': 'Early Departure Count',
  'dashboard.absenteeism.kpi.totalAttendanceViolations': 'Total Attendance Violations',

  'dashboard.absenteeism.kpiTooltips.absenceRate':
    'Overall absenteeism percentage during the selected period, excluding non-working days. Indicates workforce attendance health and productivity risk.',
  'dashboard.absenteeism.kpiTooltips.totalAbsenceDays':
    'Total lost working days due to employee absence during the selected period.',
  'dashboard.absenteeism.kpiTooltips.actualAbsenceDays':
    'Unplanned or direct absence days that may impact operational continuity.',
  'dashboard.absenteeism.kpiTooltips.policyAbsenceDays':
    'Absence days recorded under company policy rules or structured exceptions.',
  'dashboard.absenteeism.kpiTooltips.averageAbsencePerEmployee':
    'Average number of absence days per employee. Helps assess workforce performance trends.',
  'dashboard.absenteeism.kpiTooltips.lateArrivalCount':
    'Total instances of late arrivals. Reflects punctuality discipline and time management efficiency.',
  'dashboard.absenteeism.kpiTooltips.earlyDepartureCount':
    'Total instances of early departures before scheduled working hours.',
  'dashboard.absenteeism.kpiTooltips.totalAttendanceViolations':
    'Combined count of all attendance-related violations (late arrivals, early departures, and policy breaches). Indicates overall compliance with attendance standards.',
  'dashboard.absenteeism.kpi.daysSuffix': ' days',
  'dashboard.absenteeism.kpi.totalAbsentDays.subLabel': '{actual} Actual / {policy} Policy',
  'dashboard.absenteeism.kpi.violations.subLabel': '{delay} Delay / {earlyOut} Early Out',
  'dashboard.absenteeism.kpi.policyVsActualGap.subLabel': 'Positive indicates spare capacity',

  'dashboard.absenteeism.charts.trend.title': 'Absenteeism Trend (Line Chart)',
  'dashboard.absenteeism.charts.absenceByType.title': 'Absence by Type (Donut)',
  'dashboard.absenteeism.charts.topDepartments.title': 'Top Departments by Absence Rate',
  'dashboard.absenteeism.charts.departmentAbsenceRate.title': 'Absence Rate by Department',
  'dashboard.absenteeism.charts.managerAbsenceRate.title': 'Absence Rate by Manager',
  'dashboard.absenteeism.charts.heatmap.title': 'Department vs Day of Week (Heatmap)',
  'dashboard.absenteeism.charts.shiftWiseComparison.title': 'Shift-wise Absence Comparison',
  'dashboard.absenteeism.charts.dayOfWeekPattern.title': 'Day of Week Absence Pattern',
  'dashboard.absenteeism.charts.prePostHoliday.title': 'Pre/Post Holiday Absence',
  'dashboard.absenteeism.charts.highRiskCount.title': 'High-Risk Employee Count',
  'dashboard.absenteeism.charts.repeatAbsenteesTrend.title': 'Trend of Repeat Absentees',
  'dashboard.absenteeism.risk.title': 'Absence Pattern & Risk Dashboard',

  'dashboard.absenteeism.series.currentYear': 'Current Year',
  'dashboard.absenteeism.series.previousYear': 'Previous Year',
  'dashboard.absenteeism.series.absenceRate': 'Absence Rate',
  'dashboard.absenteeism.series.absencePercent': 'Absence %',
  'dashboard.absenteeism.series.absences': 'Absences',
  'dashboard.absenteeism.series.employees': 'Employees',
  'dashboard.absenteeism.series.repeatAbsentees': 'Repeat Absentees',

  'dashboard.absenteeism.empty.noData': 'No data available',
  'dashboard.absenteeism.empty.noKpi': 'No KPI data available',
  'dashboard.absenteeism.empty.noTrend': 'No trend data for selected filters',
  'dashboard.absenteeism.empty.noTypeBreakdown': 'Absence types breakdown unavailable',
  'dashboard.absenteeism.empty.noDepartmentRate': 'Department absence rate unavailable',
  'dashboard.absenteeism.empty.noDepartmentRateData': 'No department rate data available',
  'dashboard.absenteeism.empty.noManagerRateData': 'No manager rate data available',
  'dashboard.absenteeism.empty.noHeatmap': 'No heatmap data available',
  'dashboard.absenteeism.empty.noRepeatMonthly': 'No repeat absentee data available',

  'dashboard.absenteeism.fallback.metric': 'Metric',
  'dashboard.absenteeism.fallback.month': 'Month {number}',
  'dashboard.absenteeism.fallback.type': 'Type {number}',
  'dashboard.absenteeism.fallback.department': 'Department {number}',

  'dashboard.absenteeism.holiday': 'Holiday',
  'dashboard.absenteeism.days.sun': 'Sun',
  'dashboard.absenteeism.days.mon': 'Mon',
  'dashboard.absenteeism.days.tue': 'Tue',
  'dashboard.absenteeism.days.wed': 'Wed',
  'dashboard.absenteeism.days.thu': 'Thu',
  'dashboard.absenteeism.days.fri': 'Fri',
  'dashboard.absenteeism.days.sat': 'Sat',

  'dashboard.absenteeism.months.jan': 'Jan',
  'dashboard.absenteeism.months.feb': 'Feb',
  'dashboard.absenteeism.months.mar': 'Mar',
  'dashboard.absenteeism.months.apr': 'Apr',
  'dashboard.absenteeism.months.may': 'May',
  'dashboard.absenteeism.months.jun': 'Jun',
  'dashboard.absenteeism.months.jul': 'Jul',
  'dashboard.absenteeism.months.aug': 'Aug',
  'dashboard.absenteeism.months.sep': 'Sep',
  'dashboard.absenteeism.months.oct': 'Oct',
  'dashboard.absenteeism.months.nov': 'Nov',
  'dashboard.absenteeism.months.dec': 'Dec',

  'dashboard.absenteeism.riskLevels.chronic': 'Chronic',
  'dashboard.absenteeism.riskLevels.atRisk': 'At Risk',
  'dashboard.absenteeism.riskLevels.normal': 'Normal',

  'dashboard.absenteeism.fallback.manager': 'Manager {number}',
  'dashboard.absenteeism.fallback.status': 'Status {number}',

  'dashboard.absenteeism.drilldown.modalTitle': 'Absence Drilldown',
  'dashboard.absenteeism.drilldown.titleWithSource': '{source}',
  'dashboard.absenteeism.drilldown.tableTitle': 'Employee Absence Table',
  'dashboard.absenteeism.drilldown.sectionTitle': 'Absence Drilldown (HR Operations)',
  'dashboard.absenteeism.drilldown.columns.id': 'ID',
  'dashboard.absenteeism.drilldown.columns.name': 'Name',
  'dashboard.absenteeism.drilldown.columns.department': 'Department',
  'dashboard.absenteeism.drilldown.columns.totalDays': 'Total Days',
  'dashboard.absenteeism.drilldown.columns.unauthorized': 'Unauthorized',
  'dashboard.absenteeism.drilldown.columns.consecutive': 'Consecutive',
  'dashboard.absenteeism.drilldown.columns.lastAbsence': 'Last Absence',
  'dashboard.absenteeism.drilldown.columns.pattern': 'Pattern',

  'dashboard.absenteeism.hrbp.title': 'Department Analysis (HRBP)',
  'dashboard.absenteeism.drilldown.sources.trend': 'Absenteeism Trend',
  'dashboard.absenteeism.drilldown.sources.type': 'Absence by Type',
  'dashboard.absenteeism.drilldown.sources.topDepartments': 'Top Departments by Absence Rate',
  'dashboard.absenteeism.drilldown.sources.departmentRate': 'Absence Rate by Department',
  'dashboard.absenteeism.drilldown.sources.managerRate': 'Absence Rate by Manager',
  'dashboard.absenteeism.drilldown.sources.heatmap': 'Department vs Day of Week (Heatmap)',
  'dashboard.absenteeism.drilldown.sources.shiftWise': 'Shift-wise Absence Comparison',
  'dashboard.absenteeism.drilldown.sources.dayOfWeek': 'Day of Week Absence Pattern',
  'dashboard.absenteeism.drilldown.sources.prePostHoliday': 'Pre/Post Holiday Absence',
  'dashboard.absenteeism.drilldown.sources.highRisk': 'High-Risk Employee Count',
  'dashboard.absenteeism.drilldown.sources.repeatTrend': 'Trend of Repeat Absentees',

  'workflow.rejectionReason': 'Rejection Reason',

  'error.isRequired': 'is required',
  'error.required': 'Required',
  'error.validPositiveNumber':'Enter a valid positive number',
  'error.enterAValid': 'Enter a valid',
  'error.enterAValidFormat': 'Enter a valid format',
  'error.enterThe': 'Enter the',
  'error.enterA': 'Enter a',
  'error.save_failed': 'Save failed',
  'error.textValidation': 'Please enter at least 2 characters',
  'error.notificationTextValidation': 'Please enter at least 2 characters',
  'error.codeValidation': 'Please enter at least 1 characters',
  'error.fromDateGreater': 'From date cannot be greater than To date',
  'error.toDateLess': 'To date cannot be less than From date',
  'error.toDateGreaterThanFromDate': 'To Date cannot be earlier than From Date',
  'error.selectAtLeastOneEmployee': 'Please select at least one employee',
  'error.selectAtLeastOneDepartment': 'Please select at least one department',
  'error.selectAtLeastOneLocation': 'Please select at least one location',
  'error.selectAtLeastOneGroup': 'Please select at least one group',
  'error.selectDepartment': 'Department is required',
  'error.selectLocation': 'Location is required',
  'error.selectGroup': 'Group is required',
  'error.fillRequiredFields': 'Please fill all required fields',
  'error.recordAlreadyExists': 'Record already exists',
  'error.unableToUpdateAssignShift': 'Unable to update assign shift',
  'error.unableToCreateAssignShift': 'Unable to create assign shift',
  'error.updateFailed': 'Update failed',
  'error.createFailed': 'Create failed',
  'error.saveFailed': 'Save failed',
  'error.toTimeMustBeGreaterThanFromTime':'To Time must be greater than From Time',
  'error.ProbationPeriodDateNotLessThanJoiningDate':
    'Probation Period Date should not be less than Joining Date.',
  'error.TerminatedDateNotLessThanJoiningDate':
    'Terminated Date should not be less than Joining Date.',
  'error.invalidEmiratesIDFormat': 'Invalid Emirates ID format.',
  'error.endDateGraterThanStartDate':
    'End time cannot be earlier than start time',
  'error.selectValidDateRange': 'Please select valid date range',
  'error.selectValidMonthAndYear': 'Please select valid month and year',
  'error.yearIsAlreadyExist': 'Year is Already Exist',
  'error.arabicValidation': 'Only Arabic letters are allowed, minimum 3 characters',
  'error.selectValidTime': 'Please enter a valid time in HH:MM format',
  'error.invalidTime': 'Time cannot be 00:00',
  'error.provideStartTime': 'Please provide start time',
  'error.provideEndTime': 'Please provide end time',
  'error.durationMustBePositive': 'Duration must be greater than 0 minutes',
  'error.provideStartEndTime': 'Please provide both start and end time',
  'error.durationExceedsRange': 'cannot exceed the time between start and end',
  'error.invalidNumber': 'Plaese Enter a Valid number',
  'error.joiningDateCannotBeInTheFuture': 'Joining date cannot be in the future.',
  'error.invalidTerminationDateFormat': 'Invalid termination date format.',
  'error.ramadanPeriodRangeTooShort': 'Select date between 29 to 31 day. Selected range is {diffDays} days ({lessBy} days less).',
  'error.ramadanPeriodRangeTooLong': 'Select date between 29 to 31 day. Selected range is {diffDays} days ({moreBy} days more).',
  'error.overlapDateRange': 'The selected date range overlaps with an existing record.',
  'error.ramadanPeriodInvalidDurationOrOverlap':
    'The Ramadan period must be between 29 and 31 days and must not overlap with or be too close to an existing Ramadan period.',
  'error.holidayPeriodDuplicateOrOverlap':
    'Another active period exists with the same Arabic name, English name, code, or an overlapping date range for this company.',
  'error.activeEmployeeAlreadyExists':
    'An active employee with the same employee number or email already exists for this company.',
  'error.failedToLoadDataTryAgain': 'Failed to load data. Please try again.',
  'error.saveOperationFailed': 'Save operation failed',
  'employee.unableToSaveEmployee': 'Unable to save employee',
  'error.duplicateWithFieldsPrefix': 'A record with the same',
  'error.duplicateWithFieldsSuffix': 'already exists.',
  'error.recordMayAlreadyExistOrInvalid': 'An error occurred. The record may already exist or the data is invalid.',
  'error.failedToFetchData': 'Failed to fetch data',
  'error.failedToLoad': 'Failed to load {page}',
  'lookup.saveErrorTitle': 'Unable to save {lookup}',
  'lookup.saveErrorMessage': 'Unable to save {lookup}. Please try again.',
  'lookup.userRole.error.defaultAlreadyExists': 'Only one active default User Role is allowed. Please unset the current default and try again.',
  'error.unableToFetchTryAgain': 'Unable to fetch {page}. Please try again.',
  'error.sorrySomethingWentWrong': 'Sorry, something went wrong',
  'error.couldNotConnectTryAgainLater': "We couldn't connect to the server. Please try again later.",
  'error.failedToDeleteRecordsTitle': 'Failed to delete records',
  'error.errorOccurredWhileDeletingRecord': 'An error occurred while deleting the record.',
  'error.errorOccurredWhileDeletingRecords': 'An error occurred while deleting the records.',
  'error.failedToDownloadRecordsTitle': 'Failed to download records',
  'error.errorOccurredWhilePreparingDownload': 'An error occurred while preparing the download.',
  // Employee assignment errors
  'error.assignmentLoadTitle': 'Failed to load assignments',
  'error.assignmentLoadMessage': 'Unable to fetch assignments. Please try again.',
  'error.assignmentUpdateTitle': 'Update failed',
  'error.assignmentUpdateMessage': 'Unable to update assignment. Please try again.',
  'error.assignmentDeleteTitle': 'Delete failed',
  'error.assignmentDeleteMessage': 'Unable to delete assignment. Please try again.',
  // Employee contract errors
  'error.contractLoadTitle': 'Failed to load contracts',
  'error.contractLoadMessage': 'Unable to fetch contracts. Please try again.',
  'error.contractDeleteTitle': 'Delete failed',
  'error.contractDeleteMessage': 'Unable to delete contract. Please try again.',
  'error.contractBulkDeleteTitle': 'Delete failed',
  'error.contractBulkDeleteMessage': 'Unable to delete contracts. Please try again.',
  // Employee calculation story
  'error.calcStoryLoadTitle': 'Failed to load calculation story',
  'error.calcStoryLoadMessage': 'Unable to load calculation story. Please try again.',
  // Frontend-defined API errors (bilingual usage)
  'error.loadListTitle': 'Employee list failed',
  'error.loadListMessage': 'Unable to fetch employees. Please try again.',
  'error.deleteBulkTitle': 'Delete failed',
  'error.deleteBulkMessage': 'Failed to delete records.',
  'error.deleteSingleTitle': 'Delete failed',
  'error.deleteSingleMessage': 'Failed to delete record.',
  'error.saveTitle': 'Unable to save setting',
  'error.saveMessage': 'Unable to save the setting. Please try again.',
  'error.loadTitle': 'Failed to load setting',
  'error.loadMessage': 'Unable to load the setting. Please try again.',
  'error.deleteTitle': 'Delete failed',
  'error.deleteMessage': 'Unable to delete the record. Please try again.',
  'error.duplicateLookup': 'Duplicate: an active lookup with the same name or code already exists.',
  'error.conflictTitle': 'Record Already Exists',
  'error.conflictMessage': 'Record already exists.',
  'error.conflictWithControlsMessage': 'Record with control(s) "{controls}" already exists.',
  // Generic API error-code messages
  'api.error.000.title': 'Success',
  'api.error.000.message': 'Operation completed successfully.',
  'api.error.400.title': 'Validation Error',
  // Specific API error-code messages
  'api.error.103.message': 'You cannot delete the leave request while it is pending approval or under the approval process, or you may not have the required permission to delete it',
  'api.error.103.remote.message':'You cannot delete the Remote work request while it is pending approval or under the approval process, or you may not have the required permission to delete it',
  'api.error.103.permission.message':'You cannot delete the Permission request while it is pending approval or under the approval process, or you may not have the required permission to delete it',
  'api.error.103.manual.message':'You cannot delete the Manual Entry request while it is pending approval or under the approval process, or you may not have the required permission to delete it',
  'api.error.103.update.message': 'You cannot update the leave request while it is pending approval or under the approval process, or you may not have the required permission to update it',
  'api.error.103.update.remote.message': 'You cannot update the Remote Work request while it is pending approval or under the approval process, or you may not have the required permission to update it',
  'api.error.103.update.permission.message': 'You cannot update the Permission request while it is pending approval or under the approval process, or you may not have the required permission to update it',
  'api.error.103.update.manual.message': 'You cannot update the Manual Entry request while it is pending approval or under the approval process, or you may not have the required permission to update it',
  'api.error.400.message': 'Some of the data you entered is invalid. Please review and try again.',
  'api.error.401.title': 'Unauthorized',
  'api.error.401.message': 'You are not authorized to perform this action. Please log in again or contact your administrator.',
  'api.error.403.title': 'Forbidden',
  'api.error.403.message': 'You do not have permission to perform this action.',
  'api.error.404.title': 'Not Found',
  'api.error.404.message': 'The requested resource was not found.',
  'api.error.409.title': 'Duplicate Record',
  'api.error.409.message': 'A record with the same information already exists.',
  'api.error.410.title': 'Delete Failed',
  'api.error.410.message': 'Unable to delete selected item as it depends on {entity}.',
  'api.error.410.pageName': 'Page Name',
  'api.error.410.reference': 'Reference',
  'api.error.422.title': 'Cannot Be Deleted',
  'api.error.422.message': 'The record cannot be deleted because it is in use or in an invalid state.',
  'api.error.423.title': 'Logical Error',
  'api.error.423.message': 'A logical error occurred while processing your request. Please check your input and try again.',
  'api.error.500.title': 'Unexpected Error',
  'api.error.500.message': 'An unexpected server error occurred. Please try again later.',
  'api.error.510.title': 'Database Error',
  'api.error.510.message': 'A database error occurred while processing your request. Please try again later.',
  'error.mustBePositive': 'Value must be positive',
  'error.coreTimeOutsideFlex': 'Core time must be within Flex Start and Flex End time',
  'error.invalidCoreRange': 'Core Start time must be before Core End time',
  'error.mustBeGreaterThanZero': 'Must Be Greater Than Zero',
  'error.somethingWentWrong': 'Something went wrong. Please try again later.',
  'error.saveFailed': 'Save failed',
  'error.updateFailed': 'Update failed',
  'error.cannotUpdateDueToDependencies': 'Unable to update the selected item as it is being used by the following records:',
  'notification.error.invalidTypeId': 'Notification Type ID is invalid.',
  'notification.error.oneDefinitionPerType': 'One definition per Notification Type.',
  'notification.error.invalidIntervalId': 'Interval ID is invalid.',
  'notification.error.scheduleTypeRequired': 'Schedule Type ID is required.',
  'notification.error.durationRequired': 'Duration is required.',
  'notification.error.workdayRequired': 'Workday ID is required.',
  'error.error': 'Error',
  'error.required': 'Required',
  'error.pleaseSelectAtLeastOneMetric': 'Please select at least one metric.',
  'error.pleaseSelectAtLeastOneDetail': 'Please select at least one detail.',
  'error.Required': 'Required',
  'error.required': 'Required',
  'error.fetching_data': 'Failed to fetch data',
  "common.nightShiftWarning": "Night Shift Detected",
  "common.confirmNightShift": "Yes, Continue with Night Shift",
  "common.warning": "warning",
  "common.info": "Info",
  "common.alreadyExists": "Already exists",
  "common.shift": "Shift is required",
  "common.shiftLabel": "Shift",
  "common.group": "Group is required",
  "common.groupTab":'Group',
  "common.employeeTab":'Employee',
  "common.nightShiftDetectionMessage": "The selected times indicate a night shift (start time is after end time)",
  "common.nightShiftConfirmation": "Are you sure you want to set these times for a night shift?",
  "common.nightShiftActive": "Night shift schedule is active (start time is after end time, crossing midnight)",
  'common.savedSuccessfully': 'Saved successfully',
  'employee.createEmployeeFirst': 'Create the employee first to access Contracts.',

    "error.coreStartShouldBeAfterFlexStart": "Core Start Time should be after or equal to Flex Start Time",
    "error.coreStartShouldBeBeforeFlexEnd": "Core Start Time should be before or equal to Flex End Time",
    "error.coreEndShouldBeAfterFlexStart": "Core End Time should be after or equal to Flex Start Time",
    "error.coreEndShouldBeBeforeFlexEnd": "Core End Time should be before or equal to Flex End Time",
    "error.coreStartAfterCoreEnd": "Core Start Time must be before Core End Time",
    "common.nightShiftDetected": "Night Shift Detected",
    "common.nightShiftOptionMessage": "Flex End Time is before Flex Start Time. Are you setting up a night shift?",
    "common.enableNightShift": "Yes, Enable Night Shift",
    "common.nightShiftActive": "Night Shift Active",
    "common.nightShiftActiveMessage": "Night shift schedule is enabled (start time is after end time, crossing midnight).",
    "common.disableNightShift": "Disable Night Shift",
 
    "error.coreStartShouldBeGreaterThanOrEqualToFlexStart": "Core Start Time should be greater than or equal to Flex Start Time",
    "error.coreStartShouldBeLessThanOrEqualToFlexEnd": "Core Start Time should be less than or equal to Flex End Time",
    "error.coreEndShouldBeGreaterThanOrEqualToFlexStart": "Core End Time should be greater than or equal to Flex Start Time",
    "error.coreEndShouldBeLessThanOrEqualToFlexEnd": "Core End Time should be less than or equal to Flex End Time",
    "error.coreStartAfterCoreEnd": "Core Start Time must be before Core End Time",
    "error.flexEndShouldBeGreaterThanFlexStart": "Flex End Time should be greater than Flex Start Time",
    "error.coreTimeOutsideFlexRange": "Core Time should be within Flex time range", 
  "error.duplicatePermissionType": "This permission type has already been added",
  "error.cannotModifyFinalStatus": "Cannot modify a request that has been approved or rejected", 
  
  'groups.groupName': 'Group Name',
  // TargetEmployeeType
  'TargetEmployeeType.NotSet': 'NotSet',
  'TargetEmployeeType.Employee': 'Employee',
  'TargetEmployeeType.Group': 'Group',
  'TargetEmployeeType.Location': 'Location',
  'TargetEmployeeType.Entity': 'Entity',
  'TargetEmployeeType.Manager': 'Manager',
  'TargetEmployeeType.Requester': 'Requester',

  // Label Fields
  'labelFor.nameEn': 'Name En',
  'labelFor.nameAr': 'Name Ar',
  'labelFor.assignType': 'Assign Type',
  'labelFor.assignTo': 'Assign To',
  'labelFor.escalateAfterDay': 'Escalate After (Day)',
  'labelFor.stageOrder': 'Stage Order',
  'labelFor.escalateAction': 'Escalate Action',
  'labelFor.form': 'Form',
  'labelFor.workFlowFor': 'Workflow For',

  // Sidebar
  'sidebar.auditLog': 'Audit Log',
  'sidebar.leaves': 'Leaves',
  'sidebar.employeeLeaves': 'Employee Leaves',
  'sidebar.employeeReports': 'Employee Reports',

  // Employee Leave
  'employeeLeave.title': 'Employee Leave',
  'employeeLeave.review': 'Employee Leave Review',
  'employeeLeave.allowedDays': 'Allowed Days',
  'employeeLeave.carryoverDays': 'Carryover Days',
  'employeeLeave.reference': 'Reference',
  'employeeLeave.allowedDayBalance': 'Allowed Day Balance',
  'employeeLeave.carryOverBalance': 'Carry Over Balance',
  'employeeLeave.totalRequestedBalance': 'Total Requested Balance',
  'employeeLeave.balance': 'Balance',
  'employeeLeave.lastUpdatedDate': 'Last Updated Date',
  'common.search': 'Search',
  'sidebar.selfServices': 'Self Services',
  'sidebar.dashboard': 'Dashboard',
  'sidebar.leave': 'Leaves',
  'sidebar.permission': 'Permissions',
  'sidebar.remoteWork': 'Remote Work',
  'sidebar.workSchedule': 'Work Schedule',
  'sidebar.defineSchedule': 'Define Schedule',
  'sidebar.assignSchedule': 'Assign Schedule',
  'sidebar.breakDuration': 'Break Duration',
  'sidebar.breakManagement': 'Break Management',
  'sidebar.CardPrint':'Card Print',
  'sidebar.attendanceDuration': 'Time Table',
  'sidebar.assignTemporarySchedule': 'Assign Temporary Schedule',
  // 'sidebar.shiftWorkSchedule': 'Assign Work Schedule',
  'sidebar.defineWorkSchedule': 'Shift Plan',
  'sidebar.shiftWorkSchedule': 'Assign Work Schedule',
  'sidebar.scheduleAssignment': 'Schedule Assignment',
  'sidebar.ramadanPeriod': 'Ramadan Period',
  'sidebar.subordinateRequest': 'Subordinates Requests',
  'sidebar.delegation': 'Delegation',
  'sidebar.policy': 'Policy',
  'sidebar.definePolicy': 'Define Policy',
  'sidebar.assignPolicy': 'Assign Policy',
  'sidebar.reports': 'Reports',
  'sidebar.attendance': 'Attendance',
  'sidebar.violations': 'Violations',
  'sidebar.requests': 'Employee Requests',
  'sidebar.humanResources': 'Human Resources',
  'sidebar.recalculateAttendance': 'Recalculate Attendance',
  'sidebar.exception': 'Exception',
  'sidebar.updateSupervisor': 'Update Manager',
  'sidebar.request': 'Request',
  'sidebar.approvalRequestsStatus': 'Approval Requests Status',
  'sidebar.approvalRequestsScreen': 'Approval Requests Screen',
  'sidebar.employees': 'Employees',
  'sidebar.groups': 'Groups',
  'sidebar.manualEntry': 'Manual Entry',
  'sidebar.holidays': 'Holidays',
  'sidebar.lookups': 'Lookups',
  'sidebar.applicationConfigration': 'Application Configration',
  'sidebar.builder': 'Builder',
  'sidebar.newReportBuilder': 'Report Builder',
  'sidebar.leaveSetting': 'Leave Setting',
  'sidebar.permissionType': 'Permission Type',
  'sidebar.permissionSetting': 'Permission Setting',
  'sidebar.workFlow': 'Workflow Setting',
  'sidebar.workFlowApplication': 'WorkFlow Application',
  'sidebar.form': 'Form Worklfow Setting',
  'sidebar.notification': 'Notification',
  'sidebar.employeeWorkSchedule': 'Employee Work Schedule',
  'sidebar.remoteWorkSetting': 'Remote Work Setting',
  'sidebar.lineListingFiltersReport': 'Line Listing Filters Report',
  'sidebar.selectionCriteria': 'Selection Criteria',
  'sidebar.selectedColumnsList': 'Selected Columns List',
  'sidebar.leaveConfirmation': 'Leave Configuration',
  'sidebar.remoteConfirmation': 'Remote Configuration',
  'sidebar.permissionConfirmation': 'Permission Configuration',
  'sidebar.missingGateTransaction': 'Missing Gate Transaction',
  'sidebar.updateBulkEmployee': 'Update Bulk Employee',

  // Dashboard
  'dashboard.employeeInfo': 'Employee Information',
  'dashboard.lineManager': 'Line Manager',
  'dashboard.absent': 'Absent',
  'dashboard.violation': 'Violation',
  'dashboard.consumedHours': 'Remaining Personal Consumed Hours',
  'dashboard.pendingApproval': 'Pending Approvals',
  'dashboard.leaveBalance': 'Leave Balance',
  'dashboard.carryForwardLeave': 'Carry Forward Leaves',
  'dashboard.currentDayStatus': 'Status on ',
  'dashboard.officeInOut': 'In/Out',
  'dashboard.delay': 'Delay',
  'dashboard.inOffice': 'In Office',
  'dashboard.hoursLeftInOffice': 'Hours Left',
  'dashboard.in': 'In Time',
  'dashboard.out': 'Expected Out Time',
  'dashboard.lastOutTime': 'Last Out Time',
  'dashboard.checkIn': 'Check In',
  'dashboard.checkOut': 'Check Out',
  'dashboard.subOrdinate': 'Subordinates',
  'dashboard.dashboard': 'Dashboard',
  'dashboard.Absent': 'Absent',
  'dashboard.Violations': 'Violations Details',
  'dashboard.Personal Permission Requests': 'Personal Permission Details',
  'dashboard.Pending Approval': 'Pending Approval Details',
  'dashboard.Pending Approval': 'Pending Approval Details',
  'dashboard.Leave Balance': 'Leave Balance Details',
  'dashboard.': 'dashboard.',
  'dashboard.clickAboveToCheckIn': 'Click above to check in',
  'dashboard.clickAboveToCheckOut': 'Click above to check out',
  'dashboard.flexibleInTime': 'Flexible In Time',
  'dashboard.flexibleOutTime': 'Flexible Out Time',
  // Manager Dashboard
  'dashboard.manager.employeesWithViolations': 'Employees with Violations',
  'dashboard.manager.upcomingLeaves': 'Upcoming Leaves',
  'dashboard.manager.pendingApprovals': 'Pending Approvals',
  'dashboard.manager.noPendingApprovals': 'No pending approvals',
  'dashboard.manager.leaveRequests': 'Leave Requests',
  'dashboard.manager.permissions': 'Permissions',
  'dashboard.manager.remoteWork': 'Remote Work',
  'dashboard.manager.manualAdjustments': 'Manual Entry',
  'dashboard.manager.noViolationsRecorded': 'No violations recorded',
  'dashboard.manager.noUpcomingLeaves': 'No upcoming leaves',
  'dashboard.manager.employeeAttendanceCalendar': 'Employee Attendance Calendar',
  'dashboard.manager.noEmployeeAttendanceData': 'No employee attendance data for the selected date range',
  'dashboard.manager.quickActions': 'Quick Actions',
  'dashboard.manager.addPermission': 'Add Permission',
  'dashboard.manager.addLeave': 'Add Leave',
  'dashboard.manager.addRemoteWork': 'Add Remote Work',
  'dashboard.manager.exportReport': 'Export Report',
  'dashboard.manager.attendancedistribution': 'Attendance Distribution',
  'dashboard.manager.attendancestatistics': 'Attendance Statistics',
  'dashboard.manager.leavetypes': 'Leave Types',
  'dashboard.manager.departmentattendance': 'Department Attendance',
  'dashboard.manager.title': 'Manager Dashboard',
  'dashboard.manager.pendingRequest': 'Pending Request',
  'employee.resetPassword': 'Reset Password',
  'employee.allowLogin': 'Send password through email',
  'employee.allowedToLogin': 'Allowed to Login',
  'employee.deleteEmployee': 'Delete Employee',
  // Attendance Violation & Transaction
  'attendanceViolation.applyRequest': 'Apply Request',
  'attendanceTransaction.readerTransaction': 'Make it Reader Transaction',

  // Leave Request
  'leaveRequest.Title': 'Leave Requests',
  'leaveRequest.HRTitle':'People Management Leave Requests',
  'leaveRequest.leaveTypeEn': 'Leave Type',
  'leaveRequest.fromDate': 'From Date',
  'leaveRequest.toDate': 'To Date',
  'leaveRequest.status': 'Status',
  'leaveRequest.nextActionBy': 'Next Action By',
  'leaveRequest.add': '+ Add',
  'leaveRequest.leaveType': 'Leave Type',
  'leaveRequest.requestedLeaveCount': 'Requested Leave Count',
  'leaveRequest.carryForwardLeavesCount': 'Carry Forward Leaves Count',
  'leaveRequest.allowedLeavesInYear': 'Allowed Leaves Count',
  'leaveRequest.consumedLeavesCount': 'Consumed Leaves Count',
  'leaveRequest.remainingLeavesCount': 'Remaining Leaves Count',
  'leaveRequest.newLeaveRequest': 'New Leave Request',
  'leaveRequest.editLeaveRequest': 'Edit Leave Request',
  'leaveRequest.leaveSummary': 'Leave Summary',
  'leaveRequest.leaveRequestLabel': 'Leave Request',
  'leaveRequest.leaveRequestSaved': 'Leave request submitted successfully',
  
  // Leave Request Error Messages
  'leaveRequest.error.eligible': 'Eligible / OK',
  'leaveRequest.error.invalidDateRange': 'Invalid leave type or date range (From/To year mismatch)',
  'leaveRequest.error.alreadyInWorkflow': 'Request already in workflow (cannot modify)',
  'leaveRequest.error.overlappingRequest': 'Overlapping leave request exists',
  'leaveRequest.error.afterTermination': 'Leave cannot be after employee termination date',
  'leaveRequest.error.noBalance': 'No leave balance available for this period',
  'leaveRequest.error.insufficientBalance': 'Insufficient leave balance',
  'leaveRequest.error.beforeJoining': 'Leave dates are before employee joining date',
  'leaveRequest.error.workflow': 'No Configuration found with workflow',
  'leaveRequest.error.requestedCountZero': "You can’t submit this request for the selected period because it falls on a non-working day or there is no work schedule available for this date.",
  'leaveRequest.error.beforeafterholiday': 'You cannot apply for leave before or after a holiday.',
  'leaveRequest.error.beforeafterRestday': 'You cannot apply for leave before or after a restday.',
  'leaveRequest.error.splitRequestsNotAllowed': 'You have leave on the last working day. Please submit all leave dates in a single request. Split requests are not allowed',
  'error.failedToSave':'Failed to Save this Request',
  'error.invalidEmployee': 'Invalid employee',


  // Lookups
  'lookup.isDailyReport': 'Is Daily Report',
  'lookup.addDesignationCategory': 'Add Designation Category',
  'lookup.designationCategoryExpansion': 'Designation Category Expansion',
  'lookup.designationCategory': 'Designation Category',
  'lookup.isDefaultValue': 'Is Default',
  'lookup.isContractEmployee': 'Is Contract Employee',
  'lookup.isSecurity': 'Is Security',
  'lookup.addNationality': 'Add Nationality',
  'lookup.nameAr': 'Name Ar',
  'lookup.nameEn': 'Name En',
  'lookup.code': 'Code',
  'lookup.close': 'Close',
  'lookup.save': 'Save',
  'lookup.gender': 'Gender',
  'lookup.userRole': 'User Role',
  'lookup.userRoleExpansion': 'User Role Expansion',
  'lookup.isDefault': 'Is Default',
  'lookup.isEmployee': 'Is Employee',
  'lookup.group': 'Group',
  'lookup.reason': 'Reason',
  'lookup.isDailyReport': 'Is Daily Report',
  'lookup.nationalityExpansion': 'Nationality Expansion',
  'lookup.nationality': 'Nationality',
  'lookup.add': 'Add',
  'lookup.designation': 'Designation',
  'lookup.designationExpansion': 'Designation Expansion',
  'lookup.addDesignation': 'Add Designation',
  'lookup.keyword': 'Keyword',
  'lookup.newEmployeeCategory': 'New Employee Category',
  'lookup.employeeCategoryExpansion': 'Employee Category Expansion',
  'lookup.employeeCategory': 'Category',
  'lookup.qualificationType': 'Qualification Type',
  'lookup.qualification': 'Qualification',
  'lookup.reason': 'Reason',
  'lookup.cardType': 'Card Type',
  'lookup.qualificationStatus': 'Qualification Status',
  'lookup.qualificationEquivalence': 'Qualification Equivalence',
  'lookup.appraisalFinalResult': 'Appraisal Final Result',
  'lookup.country': 'Country',
  'lookup.notFoundLocation': 'Not found location',
  'lookup.notFoundGroup': 'Not found group',
  'lookup.employeeStatus': 'Status',
  'lookup.addEmployeeStatus': 'Add Employee Status',
  'lookup.employeeType': 'Employee Type',
  'lookup.addEmployeeType': 'Add Employee Type',
  'lookup.entity': 'Entity',
  'lookup.level': 'Level',
  'lookup.parent': 'Parent',
  'lookup.entityLevel': 'Entity Level',
  'lookup.addEntityLevel': 'Add Entity Level',
  'lookup.addLeaveType': 'Add Leave Type',
  'lookup.isAnnualLeave': 'Is Annual Leave',
  'lookup.leaveType': 'Leave Type',
  'lookup.userType': 'User Type',
  'lookup.isManager': 'Is Manager',
  'lookup.isHr': 'Is Hr',
  'lookup.religion': 'Religion',
  'lookup.addReligion': 'Add Religion',
  'lookup.workLocation': 'Work Location',
  'lookup.lat': 'Lat',
  'lookup.long': 'Long',
  'lookup.mapUrl': 'Map Url',
  'lookup.radius': 'Radius',
  'lookup.addWorkLocation': 'Add Work Location',
  'lookup.jobGrade': 'Job Grade',
  'lookup.addJobGrade': 'Add Job Grade',
  'lookup.scheduleCategory': 'Schedule Category',
  'lookup.addScheduleCategory': 'Add Schedule Category',
  'lookup.edit': 'Edit',
  'lookup.export': 'Export',
  'lookup.delete': 'Delete',
  'lookup.copy': 'Copy',
  'lookup.view': 'View',
  'lookup.usertypePrivileges': 'User Type Privileges',
  'lookup.menuList': 'Menu List',
  'lookup.elementType': 'Element Type',
  'lookup.addUserType': 'Add User Type',
  'lookup.addEntity': 'Add Entity',
  'lookup.promotionType': 'Promotion Type',
  'lookup.permissionType': 'Permission Type',
  'lookup.addPermissionType': 'Add Permission Type',
  'lookup.workschedule': 'Work Schedule',
  'lookup.policy': 'Policy',
  'lookup.duplicateRecordMessage': 'An active record with the same Arabic Name, English Name, or Code already exists.',
  'lookup.employmentcategory': 'Category',
  'lookup.schedulecategory': 'Schedule Category',
  'lookup.employmentType': 'Employee Type',
  'lookup.groupType': 'Group Type',
  'lookup.department': 'Department',
  'lookup.pleaseFixFollowingFields': 'Please fix the following fields',
  'lookup.pleaseFillRequiredFieldsInGeneralTab': 'Please fill in all required fields in the General tab',
  'lookup.pleaseSelectAtLeastOnePermissionForUserRole': 'Please select at least one permission for this User Role',
  'lookup.selectedEmployees': 'Selected Employees',
  'lookup.sortByNameArabic': 'Sort by Name (Arabic)',
  'lookup.sortByNameEnglish': 'Sort by Name (English)',
  'lookup.sortByEmployeeNo': 'Sort by Employee No',
  'lookup.noEmployeeSelected': 'No employee selected',
  'lookup.pleaseSelectAtLeastOneEmployeeForGroup': 'Please select at least one employee for this Group',
  'common.general': 'General',
  'common.privileges': 'Privileges',
  'lookup.selectPermissionsForThisUserRole': 'Select Permissions for this User Role',
  'lookup.noPermissionsMatchSearch': 'No permissions match your search',
  'lookup.noPermissionsAvailable': 'No permissions available',
  'lookup.module': 'Module',
  'lookup.permissionSettingsFor': 'Permission Settings For {module}',
  'lookup.untitledSection': 'Untitled Section',
  'lookup.fullMenuAccess': 'Full menu access',
  'lookup.unnamedPermission': 'Unnamed Permission',
  'lookup.metrics': 'Metrics',
  'lookup.details': 'Details',
  'lookup.customReport': 'Custom Report',
  'lookup.selectCustomReport': 'Select Custom Report',
  'lookup.loginConfigurationDescription': 'Configure login settings for authentication methods',
  'lookup.loginType': 'Login Type',
  'lookup.usernameAndPassword': 'Username and Password',
  'lookup.azureLogin': 'Azure Login',
  'lookup.both': 'Both',
  'lookup.tenantId': 'Tenant ID',
  'lookup.enterTenantId': 'Enter Tenant ID',
  'lookup.clientId': 'Client ID (Application ID)',
  'lookup.enterClientId': 'Enter Client ID',
  'lookup.redirectUri': 'Redirect URI',
  'lookup.enterRedirectUri': 'Enter Redirect URI',
  'lookup.issuerUrl': 'Issuer URL',
  'lookup.enterIssuerUrl': 'Enter Issuer URL',
  'error.failedToSaveLoginConfiguration': 'Failed to save login configuration',
  'error.invalidUrlFormat': 'Invalid URL format',
  'lookup.emailConfiguration': 'Configuration',
  'lookup.emailConfigurationDescription': 'Configure email settings for sending notifications and system emails',
  'lookup.readers': 'Readers',
  'lookup.readerType': 'Reader Type',
  'lookup.ipAddress': 'IP Address',
  'lookup.isActive': 'Is Active',
  'lookup.providerType': 'Provider Type',
  'lookup.host': 'Host',
  'lookup.enterHost': 'Enter SMTP host (e.g., smtp.gmail.com)',
  'lookup.port': 'Port',
  'lookup.enterPort': 'Enter port number (e.g., 587)',
  'lookup.username': 'Username',
  'lookup.enterUsername': 'Enter email username',
  'lookup.password': 'Password',
  'lookup.enterPassword': 'Enter email password',
  'lookup.apiKey': 'API Key',
  'lookup.enterApiKey': 'Enter API key (if applicable)',
  'lookup.fromEmail': 'From Email',
  'lookup.enterFromEmail': 'Enter from email address',
  'lookup.displayName': 'Display Name',
  'lookup.enterDisplayName': 'Enter display name',
  'lookup.enableSSL': 'Enable SSL',
  'lookup.testEmail': 'Test Email',
  'lookup.sendTestMail': 'Send Test Mail',
  'lookup.sendTestEmail': 'Send Test Email',
  'lookup.recipientEmail': 'Recipient Email',
  'lookup.enterRecipientEmail': 'Enter recipient email',
  'lookup.subject': 'Subject',
  'lookup.enterEmailSubject': 'Enter email subject',
  'lookup.body': 'Body',
  'lookup.enterEmailBody': 'Enter email body',
  'lookup.sending': 'Sending...',
  'lookup.send': 'Send',
  'lookup.cancel': 'Cancel',
  'lookup.optional': 'Optional',
  
  // Mobile Configuration
  'lookup.mobileConfiguration': 'Mobile configuration',
  'lookup.mobileApplication': 'Mobile application',
  'lookup.mobileApplicationUsageAndRestrictions': 'Mobile application usage & restrictions',
  'lookup.companyConfiguration': '1. Company Configuration',
  'lookup.allowEmployeesMobileAccess': 'Configuration for all company if the employees can access',
  'lookup.deviceBufferMinutes': 'Device buffer time (Minutes)',
  'lookup.locationAndGeoValidationConfigurations': '2. Location & Geo Validation Configurations',
  'lookup.deviceAndSecurityConfigurations': '3. Device & Security Configurations',
  'lookup.timeAndPunchingRules': '4. Time & Punching Rules',
  'lookup.requiredGpsAccuracyMeters': 'Required GPS Accuracy (Meters)',
  'lookup.maxDistanceAllowedFromOfficeMeters': 'Max Distance Allowed From Office (Meters)',
  'lookup.enforceGeoFence': 'Enforce Geo-Fence',
  'lookup.deviceBufferCheck': 'Device buffer check',
  'lookup.maxAllowedRegisteredDevicesPerEmployee': 'Max Allowed Registered Devices per Employee',
  'lookup.allowEarlyPunchMinutesBeforeShift': 'Allow Early Punch (Minutes Before Shift)',
  'lookup.allowLatePunchMinutesAfterShift': 'Allow Late Punch (Minutes After Shift)',
  'lookup.limitPunchCountPerDay': 'Limit Punch Count per Day',
  'lookup.minimumDifferenceBetweenTwoPunchesMinutes': 'Minimum Difference Between Two Punches (minutes)',
  'lookup.examplePlaceholder': 'e.g. {value}',

  // Addon Configuration
  'lookup.addonConfiguration': 'Addon configuration',
  'lookup.requestNameEnglish': 'Request Name English',
  'lookup.requestNameArabic': 'Request Name Arabic',
  'lookup.requestTypeId': 'Request Type ID',

  // Mobile Application
  'mobile.mobileApplication': 'Mobile Application',
  'mobile.mobileConfiguration': 'Mobile Configuration',
  'mobile.allowMobileAccess': 'Allow Mobile Access',
  'mobile.allowMobileAccessDesc': 'Employee can sign in to the BOS Attendance app.',
  'mobile.allowPunchInOutMobileApp': 'Allow Punch In/Out Using Mobile App',
  'mobile.allowPunchInOutMobileAppDesc': 'Clock in and out from the mobile app.',
  'mobile.locationCheck': 'Location Check',
  'mobile.locationCheckDesc': 'Punch only inside assigned',
  'mobile.deviceLimit': 'Device Limit',
  'mobile.deviceLimitDesc': 'Max approved devices this employee can use.',
  'mobile.registeredDevices': 'Registered Devices',
  'mobile.devicesSeen': 'device(s) seen',
  'mobile.deviceID': 'Device ID',
  'mobile.registered': 'Registered',
  'mobile.lastActive': 'Last active',
  'mobile.lastAction': 'Last action',
  'mobile.viewActivity': 'Show history',
  'mobile.hideHistory': 'Hide history',
  'mobile.signOutAllDevices': 'Deactivate all devices',
  'mobile.block': 'Deactivate',
  'mobile.deactivateDeviceConfirm': 'Are you sure you want to deactivate this device?',
  'mobile.deactivate': 'Deactivate',
  'mobile.activateDeviceConfirm': 'Are you sure you want to activate this device?',
  'mobile.activate': 'Activate',
  'mobile.deactivateAllDevicesConfirm': 'Are you sure you want to deactivate all devices for this employee?',
  'mobile.deactivateAllDevices': 'Deactivate all devices',
  // Mobile app device error messages
  'mobile.error.noDevicesToUpdate': 'Nothing to update: there are no devices, or all are already in the requested state.',
  'mobile.error.deviceNotFound': 'Device ID not found for this company.',
  'mobile.error.deviceRegisteredToAnotherEmployee': 'This device is already registered to another employee in the company.',
  'mobile.error.maxDevicesReached': 'This employee already has the maximum number of active devices.',
  'mobile.error.deviceAlreadyActive': 'The device is already active.',
  'mobile.error.deviceAlreadyInactive': 'The device is already inactive.',
  'mobile.error.deviceDeactivated': 'This device has been deactivated by an administrator.',
  'mobile.error.appVersionNotSupported': 'The app version on this device is not supported. Please update the app.',
  'mobile.error.mobileConfigurationNotFound': 'Mobile configuration is missing for this company, so the device limit cannot be checked.',
  'mobile.error.saveFailed': 'Saving the device settings failed. Please try again.',
  'mobile.unblock': 'Unblock',
  'mobile.remove': 'Remove',
  'mobile.setAsPrimary': 'Set as primary',
  'mobile.primary': 'Primary',
  'mobile.blocked': 'Blocked',
  'mobile.blockedBy': 'Blocked by',
  'mobile.blockedOn': 'Blocked on',
  'mobile.reason': 'Reason',
  'mobile.mobileHistory': 'Mobile History',
  'mobile.eventID': 'Event ID',
  'mobile.action': 'Action',
  'mobile.dateTime': 'Date Time',
  'mobile.fromDate': 'From Date',
  'mobile.toDate': 'To Date',

  'error.failedToLoadData': 'Failed to load data',
  'error.failedToLoadPermissions': 'Failed to load permissions',
  'employee.editEmployee': 'Edit Employee',
  'employee.selectEmployee': 'Select an Employee',
  'menu.lookupGroup.employee': 'Employee',
  'menu.lookupGroup.request': 'Request',
  'menu.lookupGroup.rbac': 'Role Based Access Control',
  'menu.lookupGroup.general': 'General',
  'recalculateAttendance.employeeAttendance': 'Employee Attendance',
  'recalculateAttendance.entityAttendance': 'Entity Attendance',
  'exception.entityException': 'Department Exception',
  //Permission

  'permission.permissionRequest': 'Permission Request',
  'permission.permissionRequestHR': 'People Management Permission Request',
  'permission.addPermssionRequest': 'Add Permission Request',
  'permission.editPermssionRequest': 'Edit Permission Request',
  'permission.permissionSummary': 'Permission Summary',
  'permission.requested': 'Requested',
  'permission.consumed': 'Consumed',
  'permission.pending': 'Pending',
  'permission.remaining': 'Remaining',
  'permission.allowed': 'Allowed',
  'permission.loadingForm': 'Loading form...',
  'permission.failedToLoadForm': 'Failed to load form definition.',
  'permission.allowedMaxDuration': 'Allowed Maximum Duration to apply is',
  'permission.requiredMinimum': 'Required Minimum',
  'permission.workingHoursToApply': 'Working Hours to apply',
  'permission.hours': 'Hours',
  'permission.schedule': 'Schedule',
  'permission.flex': 'Flex',
  'permission.entityPermissionRequest': 'Entity Permission Request',
  'permission.companyPermissionRequest': 'Company Permission Request',
  'permission.locationPermissionRequest': 'Location Permission Request',
  'permission.groupPermissionRequest': 'Group Permission Request',
  'permission.permissionSavedSuccessfully': 'Permission request submitted successfully',
  'permission.permissionRequestError': 'Permission Request Error',
  'permissionRequest.error.invalidDateOrShiftPatternOrDuration': 'Invalid Date / Invalid Shift Pattern / Invalid Duration',
  'permissionRequest.error.allowedBeforeDaysExceeded': 'This request must be submitted at least {AllowedBefore} day(s) before the permission date.',
  'permissionRequest.error.allowedAfterDaysExceeded': 'This request cannot be submitted more than {AllowedAfter} day(s) before the permission date.',
  'permissionRequest.error.overlapWithAnotherPermission': 'Overlap with another permission.',
  'permissionRequest.error.cannotUpdateWhilePendingApproval': 'You cannot update the Permission request while it is pending approval or under the approval process, or you may not have the required permission to update it',
  'permissionRequest.error.invalidDateRangeNull': 'Invalid date range: From Date or To Date is missing.',
  'permissionRequest.error.toDateEarlierThanFromDate': 'Invalid date range: To Date cannot be earlier than From Date.',
  'permissionRequest.error.initialState': 'Processing not started yet.',
  'permissionRequest.error.minMaxDurationNotDefined': 'Min/Max duration settings not defined.',
  'permissionRequest.error.requestedDurationAboveMaximum': 'Requested duration is above the maximum allowed.',
  'permissionRequest.error.requestedDurationBelowMinimum': 'Requested duration is below the minimum allowed.',
  'permissionRequest.error.monthlyLimitExceeded': 'Monthly limit exceeded.',
  'permissionRequest.error.dailyLimitExceeded': 'Daily limit exceeded.',
  'permissionRequest.error.notAllowedBeforeJoinDate': 'Not allowed before employee join date.',
  'permissionRequest.error.notAllowedAfterTerminationDate': 'Not allowed after employee termination date.',
  'permissionRequest.error.pendingActionTypeRecalNotFound': 'Pending action type RECAL was not found in TimeManagementLookups.',
  'permissionRequest.error.workflowConfigurationMissing': 'No Configuration found with workflow.',
  'permissionRequest.error.configurationNotFoundInactive': 'Permission request configuration was not found or is inactive/not applicable.',
  'permissionRequest.error.fullDayNoValidScheduleOrRange': 'Full-day permission failed: no valid work schedule/time range found.',
  'permissionRequest.error.invalidTimeRangeNullOrOrder': 'Invalid time range: FromTime or ToTime is NULL, or ToTime must be greater than FromTime.',
  'permissionRequest.error.workflowDefinitionMissing': 'Workflow definition is missing for an employee permission request.',
  'permissionRequest.error.workflowSubmitActionNotFound': 'Workflow Submit action was not found.',
  'permissionRequest.error.requiredStatusNotFound': 'Required request status was not found (AutomaticApproval, Requested, or Approved).',
  'permissionRequest.error.requestNotFoundOrDeleted': 'Permission request was not found or is deleted.',
  'permissionRequest.error.updateNoActiveRecord': 'Permission request update failed because no active record was updated.',
  'permissionRequest.error.genericWorkflowFailure': 'Workflow failed to process the request.',
  'permissionRequest.error.unexpectedSystemError': 'Unexpected system/database error. Please try again or contact the administrator.',
  'permissionRequest.error.eligibilityFailed': 'Permission eligibility validation failed.',
  'permissionRequest.error.workflowSpecificFailure': 'Workflow-specific validation or processing failure.',
  'permission.noFormDefinitionFound': 'No form definition found.',
  'permission.field': 'Field',
  'permission.cannotModifyFinalStatus': 'Cannot modify a request that has been approved or rejected',
  'permission.delete.error.-101': 'Permission not found or already deleted',
  'permission.delete.error.-102': 'Recalculation action type not configured',
  'permission.delete.error.-103': 'Not authorized or invalid state',
  'permission.delete.error.-500': 'Unexpected database/system error',
  'permission.invalidResponseData': 'Invalid response data',
  'permission.noPermissionFound': 'No permission found for this employee',
  'permission.formNoFields': 'Form definition has no fields.',

  // Remote Work Delete Error Messages
  'remoteWork.delete.error.-101': 'Remote not found or already deleted',
  'remoteWork.delete.error.-102': 'Recalculation action type not configured',
  // -103 uses api.error.103.remote.message
  'remoteWork.delete.error.-500': 'Unexpected database/system error',

  // Leave Delete Error Messages
  'leave.delete.error.-101': 'Leave not found or already deleted',
  'leave.delete.error.-102': 'Recalculation action type not configured',
  // -103 uses api.error.103.message
  'leave.delete.error.-500': 'Unexpected database/system error',

  // Manual Entry Delete Error Messages
  'manualEntry.delete.error.-101': 'Manual entry not found or already deleted',
  'manualEntry.delete.error.-102': 'Recalculation action type not configured',
  // -103 uses api.error.103.manual.message
  'manualEntry.delete.error.-500': 'Unexpected database/system error',
  'permission.noDataFound': 'No data found',
  'permission.failedToLoadData': 'Failed to load data',
  'permission.requiredMinimum': 'Required Minimum',
  'permission.loadingForm': 'Loading form...',
  'permission.requestFailed': 'Failed to save permission request',

  'error.isRequired': 'is required',
  'error.invalidEmployee': 'Invalid employee',
  'error.toTimeMustBeGreaterThanFromTime': 'To Time must be greater than From Time',
  'error.failedToLoadData': 'Failed to load data',

  //remoteWork
  'remoteWork.remoteWorkRequests': 'Remote Work Requests',
  'remoteWork.newRemoteWorkRequest': 'Add Remote Work Request',
  'remoteWork.editRemoteWorkRequest': 'Edit Remote Work Request',
  'remoteWork.remoteValidData': 'Please check your request',
  'remoteWork.onlinePunchInOut': 'Online Punch IN/OUT',
  'remoteWork.checkScheduleTiming':
    'Enable During Schedule Timing (Punch IN/OUT)',
  'remoteWork.RemoteWorkSettingExpansion': 'Remote Work Setting',
  'remoteWork.AllowedDayPerYear': 'Allowed Day Per Year',
  'remoteWork.AllowedDayPerMonth': 'Allowed Day Per Month',
  'remoteWork.error.yearlyLimitExceeded': 'Yearly remote work limit exceeded.',
  'remoteWork.error.beforeJoinDate': 'Request starts before employee join date.',
  'remoteWork.error.afterTerminationDate': 'Request ends after employee termination date.',
  'remoteWork.error.leaveExists': 'A leave request exists within the requested remote work period.',
  'remoteWork.error.configurationMissing': 'Remote work configuration is missing. Please contact your administrator.',
  'remoteWork.error.remoteExists': 'A remote work request already exists in the selected period.',
  'remoteWork.remoteWorkSummary': 'Remote Work Summary',
  'remoteWork.remoteWorkRequest': 'Remote Work Request',
  'remoteWork.remoteWorkRequestHR': 'People Management Remote Work Request',
  'remoteWork.allowedMaxDurationMonth': 'Maximum Allowed Per Month is',
  'remoteWork.showDetails': 'Show Details',
  'remoteWork.days': 'days',
  'remoteWork.error.failedToFetchDetails': 'Failed to fetch remote work request details',
  'remoteWork.error.title': 'Remote Work Request Error',
  'remoteWork.loadingForm': 'Loading form...',
  'remoteWork.notEligibleForPeriod': 'You are not eligible for remote work during this period.',
  'announcement.announcementReq' : 'Announcement',
  'announcement.newAnnouncement': 'Add Announcement',
  'announcement.editAnnouncement': 'Edit Announcement',
  'announcement.headerEn': 'Header (English)',
  'announcement.headerAr': 'Header (Arabic)',
  'announcement.bodyEn': 'Body (English)',
  'announcement.bodyAr': 'Body (Arabic)',
  'announcement.announcementDate': 'Announcement Date',
  'announcement.attachment': 'Attachment',
  'announcement.announcementType': 'Announcement Type',
  'announcement.updated': 'Announcement Updated',
  'announcement.created': 'Announcement Created',

  // App Layout
  'appLayout.configuration': 'Configuration',
  'appLayout.darkMode': 'Dark Mode',
  'appLayout.userRole': 'User Role',
  'appLayout.selectUserRole': 'Select User Role',
  'appLayout.employeeDashboard': 'Employee Dashboard',
  'appLayout.hrDashboard': 'HR Dashboard',
  'appLayout.customizeLayout': 'Customize Layout',
  'appLayout.palette': 'Palette',
  'appLayout.color.blue': 'Blue',
  'appLayout.color.orange': 'Orange',
  'appLayout.color.green': 'Green',
  'appLayout.color.yellow': 'Yellow',
  'appLayout.color.red': 'Red',
  'appLayout.language': 'Language',
  'appLayout.languageEnglish': 'English',
  'appLayout.languageArabic': 'Arabic',
  'appLayout.pagination': 'Pagination',
  'appLayout.leftMenu': 'Left Menu',
  'appLayout.leftMenu.fixed': 'Fixed',
  'appLayout.leftMenu.fluid': 'Fluid',
  'appLayout.resetTheme': 'Reset Theme',
  'appLayout.selectEmployeePlaceholder': 'Search Employee',
  'appLayout.empShort': 'Emp',
  'appLayout.signOut': 'Sign out',
  'appLayout.viewProfile': 'View my profile',
  'appLayout.myProfile': 'My Profile',
  'appLayout.changeCurrentRole': 'Change Current Role',
  'appLayout.loading': 'Loading...',
  'appLayout.companyName': 'Smartv.ae',
  'appLayout.configSaveSuccess': 'Configuration saved successfully',
  'appLayout.configSaveFailed': 'Failed to save configuration',
  'appLayout.configCloseWarningTitle': 'Unsaved Changes',
  'appLayout.configCloseWarningMessage': 'Changes made will not be saved. Do you want to close the configuration panel?',
  'appLayout.accessDenied': 'Access Denied',
  'appLayout.noAccessibleRoutes': 'Your current role does not have access to any pages.',
  'appLayout.roleCompanyMismatch': 'Selected role does not belong to your company.',
  'appLayout.dashboardNotAvailable': 'Dashboard Not Available',
  'appLayout.roleCompanyMismatchDashboard': "You can't view the Dashboard because your selected role belongs to a different company. Please use the sidebar to navigate to your allowed pages or change your role.",
  'common.noPermission': "You don't have permission to view this page",
  'appLayout.profileUpdateSuccess': 'Profile updated successfully',
  'appLayout.connectivity.noInternetTitle': 'No internet connection',
  'appLayout.connectivity.noInternetMessage': 'No internet connection. Please check your connection and try again.',
  'appLayout.connectivity.serverUnreachableTitle': 'Service Unavailable',
  'appLayout.connectivity.serverUnreachableMessage': 'We are experiencing an issue while processing your request. Please try again shortly.',
  'appLayout.connectivity.serverErrorTitle': 'Server Error',
  'appLayout.connectivity.serverErrorMessage': 'An internal server error occurred.',
  'appLayout.connectivity.serverUnavailableTitle': 'Service Unavailable',
  'appLayout.connectivity.serverUnavailableMessage': 'The server is temporarily unavailable. Please try again shortly.',

  //Delegation

  'delegation.delegation': 'Delegation',
  'delegation.addDelegation': 'Add Delegation',
  'delegation.enableEndDate': 'Enable End Date',
  'delegation.currentManager': 'Current Manager',
  'delegation.enabletoDate': 'Enable To Date',

  //Work Schedule
  'workSchedule.workSchedule': 'Work Schedule',
  'workSchedule.updateWorkSchedule': 'Update Work Schedule',
  'workSchedule.workScheduleExpansion': 'Work Schedule Expansion',
  'workSchedule.addWorkSchedule': 'Add Work Schedule',
  'workSchedule.normalSchedule': 'Normal Schedule',
  'workSchedule.scheduleCategory': 'Schedule Category',
  'workSchedule.ramadanSchedule': 'Ramadan Schedule',
  'workSchedule.shift1': 'Shift 1',
  'workSchedule.flexDuration': 'Flex Duration',
  'workSchedule.minRequired': 'Min. Required',
  'workSchedule.isOffDay': 'Is Off Day',
  'workSchedule.nameAr': 'Schedule Name Ar',
  'workSchedule.nameEn': 'Schedule Name En',
  'workSchedule.targetEmployees': 'Target Employees',
  'workSchedule.updateWorkSchedule': 'Update Work Schedule',
  'workSchedule.sameDataEntryOfRamadan':
    'Ramdan for Same From Date & To Date Is Already Exist',
  ///Schedule Assignment
  'assignWorkSchedule.scheduleAssignment': 'Assign Shift',
  'assignWorkSchedule.editScheduleAssignment': 'Edit Assign Shift',
  'assignWorkSchedule.addScheduleAssignment': 'Assign Shift',
  'assignWorkSchedule.assignWorkSchedule': 'Assign Work Schedule',
  'assignWorkSchedule.schedules': 'Schedules',
  'assignWorkSchedule.viewAssignedSchedules': 'View Assigned Schedules',
  'assignWorkSchedule.workScheduleExpansion': 'Work Schedule Expansion',
  'assignWorkSchedule.emergencySchedule': 'Emergency Schedule',
  'assignWorkSchedule.temporary': 'Temporary',
  'assignWorkSchedule.assign': 'Assign',
  'assignWorkSchedule.assignmentType': 'Assignment Type',

  // User role assignment
  'userRoleAssignment.userRoleAssignment': 'User Role Assignment',
  'userRoleAssignment.userRoleAssignmentAdd': 'User Role Assignment',
  'userRoleAssignment.userRoleAssignmentEdit': 'Edit User Role Assignment',
  'userRoleAssignment.updateSuccess': 'User Role Updated Successfully!',
  'userRoleAssignment.saveSuccess': 'User Role Saved Successfully!',
  'userRoleAssignment.addUserRole': 'Add User Role',
  'userRoleAssignment.createdByEmployee': 'Created By Employee',
  'userRoleAssignment.createdDate': 'Created Date',
  'userRoleAssignment.lastUpdatedByEmployee': 'Last Updated By Employee',
  'userRoleAssignment.lastUpdatedDate': 'Last Updated Date',
  'userRoleAssignment.blockedUserScreen': 'Blocked User',
  'userRoleAssignment.addBlockedUserScreen': 'Add Blocked User',
  'userRoleAssignment.editBlockedUserScreen': 'Edit Blocked User',
  'userRoleAssignment.targetName': 'Target',
  'userRoleAssignment.blockedScreens': 'Blocked Screens',
  'userRoleAssignment.selectAtLeastOneScreen': 'Please select at least one screen',

  // Workflow Builder
  'workflow.workflowBuilder': 'Workflow Setting',
  'workflow.nameEn': 'Name En',
  'workflow.stageOrder': 'Stage Order',
  'workflow.formName': 'Form Name',
  'workflow.assignType': 'Assign Type',
  'workflow.escalatedAfter': 'Escalated After',
  'workflow.escalateAction': 'Escalate Action',
  'workflow.workflowFor': 'Workflow For',
  'workflow.selectWorkflow': 'Select Workflow',
  'workflow.formId':'Form',
  'workflow.assignTo':'Assign To',
  'workflow.actions':'Actions',
  'workflow.notificationType':'Notification',
  'workflow.notification': 'Notification',
  'workflow.escalateType':'Escalate Type',
  'workflow.escalateDays':'Escalate Days',
  'workflow.approvalStages': 'Workflow Approval Stages',
  'workflow.actor': 'Workflow Actor',
  'workflow.actorType': 'Actor Type',
  'workflow.selectActorType': 'Select Actor Type',
  'workflow.selectWorkflowActor': 'Select Workflow Actor',
  'workflow.attachLinkForm': 'Attach/Link Form',
  'workflow.requiredActions': 'Required Actions',
  'workflow.rejectionReason': 'Rejection Reason Required',
  'workflow.selectForm': 'Select Form',
  'workflow.pleaseClickToSelectTheForm': 'Please click to select the form',
  'workflow.formList': 'Form List',
  'workflow.pleaseSelectFormBelow': 'Please select the form which is given below',
  'workflow.noFormsAvailable': 'No forms available for this workflow type.',
  'workflow.createNewForm': 'Create New Form',
  'workflow.createForm': 'Create Form +',
  'workflow.untitledForm': 'Untitled Form',
  'workflow.untitledField': 'Untitled Field',
  'workflow.enterDaysPlaceholder': 'Enter number of days',
  'workflow.noFieldsInThisForm': 'No fields in this form',
  'workflow.all': 'All',

  // Form Builder
  'form.formBuilder': 'Form Builder',
  'form.BacktoList': 'Back to List',
  'form.formType': 'Form Type',
  'form.Code': 'Code',
  'form.FormNameEn': 'Form Name (En)',
  'form.FormNameAr': 'Form Name (Ar)',
  'form.saving': 'Saving...',
  'form.Save': 'Save',
  'form.Update': 'Update',
  'form.components': 'Components',
  'form.search': 'Search',
  'form.build': 'Build',
  'form.preview': 'Preview',
  'form.code': 'Code',
  'form.formConfiguration': 'Form Configuration',
  'form.copyToClipboard': 'Copy to Clipboard',
  'form.fieldProperties': 'FIELD PROPERTIES',
  'form.labelText': 'Label Text',
  'form.labelTextEn': 'Label Text (EN)',
  'form.labelTextAr': 'Label Text (AR)',
  'form.enterLabelPlaceholder': 'Please Enter Label Text...',
  'form.enterLabelEnPlaceholder': 'Please Enter Label Text in English...',
  'form.enterLabelArPlaceholder': 'Please Enter Label Text in Arabic...',
  'form.tooltip': 'Tooltip',
  'form.enterTooltipPlaceholder': 'Please Enter Tooltip Text Here...',
  'form.hintValue': 'Hint Value',
  'form.hintValueEn': 'Hint Value (EN)',
  'form.hintValueAr': 'Hint Value (AR)',
  'form.enterHintPlaceholder': 'Please Enter Hint Value Here...',
  'form.enterHintEnPlaceholder': 'Please Enter Hint Value in English...',
  'form.enterHintArPlaceholder': 'Please Enter Hint Value in Arabic...',
  'form.dropdownType': 'Dropdown Type',
  'form.customOptions': 'Custom Options',
  'form.countryList': 'Country List',
  'form.numberRange': 'Number Range',
  'form.predefinedData': 'Predefined Data',
  'form.predefinedType': 'Predefined Type',
  'form.selectType': 'Select type...',
  'form.options': 'Options',
  'form.enterOption': 'Enter option...',
  'form.addOption': 'Add Option',
  'form.min': 'Min',
  'form.max': 'Max',
  'form.fieldWidth': 'Field Width',
  'form.fullWidth': 'Full Width',
  'form.halfWidth': 'Half Width',
  'form.oneThird': 'One Third',
  'form.selectWidth': 'Select width...',
  'form.mandatoryField': 'Mandatory Field',
  'form.noFieldsAdded': 'No form fields added yet.',
  'form.noFieldsDescription': "It looks like you haven't added any form fields yet. Click on the \"Add Field\" button to start building your form.",
  'form.addField': 'Add Field',
  'form.loadingFormDetails': 'Loading form details...',
  'form.dropHere': 'Drop here',
  'form.dragToMove': 'Drag to move',
  'form.duplicate': 'Duplicate',
  'form.edit': 'Edit',
  'form.delete': 'Delete',
  'form.addRow': 'Add Row',
  'form.gridSettings': 'Grid Settings',
  'form.deleteRow': 'Delete Row',
  'form.on': 'On',
  'form.off': 'Off',
  'form.from': 'From',
  'form.to': 'To',
  'form.loadingFormDetails': 'Loading form details...',
  'form.validation.required': 'This field is required.',
  'form.validation.validEmail': 'Please enter a valid email address.',
  'form.validation.selectOption': 'Please select an option.',
  'form.validation.selectAtLeastOne': 'Please select at least one option.',
  'form.validation.mustBeChecked': 'This field must be checked.',
  'form.column.one': '1 Column',
  'form.column.two': '2 Columns',
  'form.column.three': '3 Columns',
  'form.error.negativeNumbers': 'Negative numbers are not allowed.',
  'form.error.minMax': 'Min cannot be greater than Max.',
  'form.error.duplicateRowLimit': 'Cannot duplicate field: Row limit reached.',
  'form.error.fieldWidthLimit': 'Field width exceeds row limit.',
  'form.error.minRequired': 'Min is required and must be a number',
  'form.error.maxRequired': 'Max is required and must be a number',
  'form.error.fillRequired': 'Please fill in both English and Arabic Form Names and Code.',
  'form.error.columnLimitExceeded': "Field width exceeds row's {count} {count, plural, one {column} other {columns}} limit.",
  'form.error.noFields': 'Please add at least one field to save the form.',
  'form.error.saveFailed': 'Failed to save the form.',
  'form.error.updateFailed': 'Failed to update the form.',
  'form.success.saved': 'Form saved successfully!',
  'form.success.updated': 'Form updated successfully!',
   'form.error.missingProperties': 'Please fill in the missing properties',
   'form.noFieldsYet': 'No fields yet',
   'form.startBuilding': 'Drag and drop components from the sidebar to start building your form.',
  'form.placeholder.enterText': 'Enter text...',
  'form.placeholder.enterEmail': 'Enter email address...',
  'form.placeholder.enterDescription': 'Enter description...',
  'form.placeholder.enterNumber': 'Enter number...',
  'form.placeholder.selectOption': 'Select an option',
  'form.placeholder.selectMultiple': 'Select multiple options',
  'form.option': 'Option {count}',

  // Form Components
  'form.component.input': 'Text Input',
  'form.component.textarea': 'Text Area',
  'form.component.email': 'Email',
  'form.component.dropdown': 'Dropdown',
  'form.component.multiselect': 'Multi Select',
  'form.component.radio': 'Radio',
  'form.component.checkbox': 'Checkbox',
  'form.component.number': 'Number',
  'form.component.date': 'Date',
  'form.component.time': 'Time',
  'form.component.daterange': 'Date Range',
  'form.component.switch': 'Switch',
  'form.component.file': 'File Upload',
  'form.placeholder.uploadFile': 'Upload a PDF or Word document (max 10 MB)',
  'form.validation.fileTooLarge': 'File exceeds the 10 MB limit.',
  'form.validation.invalidFileType': 'Only PDF or Word (doc, docx) files are allowed.',

  // Form Categories
  'form.category.textInput': 'Text & Input',
  'form.category.selection': 'Selection',
  'form.category.numbersDates': 'Numbers & Dates',
  'form.category.interactive': 'Interactive',

  // Common Buttons
  'button.add': '+ ADD',
  'button.addApprovalLevel': 'Add Approval Level',
  'button.save': 'Save',
  'button.cancel': 'Cancel',
  'button.clear': 'Clear',
  'button.addElement': 'Add Element',

  //policy
  'policy.manualEntryWorkFlow': 'Manual Entry Work Flow',
  'policy.policyExpansion': 'Policy Expansion',
  'policy.policy': 'Policy',
  'policy.policyNameEn': 'Policy Name En',
  'policy.policyNameAr': 'Policy Name Ar',
  'policy.remoteWork': 'Remote Work',
  'policy.remoteWorkFlow': 'Remote Work Flow',
  'policy.addTaPolicy': 'Add  Policy',
  'policy.assignPolicy': 'Assign Policy',
  'policy.policyAssignment': 'Policy Assignment',
  'policy.viewAssignedPolicies': 'View Assigned Policies',
   'policy.policies': 'Policies',
   'policy.assignmentType': 'Assignment Type',

   // Notification Template
   'notificationTemplate.title': 'Notification Settings',
   'notificationTemplate.lastUpdatedDate': 'Last Updated Date',
   'notificationTemplate.createdDate': 'Created Date',
   'notificationTemplate.interval': 'Interval',
   'notificationTemplate.type': 'Type',
   'notificationTemplate.operations': 'Operations',
   'notificationTemplate.deleteConfirm': 'Are you sure you want to delete {name}?',
   'notificationTemplate.recordDeleted': 'Record deleted successfully!',
   'notificationTemplate.recordsDeleted': 'record(s) deleted successfully!',
   'notificationTemplate.failedToDelete': 'Failed to delete records',
   'notificationTemplate.deleteError': 'An error occurred while deleting the record.',
   'notificationTemplate.exportPDF': 'Export PDF',
   'notificationTemplate.exportPDFMsg': 'All items will be exported to PDF.',
   'notificationTemplate.exportExcel': 'Export Excel',
   'notificationTemplate.exportExcelMsg': 'All items will be exported to .csv',
   'notificationTemplate.importData': 'Import Data',
   'notificationTemplate.importDataMsg': 'All items will be Imported.',
   'notificationTemplate.downloadConfirm': 'Confirmation',
   'notificationTemplate.itemsWillBeDownloaded': 'items will be downloaded.',
   'notificationTemplate.durationTooltip': 'Duration (minutes): how long to wait after the window starts before sending. E.g. for 00:00–06:00 with Duration = 30, sending starts at 00:30 and still stops at 06:00.',
   'policy.targetEmployees': 'Target Employees',
   'policy.TA Policy': 'TA Policy',

  //Recalculate Attendance
  'recalculateAttendance.recalculateAttendance': 'Recalculate Attendance',
  'recalculateAttendance.recalculateSchedule': 'Recalculate Schedule',
  'recalculateAttendance.createRecalculation': 'Add Recalculation',
  'recalculateAttendance.companyAttendance': 'Company Attendance',
  'recalculateAttendance.entityAttendance': 'Entity Attendance',
  'recalculateAttendance.groupAttendance': 'Group Attendance',
  'recalculateAttendance.locationAttendance': 'Location Attendance',
  'recalculateAttendance.addCompanyRecalculation': 'Add Company Recalculation',
  'recalculateAttendance.addEmployeeRecalculation': 'Add Employee Recalculation',
  'recalculateAttendance.addEntityRecalculation': 'Add Entity Recalculation',
  'recalculateAttendance.addLocationRecalculation': 'Add Location Recalculation',
  'recalculateAttendance.addGroupRecalculation': 'Add Group Recalculation',

  'recalculateAttendance.calculationStory': 'Calculation Parameters',
  'recalculateAttendance.shiftInfo': 'Shift Info',
  'recalculateAttendance.inOuts': 'In/Outs',
  'recalculateAttendance.reasons': 'Reasons',
  'recalculateAttendance.summary': 'Summary',
  'recalculateAttendance.transactions': 'Transactions',
  'recalculateAttendance.gaps': 'Gaps',
  'recalculateAttendance.stepOut': 'Step outs',
  'recalculateAttendance.calculationStoryHeaders.EmployeeNo': 'Employee No',
  'recalculateAttendance.calculationStoryHeaders.EmployeeID': 'Employee ID',
  'recalculateAttendance.calculationStoryHeaders.EmployeeName': 'Employee Name',
  'recalculateAttendance.calculationStoryHeaders.NameEn': 'Name English',
  'recalculateAttendance.calculationStoryHeaders.NameAr': 'Name Arabic',
  'recalculateAttendance.calculationStoryHeaders.Date': 'Date',
  'recalculateAttendance.calculationStoryHeaders.FromTime': 'From Time',
  'recalculateAttendance.calculationStoryHeaders.ToTime': 'To Time',
  'recalculateAttendance.calculationStoryHeaders.StartTime': 'Start Time',
  'recalculateAttendance.calculationStoryHeaders.EndTime': 'End Time',
  'recalculateAttendance.calculationStoryHeaders.Duration': 'Duration',
  'recalculateAttendance.calculationStoryHeaders.Reason': 'Reason',
  'recalculateAttendance.calculationStoryHeaders.Remark': 'Remark',
  'recalculateAttendance.calculationStoryHeaders.ReaderIn': 'Reader In',
  'recalculateAttendance.calculationStoryHeaders.ReaderOut': 'Reader Out',
  'recalculateAttendance.calculationStoryHeaders.TransactionType': 'Transaction Type',
  'recalculateAttendance.calculationStoryHeaders.DateTime': 'Date Time',
  'recalculateAttendance.calculationStoryHeaders.TransactionTime': 'Transaction Time',

  'recalculateAttendance.calculationStoryHeaders.shiftDate': 'Shift Date',
  'recalculateAttendance.calculationStoryHeaders.calculatedFromTime': 'Calculated From Time',
  'recalculateAttendance.calculationStoryHeaders.calculatedToTime': 'Calculated To Time',
  'recalculateAttendance.calculationStoryHeaders.actualFromTime': 'Actual From Time',
  'recalculateAttendance.calculationStoryHeaders.actualToTime': 'Actual To Time',
  'recalculateAttendance.calculationStoryHeaders.typeName': 'Type Name',
  'recalculateAttendance.calculationStoryHeaders.firstIn': 'First In',
  'recalculateAttendance.calculationStoryHeaders.lastOut': 'Last Out',
  'recalculateAttendance.calculationStoryHeaders.delay': 'Delay',
  'recalculateAttendance.calculationStoryHeaders.earlyOut': 'Early Out',
  'recalculateAttendance.calculationStoryHeaders.actualWorkDuration': 'Actual Work Duration',
  'recalculateAttendance.calculationStoryHeaders.overTimeAfter': 'Overtime After',
  'recalculateAttendance.calculationStoryHeaders.overTimeBefore': 'Overtime Before',
  'recalculateAttendance.calculationStoryHeaders.weeklyDuration': 'Weekly Duration',
  'recalculateAttendance.calculationStoryHeaders.monthlyDuration': 'Monthly Duration',
  'recalculateAttendance.calculationStoryHeaders.readerName': 'Reader Name',
  'recalculateAttendance.calculationStoryHeaders.gapFrom': 'Gap From',
  'recalculateAttendance.calculationStoryHeaders.gapTo': 'Gap To',
  'recalculateAttendance.calculationStoryHeaders.gapMinutes': 'Gap Minutes',

  'recalculateAttendance.createRecalculation_modalTitle': 'Add Recalculation Employee(s)',
  'recalculateAttendance.recalculationDate': 'Recalculation Date',
  'recalculateAttendance.scheduleTime': 'Schedule Time',
  'recalculateAttendance.note': 'Note',
  'common.actionBy': 'Action by',

  'subordinatesRequests.lastUpdateBy': 'Last Update By',
  'subordinatesRequests.currentStatus': 'Current Status',
  'subordinatesRequests.pendingRequests': 'Pending requests',
  'subordinatesRequest.trackingRequest': 'Tracking Request',
  'subordinatesRequests.trackingRequest': 'Tracking Request',
  'subordinatesRequests.approveLeaveRequestQuestion': 'Approve Leave Request?',
  'subordinatesRequests.departmentHeadReviewDecision': 'Department head can review and make a decision.',
  'subordinatesRequests.requestDetails': 'Request Details',
  'common.stage': 'Stage',
  'common.workSchedule':'Work Schedule',
  'common.mandatory':'is Required',
  'workflow.employeeSubmission': 'Employee Submission',
  'workflow.managerApproval': 'Manager Approval',
  'workflow.noRemarksProvided': 'No remarks provided.',
  'workflow.rejectionRemark': 'Rejection Remark',
  'workflow.enterRejectionRemark': 'Enter rejection remark',
  // Workflow action result codes
  'workflow.actionResult.0': 'No result yet. Please try again.',
  'workflow.actionResult.1': 'Workflow was processed successfully.',
  'workflow.actionResult.-1': 'Unexpected system error.',
  'workflow.actionResult.-3': 'Missing required fields.',
  'workflow.actionResult.-6': 'Invalid action.',
  'workflow.actionResult.-44': 'Workflow definition not found.',
  'workflow.actionResult.-105': 'Invalid workflow stage.',
  'workflow.actionResult.defaultError': 'Failed to process workflow.',
  'leave.leaveTypeAr': 'Leave Type Ar',
  'leave.leaveTypeEn': 'Leave Type En',
  'leave.leaveType': 'Leave Type',
  'leave.employeeCategory': 'Employee Category',
  'leave.carryOverBalance': 'Carry Over Balance',
  'leave.Workflow': 'Work Flow',
  'leave.fromYear': 'From Year',
  'leave.toYear': 'To Year',
  'leave.dayBalance': 'Day Balance',
  'leave.LeaveSettingExpansion': 'Leave Setting',
  'leave.AllowedLeavesPerYear': 'Allowed Leaves Per Year',
  'leave.carryForwardLeaves': 'Carry Forward Leaves',
  'leave.includeOffDays': 'Include Off Days',
  'leave.includeHoliday': 'Include Holiday',
  'leave.NegativeDays': 'Negative Days',
  'leave.isProrateBasis': 'Is Prorate Basis',
  'leave.isCalLeavBalOnCon': 'Is Calculate Leave Balance Based On Contract',
  'leave.yourAccruedBalance': 'Your Accrued Balance',
  // Reports
  'reports.probationList': 'Probation List',
  'reports.qualificationTypeList': 'Qualification Type',
  'reports.export': 'Export List',
  'reports.inTime': 'In Time',
  'reports.delay': 'Delay',
  'reports.outTime': 'Out Time',
  'reports.earlyOut': 'Early Out',
  'reports.durationIn': 'Duration In',
  'reports.gateViolation': 'Gate Violation',
  'reports.employeeType': 'Employee Type',
  'reports.category': 'Category',
  'reports.designation': 'Designation',
  'reports.reportType': 'Report Type',
  'reports.reportStatus': 'Report Status',
  'reports.downloadPDF': 'Download (PDF)',
  'reports.downloadExcel': 'Download (Excel)',
  'reports.startTime': 'Start Time',
  'reports.endTime': 'End Time',
  'reports.consumedHours': 'Consumed Hours',
  'reports.timeReq': 'Time Req',
  'reports.permType': 'Perm Type',
  'reports.submissionDate': 'Submission Date',
  'reports.leaveDescription': 'Leave Description',
  'reports.requestsSelectionType': 'Employee Requests',
  'reports.workscheduleReport':'Work Schedule Report',
  'reports.requestsReport': 'Requests Report',
  'reports.addReportTemplate': 'Add Report Template',
  'reports.allReports': 'All Templates',
  'reports.selectAtLeastOneCategory': 'Please select at least one category for updating report template',
  'reports.selectCategoryForLeave': 'Please select the Leave category from the sidebar first',
  'reports.selectCategoryForPermission': 'Please select the Permission category from the sidebar first',
  'reports.selectCategoryForRemoteWork': 'Please select the Remote Work category from the sidebar first',
  'reports.selectCategoryForWorkSchedule': 'Please select the Work Schedule category from the sidebar first',
  'reports.noAssignments': 'No assignments added',
  'reports.selectAssignType': 'Please select an eligible type',
  'reports.selectEligibleFor': 'Please select eligible for',
  'reports.absenteesReport': 'Absentees Report',
  'reports.violations': 'Violations Report',
  'reports.violationsSelectionType': 'Violation Selection Type',
  'reports.employeeReport': 'Employee Reports',
  'report.reportName': 'Report Name',
  'reports.absentType': 'Absent Type',
  'reports.violationType': 'Violation Type',
  'reports.missingWorkDuration': 'Missing Work Duration',
  'reports.attendanceReports': 'Attendance Reports',
  'reports.auditReport':'Auditing',
  'reports.attendanceSelectionType': 'Attendance Selection Type',
  'reports.inTime': 'In Time',
  'reports.outTime': 'Out Time',
  'reports.delay': 'Delay',
  'reports.earlyOut': 'Early Out',
  'reports.durationIn': 'Duration In',
  'reports.eGate': 'E-Gate',
  'reports.shiftPlanName': 'Shift Plan',
  'reports.planTime': 'Plan Time',
  'reports.stepOut': 'Step Out',
  'reports.outReason': 'Out Reason',
  'reports.permissionCount': 'Permissions',
  'reports.permissionDuration': 'Permission Duration',
  'reports.totalDuration': 'Total Duration',
  'reports.downloadPDF': 'Download PDF',
  'reports.downloadExcel': 'Download Excel',
  'reports.noDataFound': 'Data Not Found. Adjust the filters',
  'reports.errorFound': 'Not found data',
  'reports.pleaseSelectCategory': 'Please select category',
  'reports.noSelectionFound': 'No Selection Found',
  'reports.pleaseSelectCriteria': 'Please select {criteria} in Selection Criteria (From Date / To Date)',
  'reports.selectAtLeastOneColumn': 'Select at least one Column from Category',
  'reports.selectCategory': 'Select Category',
  'reports.searchByKeyword': 'Search by Keyword',
  'reports.reportType': 'Report Type',
  'reports.untitledReport': 'Untitled Report',
  'reports.pinFailed': 'Failed to update pin',
  'reports.deleteConfirm': 'Delete',
  'reports.deleteSuccess': 'Report deleted successfully',
  'reports.deleteFailed': 'Failed to delete report',
  'reports.nameEnRequired': 'required',
  'reports.nameArRequired': 'required',
  'reports.codeRequired': 'required',
  'reports.reportSaved': 'Report',
  'reports.savedSuffix': 'saved',
  'reports.saveFailed': 'Failed to save report',
  'reports.builderReset': 'Builder reset',
  'reports.pin': 'Pin',
  'reports.edit': 'Edit',
  'reports.editing': 'Editing',
  'reports.saveAs': 'Save As',
  'reports.savedReports': 'Report Templates',
  'reports.searchReports': 'Search reports...',
  'reports.newReport': 'New Report',
  'reports.pinned': 'Pinned',
  'reports.noPinned': 'No pinned reports',
  'reports.recentlyOpened': 'Recently Opened',
  'reports.nothingOpened': 'Nothing opened yet',
  'reports.allReports': 'All Templates',
  'reports.noReports': 'No reports',
  'reports.editReport': 'Edit Report Template',
  'reports.saveReportAs': 'Add Report Template',
  'reports.saveReport': 'Add Report Template',
  'reports.reportNameEn': 'Template Name (English)',
  'reports.reportNameAr': 'Template Name (Arabic)',
  'reports.assignType': 'Assign Type',
  'reports.eligibleType': 'Eligible Type',
  'reports.submit': 'Submit',
  'reports.eligibleFor': 'Eligible For',
  'reports.publicReport': 'Public Report',
  'reports.sendNotification': 'Send Notification',
  'reports.notificationTarget': 'Notification Target',
  'reports.notificationTargetRequired': 'Please select at least one employee',
  'reports.template': 'Template',
  'reports.dateRangeLabel': 'Date Range',
  'reports.fromFormula': 'From Formula',
  'reports.toFormula': 'To Formula',
  'reports.supportedKeywords': 'Supported keywords:',
  'sidebar.lineListingFiltersReport': 'Line Listing Filters Reports',
  'common.allRequests':'All Request',
  'common.leave': 'Leave',
  'common.actionBy':'Action By',
  'common.toDateCannotBeLessThanFromDate': 'To Date cannot be less than From Date',
  'common.deleted': 'Deleted',
  'common.modified': 'Modified', 
  'common.added': 'Added',
  'common.workschedule': 'Work Schedule',
  'common.remotework': 'Remote Work',
  'common.mandatory': 'Required',
  'common.general': 'General',
  'common.employee': 'Employee',
  'common.permission': 'Permission',
  'common.personalinformation': 'Personal Information',
  'common.workinformation': 'Work Information',
  'common.workdetails': 'Work Details',
  'common.maritalstatus': 'Marital Status',
  'common.jobgrade': 'Job Grade',
  'common.groupinformation': 'Group Information',
  'common.closepanel': 'Close panel',
  'common.attendancesummary': 'Attendance Summary',
  'common.leavefromdate': 'Leave From Date',
  'common.leavetodate': 'Leave To Date',
  'common.leavecount': 'Leave Count',
  'common.leavetype': 'Leave Type',
  'common.leavetypearb': 'Leave Type ARB',
  'common.leaveremark': 'Leave Remark',
  'common.leaveyear': 'Leave Year',
  'common.leavequarter': 'Leave Quarter',
  'common.leavemonth': 'Leave Month',
  'common.leavemonthname': 'Leave Month Name',
  'common.leavestatusarb': 'Leave Status ARB',
  'common.permissiontype': 'Permission Type',
  'common.permissiontypearb': 'Permission Type ARB',
  'common.permissiondate': 'Permission Date',
  'common.permissionfromtime': 'Permission From Time',
  'common.permissiontotime': 'Permission To Time',
  'common.permissionremark': 'Permission Remark',
  'common.remoteworkfromdate': 'Remote Work From Date',
  'common.remoteworktodate': 'Remote Work To Date',
  'common.remoteworkdayscount': 'Remote Work Days Count',
  'common.workeddays': 'Worked Days',
  'common.absentdays': 'Absent Days',
  'common.leavedays': 'Leave Days',
  'common.holidaydays': 'Holiday Days',
  'common.weekenddays': 'Weekend Days',
  'common.latein': 'Late In',
  'common.earlyout': 'Early Out',
  'common.stepout': 'Step Out',
  'common.overtime': 'Overtime',
  'common.totalworkduration': 'Total Work Duration',
  'common.missingpunch': 'Missing Punch',
  'common.intime': 'In Time',
  'common.outtime': 'Out Time',
  'common.duration': 'Duration',
  'common.violation': 'Violation',
  'common.remark': 'Remark',
  'common.sn': 'S.N.',
  'common.date': 'Date',
  'common.status': 'Status',
  'common.employeeno': 'Employee Number',
  'common.name': 'Name',
  'common.namearb': 'Name (Arabic)',
  'common.nameen': 'Name (English)',
  'common.mobileno': 'Mobile No',
  'common.email': 'Email',
  'common.dateofbirth': 'Date of Birth',
  'common.age': 'Age',
  'common.nationalityarb': 'Nationality (Arabic)',
  'common.gender': 'Gender',
  'common.maritialstatus': 'Marital Status',
  'common.religion': 'Religion',
  'common.bloodgroup': 'Blood Group',
  'common.joiningdate': 'Joining Date',
  'common.employeeid': 'Employee ID',
  'common.department': 'Department',
  'common.delay': 'Delay',
  'common.missingworkduration': 'Missing Work Duration',
  'common.categoryarb': 'Category (Arabic)',
  'common.category': 'Category',
  'common.violationtype': 'Violation Type',
  'common.remarks': 'Remarks',
  'common.designation': 'Designation',
  'common.company': 'Company',
  'common.entity': 'Department',
  'common.group': 'Group',
  'common.grade': 'Grade',
  'common.worklocation': 'Work Location',
  'common.supervisor': 'Supervisor',
  'common.status': 'Status',
  'common.employee': 'Employee',
  'common.leave': 'Leave',
  'common.permission': 'Permission',
  'common.remotework': 'Remote Work',
  'common.workschedule': 'Work Schedule',
  'common.leavestatus': 'Leave Status',
  'common.leavecreatedby': 'Leave Created By',
  'common.leavecreatedbyarb': 'Leave Created By (Arabic)',
  'common.leavelastactionby': 'Leave Last Action By',
  'common.leavelastactionbyarb': 'Leave Last Action By (Arabic)',
  'common.managername': 'Manager Name',
  'common.managernamearb': 'Manager Name (Arabic)',
  'common.designationarb': 'Designation (Arabic)',
  'common.employeestatus': 'Employee Status',
  'common.employeestatusarb': 'Employee Status (Arabic)',
  'common.worklocationarb': 'Work Location (Arabic)',
  'common.genderarb': 'Gender (Arabic)',
  'common.gradearb': 'Grade (Arabic)',
  'common.religionarb': 'Religion (Arabic)',
  'common.joindate': 'Join Date',
  'common.cardno': 'Card Number',
  'common.terminationdate': 'Termination Date',
  'common.managerno': 'Manager Number',
  'common.ismanager': 'Is Manager',
  'common.username': 'Username',
  'common.terminationreason': 'Termination Reason',
  'common.terminationreasonarb': 'Termination Reason (Arabic)',
  'lookup.export': 'Export',
  'lookup.metricsRequired': 'metrics field is require',
  'lookup.selectAtLeastOneMetric': 'Please select at least one metrics.',
  'lookup.selectAtLeastOneDetail': 'Please select at least one details.',
  'lookup.notificationDetailTooltip': 'This e-mail will be triggered on 1st day of the month.',
  'lookup.unnamedModule': 'Unnamed Module',
  'lookup.unnamedSection': 'Unnamed Section',
  'lookup.unnamedPermission': 'Unnamed Permission',
  'lookup.saveErrorTitle': 'Unable to save {lookup}',
  'lookup.saveErrorMessage': 'Unable to save {lookup}. Please try again.',
  'lookup.required': 'Required',
  'lookup.pleaseFixFollowingFields': 'Please fix the following fields',
  'lookup.pleaseFillRequiredFields': 'Please fill all required fields',
  'lookup.pleaseFillRequiredFieldsInGeneralTab': 'Please fill the required fields in the General tab',
  'lookup.pleaseSelectAtLeastOnePermissionForUserRole': 'Please select at least one permission for this user role',
  'lookup.pleaseSelectAtLeastOneEmployeeForGroup': 'Please select at least one employee for this group',
  'lookup.userRole.error.defaultAlreadyExists': 'A default user role already exists',
  'lookup.module': 'Module',
  'lookup.untitledSection': 'Untitled Section',
  'lookup.permissionSettingsFor': 'Permission settings for {module}',
  'lookup.fullMenuAccess': 'Full Menu Access',

  // Employee Personal Information
  'employee.employeeNotExistWithNo':
    'This employee number is not exists. Please add another employee number',
  'employee.addEmployeeNo': 'Please add employee no',
  'employee.personalInformation': 'Personal Information',
  'employee.emailAddress': 'Email Address',
  'employee.employeeNumber': 'Employee Number',
  'employee.employeeName': 'Employee Name',
  'employee.virtualLocations': 'Virtual Locations',
  'employee.virtualLocation': 'Virtual Location',
  'employee.fromDate': 'From Date',
  'employee.toDate': 'To Date',
  'employee.virtualLocationFieldsRequired': 'Virtual Location, From Date, and To Date are all required fields',
  'employee.addVirtualLocation': 'Add Virtual Location',
  'employee.editVirtualLocation': 'Edit Virtual Location',
  'employee.virtualLocationPlaceholder': 'e.g. Remote - Dubai',
  'employee.virtualLocationRemarksPlaceholder': 'Optional notes',
  'employee.virtualLocationCreateSuccess': 'Virtual location created successfully',
  'employee.virtualLocationCreateFailed': 'Failed to create virtual location',
  'employee.virtualLocationDeleteSuccess': 'Virtual location deleted successfully',
  'employee.virtualLocationBulkDeleteSuccess': 'Selected virtual locations deleted successfully',
  'employee.deleteVirtualLocationConfirm': 'Are you sure you want to delete this virtual location?',
  'employee.deleteVirtualLocationBulkConfirm': 'Are you sure you want to delete the selected virtual locations?',
  'common.recordSavedSuccessfully': 'Record saved successfully',
  'employee.passportFamilyBook': 'Passport & Family Book',
  'employee.employeeQualification': 'Employee Qualification',
  'employee.employeeWorkExperience': 'Employee Work Experience',
  'employee.employeeAppraisal': 'Employee Appraisal',
  'employee.employeeExtraFields': 'Employee Extra Fields',
  'employee.loginInformation': 'Login Information',
  'employee.employeeGroups': 'Employee Groups',
  'employee.employmentInformation': 'Employment Information',
  'employee.contact': 'Contact Information',
  'employee.selectLanguage': 'Select a Language',
  'employee.name': 'Employee Name',
  'employee.employeeNo': 'Employee Number',
  'employee.empNo': 'Emp',
  'employee.addRecord': 'Add Employee Appraisal Record',
  'employee.year': 'Year',
  'employee.finalResult': 'Final Result',
  'employee.supervisor': 'Manager',
  'employee.addExtraFields': 'Add Employee Extra Fields',
  'employee.basicSalary': 'Basic Salary',
  'employee.promotionDate': 'Promotion Date',
  'employee.threeMEvaluation': '3M Evaluation',
  'employee.sixMEvaluation': '6M Evaluation',
  'employee.certificate': 'Certificate',
  'employee.otherInformation': 'Other Information',
  'employee.addEmployeeQualification': 'Add Employee Qualification',
  'employee.qualificationType': 'Qualification Type',
  'employee.startDate': 'Start Date',
  'employee.endDate': 'End Date',
  'employee.title': 'Title',
  'employee.status': 'Status',
  'employee.gpa': 'GPA',
  'employee.establishment': 'Establishment',
  'employee.equivalence': 'Equivalence',
  'employee.country': 'Country',
  'employee.active': 'Active',
  'employee.addEmployeeWorkExperience': 'Add Employee Work Experience',
  'employee.employer': 'Employer',
  'employee.type': 'Type',
  'employee.jobTitle': 'Job Title',
  'employee.years': 'Years',
  'employee.months': 'Months',
  'employee.employerName': 'Employer Name',
  'employee.address': 'Address',
  'employee.department': 'Department',
  'employee.selectDepartment': 'Select a Department',
  'employee.designation': 'Designation',
  'employee.selectDesignation': 'Select a Designation',
  'employee.jobGrade': 'Job Grade',
  'employee.selectJobGrade': 'Select a Job Grade',
  'employee.employmentType': 'Employment Type',
  'employee.selectEmploymentType': 'Select an Employment Type',
  'employee.joinDate': 'Join Date',
  'employee.selectStatus': 'Select a Status',
  'employee.manager': 'Manager',
  'employee.selectManager': 'Select a Manager',
  'employee.managerStartDate': 'Manager Start Date',
  'employee.workLocation': 'Work Location',
  'employee.selectWorkLocation': 'Select a Work Location',
  'employee.annualLeaveBalance': 'Annual Leave Balance',
  'employee.upcomingHoliday': 'Upcoming Holiday',
  'employee.leaveBalance': 'Leave Balance',
  'employee.leaveSummary': 'Leave Summary',
  'employee.excludeAbsentViolation': 'Exclude Absent Violation',
  'employee.excludeAllViolation': 'Exclude All Violation',
  'employee.userName': 'Username',
  'employee.selectUserType': 'Select a User Type',
  'employee.password': 'Password',
  'employee.confirmPassword': 'Confirm Password',
  'employee.userType': 'User Type',
  'employee.familyBookNo': 'Family Book No',
  'employee.familyNo': 'Family No',
  'employee.familyTownNo': 'Family Town No',
  'employee.unifiedNo': 'Unified No',
  'employee.passportNo': 'Passport No',
  'employee.cardNo': 'Card No',
  'employee.nameEn': 'Employee Name English',
  'employee.nameAr': 'Employee Name Arabic',
  'employee.shortNameEn': 'Short Name English',
  'employee.shortNameAr': 'Short Name Arabic',
  'employee.level1': 'Level-1',
  'employee.gender': 'Gender',
  'employee.userRole': 'User Role',
  'employee.nationality': 'Nationality',
  'employee.religion': 'Religion',
  'employee.dateOfBirth': 'Date of Birth',
  'employee.email': 'Email Address',
  'employee.language': 'Language',
  'employee.phone': 'Phone',
  'employee.mobile': 'Mobile',
  'employee.emiratesID': 'Emirates ID',
  'employee.ID': 'ID',
  'employee.cardExpiryDate': 'Card Expiry Date',
  'employee.maritalStatus': 'Marital Status',
  'employee.employeeCategory': 'Employee Category',
  'employee.reason': 'Reason',
  'employee.terminateDate': 'Terminate Date',
  'employee.cardType': 'Card Type',
  'employee.remarks': 'Remarks',
  'employee.update': 'Update',
  'employee.placeOfBirth': 'Place of Birth',
  'employee.profile': 'Profile',
  'employee.upload': 'Upload',
  'employee.productManager': 'Product Manager',
  'employee.productDepartment': 'Product Department',
  'employee.dragDropUpload': 'Click to Upload Image',
  'employee.entityLevelLabel': 'Level ',
  'employee.terminatedDate': 'Terminated Date',
  'employee.exportEmployeeData': 'Export Employee Data',
  'employee.user': 'User',
  'employee.propertyName': 'Property Name',
  'employee.oldValue': 'Old Value',
  'employee.newValue': 'New Value',
  'employee.time': 'Time',
  'employee.userDetails': 'User Details',
  'employee.employeeDetails': 'Employee Details',
  'employee.workDetails': 'Work Details',
  'employee.employeeContract': 'Contract',
  'employee.contractNo': 'Contract No',
  'employee.contractStatus': 'Contract Status',
  'employee.isTaskeen': 'Taskeen',
  'employee.hasProbationalPeriod': 'Employee has Probational Period',
  'employee.probationalPeriodEndDate': 'Probational Period End Date',
  'employee.deleteEntryConfirmMsg':
    'You have to click on save. Once the entry is deleted?',
  'employee.selectCountry': 'Select a Country',
  'employee.sameDataEntryOfWorkExperience':
    'Date period with employer already exist',
  'employee.dofjoinDate': 'DOF Join Date',
  'employee.sameDataEntryOfQualification': 'Qualification already exist',
  'employee.promotionType': 'Promotion Type',
  'employee.totalExperienceYear': 'Total Experience (Year)',
  'employee.totalExperienceMonth': 'Total Experience (Month)',
  'lookup.employementStatus': 'Status',
  'employee.organizationName': 'Organization Name',
  'employee.organization': 'Company',
  'employee.organizationHierarchy': 'Department',
  'employee.profile': 'Employee Profile',
  'employee.profileTable': 'Employee Profile Table',
  'employee.updateEmployee': 'Update Employee',
  'employee.list': 'Employee List',
  'employee.grid': 'Employee Grid',
  'employee.page': 'Employee',
  'employee.addEmployee': 'Add Employee',
  //Exception
  'exception.addExceptions': 'Add Exception',
  'exception.employeeException': 'Employee Exception',
  'exception.exceptionFor': 'Exception For',
  'exception.title': 'Employee Exceptions',

  'delegation.title': 'Employee Delegations',

  //holiday
  'holiday.holidays': 'Holidays',
  'holiday.updateHolidayPeriod': 'Update Holiday Period',
  'holiday.newHolidayPeriod': 'New Holiday Period',

  //Manual Entry
  'manualEntry.AddManualEntry': 'Add Manual Entry',
  'manualEntry.EditManualEntry': 'Edit Manual Entry',
  'manualEntry.transactionType': 'Transaction Type',
  'manualEntry.entryType': 'Entry Type',
  'manualEntry.manualEntry': 'Manual Entry',
  'manualEntry.manualEntryHR': 'People Management Manual Entry',
  'manualEntry.in': 'In',
  'manualEntry.out': 'Out',
  'manualEntry.pleaseSelect': '-- Please Select --',

  // Form
  'form.formNameEn': 'Form Name En',
  'form.formNameAr': 'Form Name Ar',
  'form.elementType': 'Element Type',
  'form.formBuilder': 'Form Builder',

  // Update Supervisor
  'supervisor.assignmentType': 'Assignment Type',
  'supervisor.title': 'Update Manager',
  'supervisor.supervisor': 'Manager',
  'supervisor.searchEmployeeList': 'Search Employee List',
  'supervisor.selectEntity': 'Select an Entity',
  'supervisor.selectDesignation': 'Select a Designation',

  //   Permission Type
  'permissionType.permissionSetting': 'Permission Setting',
  'permissionType.permissionType': 'Permission Type',
  'permissionType.workFlow': 'WorkFlow Setting',
  'permissionType.minDuration': 'Min Duration',
  'permissionType.maxDuration': 'Max Duration',
  'permissionType.allowedBeforeDays': 'Allowed Before Days',
  'permissionType.allowedAfterDays': 'Allowed After Days',
  'permissionType.dailyLimit': 'Daily Limit',
  'permissionType.monthlyLimit': 'Monthly Limit',
  'permissionType.minWorking': 'Min Working Per Day',
  'permissionType.grace': 'Grace',
  'permissionType.considerInWork': 'Consider In Work',
  'permissionType.selfService': 'Show In Self Service Cards',
  'permissionType.showHr': 'Only For HR',
  'permissionType.enableDate': 'Enable Date',
  'permissionType.minDuration_Ramadan': 'Min Duration Ramadan',
  'permissionType.maxDuration_Ramadan': 'Max Duration Ramadan',
  'permissionType.minWorkingPerDay_Ramadan': 'Min Working Per Day Ramadan',
  'permissionType.montlyLimitHH': 'Monthly Limit (HH)',
  'permissionType.montlyLimitMM': 'Monthly Limit (MM)',

  // Group Builder
  'group.employeeGroupType': 'Employee Group Type',
  'group.groupName': 'Group Name',
  'group.groupArabicName': 'Group Arabic Name',
  'group.groupType': 'Group Type',
  'group.selectGroupType': 'Select a Group Type',
  'group.parentGroup': 'Parent Group',
  'group.selectParentGroup': 'Select a Parent Group',
  'group.selectDesignation': 'Select a Designation',
  'group.selectEntity': 'Select an Entity',

  // ramadan
  'ramadan.ramadanPeriod': 'Ramadan Period',
  'ramadan.newRamadanPeriod': 'New Ramadan Period',
  'ramadan.updateRamadanPeriod': 'Update Ramadan Period',

  //break duration
  'breakDuration.breakDurationDetails': 'Break Duration Details',
  'breakDuration.editBreakDuration': 'Edit Break Duration',
  'breakDuration.addBreakDuration': 'Add Break Duration',

  'breakDefinition.breakDefinitionDetails': 'Break Management Details',
  'breakDefinition.editBreakDefinition': 'Edit Break Management',
  'breakDefinition.addBreakDefinition': 'Add Break Management',

  'breakDuration.nameEn': 'NameEn',
  'breakDuration.nameAr': 'NameAr',
  'breakDuration.code': 'Code',
  'breakDuration.duration': 'Duration',
  'breakDuration.startTime': 'Start Time',
  'breakDuration.endTime': 'End Time',

  'breakDefinition.createdSuccessfully': 'Break Created Successfully',
  'breakDefinition.updatedSuccessfully': 'Break Updated Successfully',

  //attendance duration
  'attendanceDuration.attendanceDurationDetails': 'Attendance Duration Details',
  'attendanceDuration.editAttendanceDuration': 'Edit Attendance Duration',
  'attendanceDuration.addAttendanceDuration': 'Add Attendance Duration',
  'attendanceDuration.minutes': 'Minutes',
  'attendanceDuration.saveSuccess': 'Shift Pattern Saved Successfully',
  'attendanceDuration.updateSuccess': 'Shift Pattern Updated Successfully',
  'attendanceDuration.invalidTimeValues': 'Invalid Time Values',
  'attendanceDuration.invalidTimeValuesMsg': 'Please fix the time validation errors before saving.',
  'attendanceDuration.unsavedChanges': 'Unsaved Changes',
  'attendanceDuration.unsavedChangesMsg': 'You have unsaved changes. Are you sure you want to discard them?',
  'attendanceDuration.workScheduleTypeChanged': 'Work Schedule Type Changed',
  'attendanceDuration.workScheduleTypeChangedMsg': 'You are changing the work schedule type. Your data will be lost.',
  'attendanceDuration.flexStartTime': 'Flex Start Time',
  'attendanceDuration.flexEndTime': 'Flex End Time',
  'attendanceDuration.coreStartTime': 'Core Start Time',
  'attendanceDuration.coreEndTime': 'Core End Time',

  //temporary schedule
  'temporarySchedule.assignTemporarySchedule': 'Assign Temporary Shift',
  'temporarySchedule.editAssignTemporarySchedule':'Edit Temporary Shift',
  'temporarySchedule.addAssignTemporarySchedule':'Assign Temporary Shift',
  'temporarySchedule.selectionRequired':"Selection Required",
  'temporarySchedule.selectEmployeeAndShiftMsg':"Please select employee and shift pattern",
  'temporarySchedule.selectEmployeeMsg':"Please select employee",
  'temporarySchedule.selectShiftPatternMsg':"Please select shift pattern",

  // define work schedule
  'shiftWorkSchedule.editShift': 'Edit Shift Plan',
  'shiftWorkSchedule.addShift': 'Add Shift Plan',
  // 'shiftWorkSchedule.shiftNameEn' : 'Shift Name En',
  // 'shiftWorkSchedule.shiftNameAr' : 'Shift Name Ar',
  // 'shiftWorkSchedule.cycle' : 'Cy',
  'shiftWorkSchedule.genSettings': 'Shift Pattern',
  'shiftWorkSchedule.confirmTabSwitch': 'Confirm Tab Switch',
  'shiftWorkSchedule.confirmTabSwitchMessage': 'Are you sure you want to switch the plan? All unsaved shifts in the current schedule will be cleared.',

  // Notification
  'notification.addNotification': 'Add Notification',
  'notification.editNotification': 'Edit Notification',
  'notification.objectivesForms': 'General Settings',
  'notification.objectivesEmail': 'Email Settings',
  'notification.objectivesMessage': 'Message Settings',
  'notification.permissionScheduleValidData':
    'Invalid Time Selection: Please select a start time and end time within your work schedule.',
  'notification.notificationKind': 'Notification Kind',
  'notification.name': 'Name',
  'notification.nameEn': 'Name English',
  'notification.nameAr': 'Name Arabic',
  'notification.code': 'Code',
  'notification.templateType': 'Template Type',
  'notification.notificationType': 'Notification Type',
  'notification.notificationFor': 'Notification For',
  'notification.notificationSchedule': 'Notification Schedule',
  'notification.ccAssignType': 'CC. Assign Type',
  'notification.ccTargetGroup': 'CC. Target Group/Emp',
  'notification.triggerFirstDayOfMonth': 'Trigger on first day of month',
  'notification.objectivesEmail': 'Email Template',
  'notification.objectivesMessage': 'Message Template',
  'notification.editorInstructions': 'Use the editor below to compose your notification.',
  'notification.notificationParameters': 'Notification Parameters',
  'notification.templateSubject': 'Template Subject',
  'notification.notificationSubjectEn': 'Notification Subject English',
  'notification.notificationSubjectAr': 'Notification Subject Arabic',
  'notification.preview': 'Preview',
  'notification.subjectEnLabel': 'Subject (English)',
  'notification.subjectArLabel': 'Subject (Arabic)',
  'notification.systemNotificationEnLabel': 'System Notification (English)',
  'notification.systemNotificationArLabel': 'System Notification (Arabic)',
  'notification.bodyEnLabel': 'Body (English)',
  'notification.bodyArLabel': 'Body (Arabic)',
  'notification.templateBody': 'Template Body',
  'notification.notificationBuilder': 'Notification Builder',
  'notification.assignType': 'Assign Type',
  'notification.targetGroup': 'Target Group/Emp',
  'notification.notificationInterval': 'Notification Interval',
  'notification.periodType': 'Period Type',
  'notification.parameter': 'Parameter',
  'notification.selectedParameters': 'Selected Parameters',
  'notification.noParameterSelected': 'No Parameter Selected.',
  'notification.periodTypeRequired': 'Please select a period type',
  'notification.metrics': 'Metrics',
  'notification.details': 'Details',
  'notification.days': 'Days',
  'notification.detectContinuousAbsence': 'Detect continuous absence ≥',
  'notification.reportType': 'Report Type',
  'notification.selectReport': 'Select Report',
  'notification.attendance': 'Attendance',
  'notification.violations': 'Violations',
  'notification.employeeRequests': 'Employee Requests',
  'notification.continuousAbsence': 'Continuous Absence',
  'notification.customReport': 'Custom Report',
  'notification.attachmentFormat': 'Attachment Format',
  'notification.attachmentFormat.none': 'None',
  'notification.attachmentFormat.excel': 'Excel',
  'notification.attachmentFormat.html': 'HTML',
  'notification.attachmentFormat.htmlInBody': 'HTML in Body',
  'notification.attachmentFormat.excelHtml': 'Excel + HTML',
  'notification.attachmentFormat.excelHtmlInBody': 'Excel + HTML in Body',
  'notification.attachmentFormat.htmlHtmlInBody': 'HTML + HTML in Body',
  'notification.attachmentFormat.all': 'All',
  'notification.notificationScope': 'Notification Scope',
  'notification.scope.none': 'None',
  'notification.notificationTypeSubjectEn': 'Notification Type Subject English',
  'notification.notificationTypeSubjectAr': 'Notification Type Subject Arabic',
  'notification.notificationTypeBodyEn': 'Notification Type Body English',
  'notification.notificationTypeBodyAr': 'Notification Type Body Arabic',
  'notification.success': 'Success',
  'notification.created': 'Created',
  'notification.badRequest': 'Bad Request',
  'notification.unauthorized': 'Unauthorized',
  'notification.internalServerError': 'Internal Server Error',
  'notification.requiredFields': 'Please Fill All Required Fields',
  'notification.templateBodyEn': 'Template Body En',
  'notification.templateBodyAr': 'Template Body Ar',
  'notification.notificationBodyEn': 'Notification Body English',
  'notification.notificationBodyAr': 'Notification Body Arabic',
  'notification.parametersList': 'Notification Parameters ',
  'notification.employeeWorkScheduleReports': 'Employee Work Schedule Reports',
  'notification.employeeWorkScheduleSelectionType':
    'Employee Work Schedule Selection Type',
  'notification.emptyExport': 'Please ensure at least one item is selected.',
  'notification.addStage':
    'Please ensure stage order is not taken and select all required fields',
  'notification.leaveValidDataDifferentYear':
    'Please select from date and to date in same year',
  'error.parametersList': 'Please select at least one parameter',
  'error.bodyEn': 'Please enter at least 2 characters',
  'error.bodyAr': 'Please enter at least 2 characters',
  'notification.objectivesForms': 'Objectives Forms',
  'notification.objectivesEmail': 'Objectives Email',
  'notification.objectivesMessage': 'Objectives Message',
  'notification.editorInstructions': 'Kindly start by entering the content in the editor, and ensure that the notification parameter is added afterward.',
  'notification.triggerFirstDayOfMonth': 'This e-mail will be triggered on 1st day of the month.',
  'notification.subjectEnLabel': 'Subject En',
  'notification.subjectArLabel': 'Subject Ar',
  'notification.systemNotificationEnLabel': 'System Notification En',
  'notification.systemNotificationArLabel': 'System Notification Ar',
  'notification.bodyEnLabel': 'Body En',
  'notification.bodyArLabel': 'Body Ar',
  'common.workDays': 'Work Days',
  'common.richText': 'Rich Text',
  'common.rawHtml': 'Raw HTML',
  'common.validation': 'Validation',
  'common.updateFailed': 'Update failed',
  'common.saveFailed': 'Save failed',
  'common.updateOperationFailed': 'Update operation failed',
  'common.saveOperationFailed': 'Save operation failed',
  'notification.specificEmployee': 'Specific Employee',
  'notification.group': 'Group',
  'notification.directManager': 'Direct Manager',
  'notification.requester': 'Requester',


  approvalRequiredFields:
    'Please Add Approval Levels & Fill All Required Fields',
  leaveBalanceCheck: 'Requested Leaves are greater than Balance',
  permissionValidData: 'Please enter valid inputs',
  approvalExistsRequest:
    'The request cannot be deleted because its status has already been updated.',
  permissionSameYear: 'fromDate and toDate are not in the same year',
  leaveValidData: 'Please enter valid inputs',
  emailValidation: 'Please enter valid email',

  employeeNoCardCheck:
    'Either the username, email, employee number, or card number has already been used. Please note that all of these fields must be unique.',
  exportFinished:
    'Exported successfully, Please check the download folder to find the exported list.',
  allowedDayPerMonthIsLessThanAllowedDayPerYear:
    'Allowed Day Per Month should be less than allowed day per year',
  allowedDayPerMonthIsGraterThanZero:
    'Allowed Day Per Month should be greater than 0',
  allowedDayPerYearIsGraterThanZero:
    'Allowed Day Per Year should be greater than 0',

  200: 'Success',
  201: 'Created',
  400: 'Bad Request',
  401: 'Unauthorized',
  500: 'Something went wrong',
  600: 'Please Fill All Required Fields',
  555: 'The Name (Arabic), Name (English) and code must be unique. Please enter different values.',
  '-1': 'Please Add Approval Levels & Fill All Required Fields',
  '-99': 'Requested Leaves are greater than Balance',
  409: 'This Item Is Already In Used',
  overlapWorkSchedule:
    'You have overlap between work schedules, Please check your input',
  overlapPermissionType:
    'You have overlap between permission type, Please check your input',
  overlapLeaveSetting:
    'You have overlap between leave type, Please check your input',
  lessDuration:
    'The requested duration is less than the minimum allowed duration.',
  greatDuration: 'The requested duration exceeds the maximum allowed duration.',
  exceedDailyLimit: 'The requested duration exceeds the daily limit.',
  exceedAllowedAfterDays: "The request exceeds the allowed 'after' days limit.",
  exceedAllowedBeforeDays:
    "The request exceeds the allowed 'before' days limit.",
  exceedMonthlyLimit:
    'The request exceeds the monthly limit for permission usage.',
  exceedMonthlyLimitPermissionRequest:
    'You are exceeding your monthly limit of',
  generalError: 'Please check the permission request data',
  AlreadyHaveOnePemissionInSameRange:
    'You already have one permission in same time range',
  fromAndToDateNotSameYear: 'From date and to date are not in same year',
  updateLeaseApprovalStarted:
    'You are trying to update the lease and the approval process has already started.',
  requestAfterTerminationDate:
    'You are trying to make the request after the termination date.',
  overlapWithOldLeaveRequest:
    'There is an overlap between the request and the old leave request.',
  exceedLimitForRequest:
    'You have exceeded the limit to apply for this request.',
  fromTimeNotGreaterThanToTime: 'From time is not greater than to time',
  overlapException: 'You have overlap between Exception',
  overlapRemoteWork: 'You have overlap between remote work',
  notApplyLeaveBeforeJoinDate: 'You can not apply leave before joining date',
  notEligibleToTakeRemoteWork:
    'You are not eligieble to take remote work in date range',
  overlapRemoteWorkSetting:
    'You have overlap between remote work, Please check your input',
  fromDateToDateNotInSameYear: 'FromDate and ToDate are not in the same year',
  overlappingRemoteWorkRequest:
    'Overlapping remote work request exists for the given date range',
  overlappingLeaveRequest:
    'Overlapping leave request exists for the given date range',
  noActiveRemoteWorkSetting:
    'No active remote work setting found for the employee',
  yearlyLimitExceeded: 'Yearly Exceed',
  monthlyLimitExceeded: 'Monthly limit exceeded for the given month(s)',
  overlappingWithRemoteWork: 'You have overlapping with remote work',
  overlapMissingGateTransaction:
    'You have overlap between missing gate transaction, Please check your input',

  // Login
  'login.signIn': 'Sign In',
  'login.activeDirectory': 'Active Directory',
  'login.userName': 'Username',
  'login.password': 'Password',
  'login.login': 'Login',
  'login.text': 'Enter your email and password to sign in!',
  'login.error': 'Username or password is incorrect',
  'login.tooManyAttempts': 'Too many login attempts. Please wait a minute and try again.',

  //logout
  'logout.header': 'You have been logged out.',
  'logout.body_part_1': 'Please click',
  'logout.body_part_2': 'here',
  'logout.body_part_3': 'if you want to log in again.',

  'error.isRequired': 'Required',
  'common.verifiedSuccessfully': 'Verified successfully',
  'error.required': 'Required',
  'error.enterAValid': 'Enter a valid',
  'error.enterAValidFormat': 'Enter a valid format',
  'error.enterThe': 'Enter the',
  'error.enterA': 'Enter a',
  'error.validationError':
    'Please fill in all fields marked with a red star (*)',
  'error.ProbationPeriodDateNotLessThanJoiningDate':
    'Probation Period Date should not be less than Joining Date.',
  'error.TerminatedDateNotLessThanJoiningDate':
    'Terminated Date should not be less than Joining Date.',
  'error.invalidEmiratesIDFormat': 'Invalid Emirates ID format.',
  'error.endDateGraterThanStartDate':
    'End time cannot be earlier than start time',
  'error.yearIsAlreadyExist': 'Year is Already Exist',
  'error.atLeast2Character': 'At Least 2 letters',
  'error.toDateNotEarlierThanFromDate':
    'To date cannot be earlier than the from Date.',
  'error.forThisPermission': 'for this permission',
  'error.must18YearsOld': 'You must be at least 18 years old.',
  'error.must10YearsOld': 'You must be at least 10 years old.',
  'error.selectValidDate': 'Please select valid date',
  'error.startDateIsRequired': 'Start Date is Required',
  'error.endDateNotEarlierThanstartDate':
    'End date cannot be earlier than the start date',
  'error.pleaseSelectCorrectValue': 'Please Select Correct Value',
  'error.pleaseSelectValidYear': 'Please Select Valid Year',
  'error.selectFromYear': 'Please select From Year',
  'error.selectFromMonth': 'Please select From Month',
  'error.selectToYear': 'Please select To Year',
  'error.selectToMonth': 'Please select To Month',
  'error.toYearMustBeGreaterOrEqual': 'To Year must be greater than or equal to From Year',
  'error.toMonthMustBeGreaterOrEqual': 'To Month must be greater than or equal to From Month',
  'error.validAge': 'Age must be 1 to 100',
  'missingGateTransaction.addMissingGateTransaction':
    'Add Missing Gate Transaction',
  'error.fromTimeCannotBeZero': 'From Time cannot be 00:00',
  'error.toTimeCannotBeZero': 'To Time cannot be 00:00',
  'error.fromTimeNotGreaterThanToTime': 'From Time must be less than To Time',
  pleaseSelectAtleaseColumn: 'Please select atlease one column',
  pleaseSelectAtleaseOneEmployee: 'Please select atlease one employee',
  employeeNotExist:
    'Some employee no are not exists in the system.Please check it again ',
  confirmUpdateBulEmployee:
    'Are you sure you want to update selected employees',
  overlapHoliday: 'Holiday overlaps with an existing one.',
  employeeEntitiesPrivilege: 'Employee Entities Privilege',
  enitityList: 'Entity List',
  'common.directEmployee': 'Direct Employee',
  'common.January': 'January',
  'common.February': 'February',
  'common.March': 'March',
  'common.April': 'April',
  'common.May': 'May',
  'common.June': 'June',
  'common.July': 'July',
  'common.August': 'August',
  'common.September': 'September',
  'common.October': 'October',
  'common.November': 'November',
  'common.December': 'December',
  contractNo: 'Contract Number',
  contractList: 'Contract List',
  employeeContact: 'Employee Contract',
  overlapContract: 'You have overlap between contract, Please check your input',
  toDateLessThanMonthFromDate: 'To date cannot be same or less than one month',
  leaveWithinContactDate:
    "Please ensure the leave is within the contract's valid dates.",
  leaveExceedsMaxNumberDays:
    'This leave exceeds the maximum number of days permitted by your contract.',
  contractFromDate: 'Contract From Date',
  contractToDate: 'Contract To Date',
  notValidContract: 'You do not have valid contract in the selected date range',
  ensureLeaveWithIn: 'Please ensure the leave is within the',
  employeeContractInUsed:
    'You cannot do this action, Employee Contract is in used',
  selectValidDateRemoteWorkRange:
    'You are not eligible to take remote work in the selected date range.',
  selectValidDatePermissionRange:
    'You are not eligible to take permission in the selected date range.',
  remoteWorkNotPermitted:
    'Remote work is not permitted for the selected employee within the specified date range.',
  permissionNotPermitted:
    'Permission is not permitted for the selected employee within the specified date range.',

  // dashboard pin
   'dashboard.pinatDashboard': 'Pin at Dashboard',
  'dashboard.unpinFromDashboard': 'Unpin from Dashboard',
  'dashboard.unpinFromDashboard': 'Unpin from Dashboard',

  //settings
  'setting.leaveTypeAr': 'Leave Type Ar',
  'setting.leaveTypeEn': 'Leave Type En',
  'setting.leavetype': 'Leave Type',
  'setting.employeeCategory': 'Employee Category',
  'setting.carryOverBalance': 'Carry Over Balance',
  'setting.workflow': 'Work Flow',
  'setting.fromYear': 'From Year',
  'setting.toYear': 'To Year',
  'setting.fromyear': 'From Year',
  'setting.toyear': 'To Year',
  'setting.frommonth': 'From Month',
  'setting.tomonth': 'To Month',
  'setting.fromMonth': 'From Month',
  'setting.toMonth': 'To Month',
  'setting.dayBalance': 'Day Balance',
  'setting.LeaveSettingExpansion': 'Leave Setting',
  'setting.allowedleavesperyear': 'Allowed Leaves Per Year',
  'setting.carryforwardleaves': 'Carry Forward Leaves',
  'setting.includeoffdays': 'Include Off Days',
  'setting.includeholiday': 'Include Holiday',
  'setting.includeOffdays': 'Include Off Days',
  'setting.includeHoliday': 'Include Holiday',
  'setting.negativedays': 'Negative Days',
  'setting.negativeDays': 'Negative Days',
  'setting.proratebasis': 'Is Prorate Basis',
  'setting.prorateBasis': 'Is Prorate Basis',
  'setting.iscalleavbaloncon': 'Is Calculate Leave Balance Based On Contract',
  'setting.remoteworkrequests': 'Remote Work Requests',
  'setting.newremoteworkrequest': 'Add Remote Work Request',
  'setting.editremoteworkrequest': 'Edit Remote Work Request',
  'setting.remotevaliddata': 'Please check your request',
  'setting.onlinePunchInOut': 'Online Punch IN/OUT',
  'setting.checkscheduletiming':'Enable During Schedule Timing (Punch IN/OUT)',
  'setting.RemoteWorkSettingExpansion': 'Remote Work Setting',
  'setting.allowedyayyeryear': 'Allowed Day Per Year',
  'setting.alloweddaypermonth': 'Allowed Day Per Month',
  'setting.permissionRequest': 'Permission Request',
  'setting.addPermssionRequest': 'Add Permission Request',
  'setting.editPermssionRequest': 'Edit Permssion Request',
  'setting.leave-builder': 'Leave Setting',
  'setting.remot-work-builder': 'Remote Work Setting',
  'setting.permission-type': 'Permission Setting',
  'setting.manualentrybuilder': 'Manual Entry Setting',
  'setting.manualentry-builder': 'Manual Entry Setting',
  'setting.permissionTypeID': 'Permission Type',
  'setting.montlyLimitHH': 'Monthly Limit (HH)',
  'setting.montlyLimitMM': 'Monthly Limit (MM)',
  'setting.allowedDayPerYear': 'Allowed Day Per Year',
  'setting.allowedDayPerMonth': 'Allowed Day Per Month',
  'setting.calculatebasedoncontract': 'Is Calculate Leave Balance Based On Contract',


  // Form Builder

  'form.formBuilder':'Form Builder',
  'form.BacktoList':'Back to List',
  'form.formType':'Form Type',
  'form.Code':'Code',
  'form.FormNameEn':'Form Name (English)',
  'form.FormNameAr':'Form Name (Arabic)',
  'form.saving':'Saving...',
  'form.Save':'Save',
  'form.Update':'Update',
  'form.requestKind.permissions': 'Permissions',
  'form.requestKind.leaves': 'Leaves',
  'form.requestKind.remoteWork': 'Remote Work',
  'form.requestKind.manualEntry': 'Manual Entry',
  'form.requestKind.allRequests': 'All Requests',

  // General Alert Confirmation
  'general.submit-alert-confirmation': 'Confirm',
  'general.cancel-alert-confirmation': 'Cancel',

   'success.requestSubmitted':'Request submitted successfully',
  'error.fillAllMandatoryFields':'Please fill all mandatory fields',

  // Remote Work Error Messages
  'remoteWork.success.eligible': 'Request is eligible',
  'remoteWork.error.noConfiguration': 'No remote work configuration found for this employee. Please contact your administrator.',
  'remoteWork.error.invalidDateRange': 'Invalid date range. Please ensure the from date is before the to date and both dates are in the same year.',
  'remoteWork.error.monthlyLimitExceeded': 'Monthly remote work limit exceeded.',
  'remoteWork.error.yearlyLimitExceeded': 'Yearly remote work limit exceeded.',
  'remoteWork.error.weeklyLimitExceeded': 'Weekly remote work limit exceeded.',
  'remoteWork.error.beforeJoinDate': 'Request starts before employee join date.',
  'remoteWork.error.afterTerminationDate': 'Request ends after employee termination date.',
  'remoteWork.error.leaveExists': 'A leave request exists within the requested remote work period.',
  'remoteWork.error.configurationMissing': 'Remote work configuration is missing. Please contact your administrator.',
  'remoteWork.error.requestedCountZero': 'Requested count is 0',

  // Break Definition
  'sidebar.breakManagement': 'Break Management',
  'breakDefinition.showSelectedFirst': 'Show Selected First',
  'breakDefinition.exportPdfTitle': 'Export PDF',
  'breakDefinition.exportPdfBody': 'All items will be exported to PDF.',
  'breakDefinition.exportExcelTitle': 'Export Excel',
  'breakDefinition.exportExcelBody': 'All items will be exported to .csv',
  'breakDefinition.importDataTitle': 'Import Data',
  'breakDefinition.importDataBody': 'All items will be Imported.',
  'breakDefinition.itemsWillBeDownloaded': '{count} items will be downloaded.',
  'breakDefinition.minutes': 'Minutes',

  // Attendance Duration
  'attendanceDuration.attendanceDurationDetails': 'Time Table',
  'attendanceDuration.exportPdfTitle': 'Export PDF',
  'attendanceDuration.exportPdfBody': 'All items will be exported to PDF.',
  'attendanceDuration.exportExcelTitle': 'Export Excel',
  'attendanceDuration.exportExcelBody': 'All items will be exported to .csv',
  'attendanceDuration.importDataTitle': 'Import Data',
  'attendanceDuration.importDataBody': 'All items will be Imported.',

  'attendanceDuration.workScheduleType': 'Work Schedule Type',
  'attendanceDuration.withTime': 'With Time',
  'attendanceDuration.withoutTime': 'Without Time',
  'attendanceDuration.fixedSchedule': 'Fixed Schedule',
  'attendanceDuration.flexStartTime': 'Flex Start Time',
  'attendanceDuration.flexEndTime': 'Flex End Time',
  'attendanceDuration.coreStartTime': 'Core Start Time',
  'attendanceDuration.coreEndTime': 'Core End Time',
  'attendanceDuration.invalidTimeValues': 'Invalid Time Values',
  'attendanceDuration.invalidTimeValuesMsg': 'Some time values are not within the Basic Settings time range. Please correct the highlighted fields before submitting.',
  'attendanceDuration.unsavedChanges': 'Unsaved Changes',
  'attendanceDuration.unsavedChangesMsg': 'You have unsaved edits. Do you want to discard them?',
  'attendanceDuration.addAttendanceDuration': 'Add Attendance Duration',
  'attendanceDuration.editAttendanceDuration': 'Update Attendance Duration',
  'attendanceDuration.durationMustBePositive': 'Duration must be greater than 0 minutes',
  'attendanceDuration.stepOutTimeError': 'Step out time should between in basic time',
  'attendanceDuration.bufferAfterEndError': 'Buffer After End should not be greater than Buffer Before Start',
  'attendanceDuration.bufferLimitError': 'Buffer time after the end time is limited to a maximum of 50% of the total working hours.',
  'attendanceDuration.workingHoursThresholdError': 'Working hours is not more than working hour',
  'attendanceDuration.firstPunchAfterError': 'First Punch After is not more than working hour',
  'attendanceDuration.lastPunchBeforeError': 'Last Punch Before is not more than working hour',
  'attendanceDuration.fromTimeInError': 'From time In should not be greater than To Time',
  'attendanceDuration.toTimeError': 'To time should be greater than From time',
  'attendanceDuration.saveSuccess': 'Shift Pattern Saved Successfully!',
  'attendanceDuration.updateSuccess': 'Shift Pattern Updated Successfully!',
  'attendanceDuration.graceInError': 'Grace in is not more than working hour',
  'attendanceDuration.graceOutError': 'Grace out is not more than working hour',
  'attendanceDuration.graceOutCompareError': 'Grace Out should be greater than Grace In',
  'attendanceDuration.bufferCompareError': 'Buffer Before Start should not be greater than Buffer After End',
  'attendanceDuration.bufferStartLimitError': 'Buffer time before the start time is limited to a maximum of 50% of the total working hours.',
  'attendanceDuration.fromToTimeError': 'From time should not be greater than To time',
  'attendanceDuration.stepOut': 'Step Out',
  'attendanceDuration.break': 'Break',
  'attendanceDuration.bufferBeforeTooltip': 'Any transaction recorded within this defined buffer period, prior to the scheduled start time, will be treated as a valid transaction.',
  'attendanceDuration.bufferAfterTooltip': "Any transaction recorded within the defined buffer duration following the schedule's end time will be treated as a valid transaction.",
  'attendanceDuration.graceInTooltip': 'The allowed grace period for checking in. Transactions within this time will be considered valid.',
  'attendanceDuration.graceOutTooltip': 'The allowed grace period for checking out. Transactions within this time will be considered valid.',
  'attendanceDuration.hhmmFormatError': '{0} must be in HH:MM format',
  'attendanceDuration.minDurationApplyError': 'Min duration to apply is not more than working hour',
  'attendanceDuration.maxDurationApplyError': 'Max duration to apply is not more than working hour',
  'attendanceDuration.minWorkingHoursApplyError': 'Min working hours is not more than working hour',
  'attendanceDuration.flexIn': 'Flex In',
  'attendanceDuration.flexOut': 'Flex End',
  'attendanceDuration.coreStart': 'Core Start',
  'attendanceDuration.coreEnd': 'Core End',
  'attendanceDuration.core': 'Core',
  'attendanceDuration.total': 'Total',
  'attendanceDuration.h': 'h',
  'attendanceDuration.m': 'm',
  'attendanceDuration.nightShift': 'Night Shift',
  'attendanceDuration.attendanceDurationDetails': 'Attendance Duration Details',
  'attendanceDuration.exportPdfTitle': 'Export PDF',
  'attendanceDuration.exportPdfBody': 'Are you sure you want to export the data to PDF?',
  'attendanceDuration.exportExcelTitle': 'Export Excel',
  'attendanceDuration.exportExcelBody': 'Are you sure you want to export the data to Excel?',
  'attendanceDuration.importDataTitle': 'Import Data',
  'attendanceDuration.importDataBody': 'Upload your data file to import attendance durations.',
  'attendanceDuration.shift': 'Shift',
  'attendanceDuration.minutes': 'Minutes',
  'attendanceDuration.shiftpattern': 'Shift Pattern',
  'attendanceDuration.editshiftpattern':'Edit Shift Pattern',
  'attendanceDuration.addshiftpattern':'Add Shift Pattern',
  'attendanceDuration.automaticPermissionPolicyType': 'Automatic Permission Policy Type',
  'attendanceDuration.minAutoApprovalDuration': 'Min Auto Approval Duration',
  'attendanceDuration.maxAutoApprovalDuration': 'Max Auto Approval Duration',
  'attendanceDuration.workScheduleType': 'Work Schedule Type',
  'attendanceDuration.withTime': 'With Time',
  'attendanceDuration.withoutTime': 'Without Time',
  'attendanceDuration.fixedSchedule': 'Fixed Schedule',
  'attendanceDuration.flexStartTime': 'Flex Start Time',
  'attendanceDuration.flexEndTime': 'Flex End Time',
  'attendanceDuration.coreStartTime': 'Core Start Time',
  'attendanceDuration.coreEndTime': 'Core End Time',
  'attendanceDuration.invalidTimeValues': 'Invalid Time Values',
  'attendanceDuration.invalidTimeValuesMsg': 'Some time values are not within the Basic Settings time range. Please correct the highlighted fields before submitting.',
  'attendanceDuration.unsavedChanges': 'Unsaved Changes',
  'attendanceDuration.unsavedChangesMsg': 'You have unsaved edits. Do you want to discard them?',
  'attendanceDuration.addAttendanceDuration': 'Add Attendance Duration',
  'attendanceDuration.editAttendanceDuration': 'Update Attendance Duration',
  'attendanceDuration.durationMustBePositive': 'Duration must be greater than 0 minutes',
  'attendanceDuration.stepOutTimeError': 'Step out time should between in basic time',
  'attendanceDuration.bufferAfterEndError': 'Buffer After End should not be greater than Buffer Before Start',
  'attendanceDuration.bufferLimitError': 'Buffer time after the end time is limited to a maximum of 50% of the total working hours.',
  'attendanceDuration.workingHoursThresholdError': 'Working hours is not more than working hour',
  'attendanceDuration.firstPunchAfterError': 'First Punch After is not more than working hour',
  'attendanceDuration.lastPunchBeforeError': 'Last Punch Before is not more than working hour',
  'attendanceDuration.fromTimeInError': 'From time In should not be greater than To Time',
  'attendanceDuration.toTimeError': 'To time should be greater than From time',
  'attendanceDuration.saveSuccess': 'Shift Pattern Saved Successfully!',
  'attendanceDuration.updateSuccess': 'Shift Pattern Updated Successfully!',
  'attendanceDuration.graceInError': 'Grace in is not more than working hour',
  'attendanceDuration.graceOutError': 'Grace out is not more than working hour',
  'attendanceDuration.graceOutCompareError': 'Grace Out should be greater than Grace In',
  'attendanceDuration.bufferCompareError': 'Buffer Before Start should not be greater than Buffer After End',
  'attendanceDuration.bufferStartLimitError': 'Buffer time before the start time is limited to a maximum of 50% of the total working hours.',
  'attendanceDuration.fromToTimeError': 'From time should not be greater than To time',
  'attendanceDuration.stepOut': 'Step Out',
  'attendanceDuration.break': 'Break',
  'attendanceDuration.bufferBeforeTooltip': 'Any transaction recorded within this defined buffer period, prior to the scheduled start time, will be treated as a valid transaction.',
  'attendanceDuration.bufferAfterTooltip': "Any transaction recorded within the defined buffer duration following the schedule's end time will be treated as a valid transaction.",
  'attendanceDuration.graceInTooltip': 'The allowed grace period for checking in. Transactions within this time will be considered valid.',
  'attendanceDuration.graceOutTooltip': 'The allowed grace period for checking out. Transactions within this time will be considered valid.',
  'attendanceDuration.hhmmFormatError': '{0} must be in HH:MM format',
  'attendanceDuration.minDurationApplyError': 'Min duration to apply is not more than working hour',
  'attendanceDuration.maxDurationApplyError': 'Max duration to apply is not more than working hour',
  'attendanceDuration.minWorkingHoursApplyError': 'Min working hours is not more than working hour',
  'attendanceDuration.flexIn': 'Flex In',
  'attendanceDuration.flexOut': 'Flex End',
  'attendanceDuration.coreStart': 'Core Start',
  'attendanceDuration.coreEnd': 'Core End',
  'attendanceDuration.core': 'Core',
  'attendanceDuration.total': 'Total',
  'attendanceDuration.h': 'h',
  'attendanceDuration.m': 'm',
  'attendanceDuration.nightShift': 'Night Shift',
  'attendanceDuration.attendanceDurationDetails': 'Attendance Duration Details',
  'attendanceDuration.exportPdfTitle': 'Export PDF',
  'attendanceDuration.exportPdfBody': 'Are you sure you want to export the data to PDF?',
  'attendanceDuration.exportExcelTitle': 'Export Excel',
  'attendanceDuration.exportExcelBody': 'Are you sure you want to export the data to Excel?',
  'attendanceDuration.importDataTitle': 'Import Data',
  'attendanceDuration.importDataBody': 'Upload your data file to import attendance durations.',
  'attendanceDuration.shift': 'Shift',
  'attendanceDuration.minutes': 'Minutes',
  "attendanceDuration.shiftpattern":'Shift Pattern',
  'attendanceDuration.editshiftpattern':'Edit Shift Pattern',
  'attendanceDuration.addshiftpattern':'Add Shift Pattern',


  

  // Shift Management
  // 'sidebar.defineWorkSchedule': 'Define Work Schedule',
  'shiftManagement.shiftManagementDetails': 'Shift Management',
  'shiftManagement.exportPdfTitle': 'Export PDF',
  'shiftManagement.exportPdfBody': 'All items will be exported to PDF.',
  'shiftManagement.exportExcelTitle': 'Export Excel',
  'shiftManagement.exportExcelBody': 'All items will be exported to .csv',
  'shiftManagement.importDataTitle': 'Import Data',
  'shiftManagement.importDataBody': 'All items will be Imported.',
  'shiftManagement.deleteFailed': 'Delete Failed',
  'shiftManagement.deleteFailedMsg': 'Failed to delete selected records. Please try again.',
  'shiftManagement.itemsWillBeDownloaded': '{count} items will be downloaded.',
  'shiftManagement.recordDeletedSuccessfully': 'Record deleted successfully!',
  'shiftManagement.bulkDeleteSuccess': '{count} record(s) deleted successfully!',
  'shiftManagement.rotateShift': 'Rotate Shift',
  'shiftManagement.timetableNotAdded': 'Your time table shift is not added',
  'shiftManagement.selectTimetableFirst': 'First you have to select a timetable shift, then only you can proceed',
  'shiftManagement.saveSuccessTitle': 'Work Schedule saved successfully',
  'shiftManagement.saveSuccessMsg': 'Your Work Schedule has been saved successfully.',
  'shiftManagement.updateSuccessTitle': 'Work Schedule updated successfully',
  'shiftManagement.updateSuccessMsg': 'Your Work Schedule has been updated.',
  'shiftManagement.saveFailedTitle': 'Save failed',
  'shiftManagement.noShift': 'NO SHIFT',
  'shiftManagement.cycle': 'Cycle',
  'shiftManagement.halfCalendarView': 'Half Calendar View',
  'shiftManagement.fullCalendarView': 'Full Calendar View',
  'shiftManagement.dailySchedule': 'Daily Schedule',
  'shiftManagement.weeklySchedule': 'Weekly Schedule',
  'shiftManagement.monthlySchedule': 'Monthly Schedule',
  'shiftManagement.weekly': 'Weekly',
  'shiftManagement.monthly': 'Monthly',
  'shiftManagement.daily': 'Daily',
  'shiftWorkSchedule.confirmTabSwitch': 'Confirm Tab Switch',
  'shiftWorkSchedule.confirmTabSwitchMessage': 'Are you sure you want to switch the plan? All unsaved shifts in the current schedule will be cleared.',
  'shiftWorkSchedule.selectShiftFirst': 'Please select a shift first.',

  // Days
  'days.monday': 'Monday',
  'days.tuesday': 'Tuesday',
  'days.wednesday': 'Wednesday',
  'days.thursday': 'Thursday',
  'days.friday': 'Friday',
  'days.saturday': 'Saturday',
  'days.sunday': 'Sunday',

  // Assign Work Schedule
  'assignWorkSchedule.loadingDetails': 'Loading schedule details...',
  'assignWorkSchedule.noDetails': 'No schedule details available.',
  'assignWorkSchedule.employeeDetails': 'Employee Details',
  'assignWorkSchedule.allEmployees': 'All Employees',
  'assignWorkSchedule.shifts': 'shifts',
  'assignWorkSchedule.targetNameEn': 'Target Name',
  'assignWorkSchedule.targetNameAr': 'Target Name (Arabic)',
  'assignWorkSchedule.shiftName': 'Shift Name',
  'assignWorkSchedule.coreTime': 'Core Time',
  'assignWorkSchedule.flexTime': 'Flex Time',
  'assignWorkSchedule.showingCountOfTotal': 'Showing {showingCount} of {totalCount}',
  'assignWorkSchedule.deleteConfirmMessage': 'Are you sure you want to delete {name}?',
  'assignWorkSchedule.recordDeletedSuccessfully': 'Record deleted successfully!',
  'assignWorkSchedule.bulkDeleteSuccess': '{count} record(s) deleted successfully!',
  'assignWorkSchedule.noScheduleIdFound': 'Cannot view schedule: No schedule ID found.',
  'assignWorkSchedule.exportNotImplemented': 'You selected {count} record(s). Export is not implemented yet.',
  'assignWorkSchedule.addScheduleAssignment': 'Add Assign Shift',
  'assignWorkSchedule.editScheduleAssignment': 'Edit Assign Shift',
  'assignWorkSchedule.addButtonText': 'Assign',
  'assignWorkSchedule.noEmployeeFound': 'No matching employees',
  'assignWorkSchedule.addMoreEmployees': 'Add more employees',
  'assignWorkSchedule.tabEmployees': 'Employees',
  'assignWorkSchedule.tabDepartments': 'Departments',
  'assignWorkSchedule.tabGroups': 'Groups',
  'assignWorkSchedule.searchByNameOrId': 'Search employee by name or ID...',
  'assignWorkSchedule.searchInDepartment': 'Search employee in this department...',
  'assignWorkSchedule.searchInGroup': 'Search employee in this group...',
  'assignWorkSchedule.filterBy': 'Filter By',
  'assignWorkSchedule.selectedLabel': 'Selected',
  'assignWorkSchedule.selectTheEmployee': 'Select the Employee',
  'assignWorkSchedule.selectTheGroup': 'Select the Group',
  'assignWorkSchedule.selectTheGrade': 'Select the Grade',
  'assignWorkSchedule.selectTheDesignation': 'Select the Designation',
  'assignWorkSchedule.assignedEmployee': 'Assigned Employee',
  'assignWorkSchedule.employee': 'Employee',
  'assignWorkSchedule.dateRangeCompareError': 'From date should not greater than To date.',
  'assignWorkSchedule.dateRangeCompareErrorTo': 'To date should be greater than From date.',
  'assignWorkSchedule.recordAlreadyExist': 'Record already exist',
  'assignWorkSchedule.unableToUpdate': 'Unable to update assign shift',
  'assignWorkSchedule.unableToCreate': 'Unable to create assign shift',
  'assignWorkSchedule.saveSuccess': 'Assign Shift Saved Successfully!',
  'assignWorkSchedule.updateSuccess': 'Assign Shift Updated Successfully!',
  'assignWorkSchedule.saveError': 'Something went wrong while saving the form.',
  'assignWorkSchedule.selectDepartment': 'Please select department',
  'assignWorkSchedule.selectGroup': 'Please select a group',
  'assignWorkSchedule.pleaseSelectEmployee': 'Please select an employee',
  'assignWorkSchedule.selectLocation': 'Please select a location',
  'assignWorkSchedule.noEmployeesToShow': 'No employees found',
  'assignWorkSchedule.selectGrade': 'Please select a grade',
  'assignWorkSchedule.selectDesignation': 'Please select a designation',
  'assignWorkSchedule.selectAtLeastOneEmployee': 'Please select at least one employee',
  'assignWorkSchedule.unsavedChanges': 'Unsaved Changes',
  'assignWorkSchedule.unsavedChangesMsg': 'You have unsaved edits. Do you want to discard them?',
  
  // Temporary Schedule
  'temporarySchedule.assignTemporarySchedule': 'Assign Temporary Shift',
  'temporarySchedule.shiftName': 'Timetable Name',
  'temporarySchedule.employeeName': 'Employee Name',
  'temporarySchedule.shiftPatternCode': 'Shift Pattern Code',
  'temporarySchedule.workDate': 'Work Date',
  'temporarySchedule.createdDate': 'Created Date',
  'temporarySchedule.lastUpdatedDate': 'Last Updated Date',
  'temporarySchedule.addAssignTemporarySchedule': 'Add Assign Temporary Schedule',
  'temporarySchedule.editAssignTemporarySchedule': 'Update Assign Temporary Schedule',
  'temporarySchedule.selectionRequired': 'Selection Required',
  'temporarySchedule.selectEmployeeAndShiftMsg': 'Please select employee and shift pattern',
  'temporarySchedule.selectEmployeeMsg': 'Please select employee',
  'temporarySchedule.selectShiftPatternMsg': 'Please select shift pattern',
  'temporarySchedule.exportPDF': 'Export PDF',
  'temporarySchedule.exportExcel': 'Export Excel',
  'temporarySchedule.importData': 'Import Data',
  'temporarySchedule.exportPDFBody': 'All items will be exported to PDF.',
  'temporarySchedule.exportExcelBody': 'All items will be exported to .csv',
  'temporarySchedule.importDataBody': 'All items will be Imported.',
  'temporarySchedule.confirmation': 'Confirmation',
  'temporarySchedule.itemsWillBeDownloaded': '{count} items will be downloaded.',
  'temporarySchedule.deleteSuccess': 'Record deleted successfully!',
  'temporarySchedule.bulkDeleteSuccess': '{count} record(s) deleted successfully!',
  'temporarySchedule.deleteFailed': 'Failed to delete records',
  'temporarySchedule.deleteFailedMsg': 'An error occurred while deleting the record.',
  'temporarySchedule.saveSuccess': 'Temporary Shift assigned successfully!',
  'temporarySchedule.updateSuccess': 'Temporary Shift updated successfully!',
  'temporarySchedule.assignRecalcQueued': 'Assignment saved successfully. Recalculation is in progress and will be reflected shortly.',
  'temporarySchedule.saveFailed': 'Save failed',
  'temporarySchedule.updateFailed': 'Update failed',
  'temporarySchedule.unsavedChanges': 'Unsaved Changes',
  'temporarySchedule.unsavedChangesMsg': 'You have unsaved edits. Do you want to discard them?',
  'temporarySchedule.timelineMultipleSelectedTitle': 'Multiple employees selected',
  'temporarySchedule.timelineMultipleSelectedMessage': 'You selected {count} employees{namesSuffix}. If you want to view the current schedule timeline, please select only one employee.',
  'temporarySchedule.timetableNameEn': 'Timetable Name',
  'temporarySchedule.shiftNameEn': 'Timetable Name',
  'temporarySchedule.employeeNameEn': 'Employee Name',
  'temporarySchedule.employeeNo': 'Employee No',
  'temporarySchedule.workDate': 'Work Date',
  'temporarySchedule.createdDate': 'Created Date',
  'temporarySchedule.lastUpdatedDate': 'Last Updated Date',
  'temporarySchedule.exportPDF': 'Export to PDF',
  'temporarySchedule.exportPDFBody': 'Are you sure you want to export the data to PDF?',
  'temporarySchedule.exportExcel': 'Export to Excel',
  'temporarySchedule.exportExcelBody': 'Are you sure you want to export the data to Excel?',
  'temporarySchedule.importData': 'Import Data',
  'temporarySchedule.importDataBody': 'Are you sure you want to import data?',
  'temporarySchedule.itemsWillBeDownloaded': '{count} items will be downloaded.',
  'temporarySchedule.importSummary': 'Import Summary',
  'temporarySchedule.totalRows': 'Total Rows',
  'temporarySchedule.success': 'Success',
  'temporarySchedule.failed': 'Failed',
  'temporarySchedule.templateMismatch': 'Data is mismatched with expected template. Please download the template and try again.',
  'temporarySchedule.unexpectedColumns': 'Unexpected columns',
  'temporarySchedule.requiredMissing': 'Some required fields are missing (Employee No, Shift Pattern Code, Work Date). Please correct the file and try again.',
  'temporarySchedule.verificationResult': 'Verification Result',
  'temporarySchedule.failedRecords': 'Failed Records',
  'temporarySchedule.verifyingFile': 'Verifying file...',
  'temporarySchedule.verifyingPleaseWait': 'Please wait while we validate your data.',
  'temporarySchedule.onlyFirstNShown': 'Only first {n} records shown.',
  'temporarySchedule.downloadErrorFile': 'Download Error File',
  'temporarySchedule.reuploadFile': 'Re-upload File',
  'temporarySchedule.fixAndReupload': 'Please fix the failed records and upload the file again.',
  'temporarySchedule.verifyAgain': 'Verify Again',
  'temporarySchedule.allRecordsReady': 'All records are valid and ready to import.',
  'temporarySchedule.youCanNowConfirm': 'You can now confirm and import the data.',

  // Manual Entry
  'manualEntry.importManualEntry': 'Import Manual Entry',

  // Timetable Dropdown & Common
  'common.shiftPattern': 'Shift Pattern',
  'common.selectShiftPattern': 'Select Shift Pattern',
  'common.restDay': 'Rest Day',
  'common.startTime': 'Start Time',
  'common.endTime': 'End Time',
  'common.flexStartTime': 'Flex Start Time',
  'common.flexEndTime': 'Flex End Time',
  'common.colorCode': 'Color Code',
  'common.selected': 'Selected',
  'common.lang': 'en',
  'common.restDaySelectedMsg': 'This date is marked as a rest day. Remove it first to assign a timetable.',
  'common.halfCalendar': 'Half Calendar View',
  'common.fullCalendar': 'Full Calendar View',
  'common.searchEmployee': 'Search Employee...',
  'common.filterBy': 'Filter By',
  'common.unnamed': 'Unnamed',
  'temporarySchedule.lastUpdatedDate': 'Last Updated Date',
  'temporarySchedule.createdDate': 'Created Date',
  'temporarySchedule.workDate': 'Work Date',
  'temporarySchedule.employeeName': 'Employee Name',
  'temporarySchedule.timetableName': 'Timetable Name',

  // 'manualEntry.manualEntry': 'Manual Entry',
  'manualEntry.AddManualEntry': 'Add New Manual Entry',
  'manualEntry.EditManualEntry': 'Edit Manual Entry',
  'manualEntry.transactionType': 'Transaction Type',
  'manualEntry.deleteFailed': 'Failed to delete manual entry request',
  'manualEntry.deleteSuccess': 'Record Deleted',
  'manualEntry.bulkDeleteSuccess': 'Successfully deleted {count} record(s)',
  'manualEntry.error.fetchFailed': 'Failed to fetch manual entry request details',
  'manualEntry.error.saveFailed': 'Failed to save manual entry request',
  'manualEntry.error.title': 'Manual Entry Request Error',
  'manualEntry.error.noConfiguration': 'Manual Entry configuration not found',
  'manualEntry.error.exactTimeWindow': 'Exact time must be within ±2 minutes of current company time',
  'manualEntry.error.pastDatesNotAllowed': 'Past dates are not allowed',
  'manualEntry.error.futureDatesNotAllowed': 'Future dates are not allowed',
  'manualEntry.error.cannotUpdateAfterApproval': 'You can not update manual entry request after approval',
  'manualEntry.error.unexpectedError': 'An unexpected error occurred. Please try again or contact support if the issue persists.',
  'manualEntry.error.unexpectedSqlError': 'Unexpected SQL error',
  'manualEntry.loadingForm': 'Loading form...',
  'manualEntry.loading': 'Loading...',
  'manualEntry.showDetails': 'Show Details',

  // Report Builder
  'reportBuilder.pageTitle': 'Line Listing Filters Reports',
  'reportBuilder.pinDashboard': 'Pin here for the Dashboard',
  'reportBuilder.addFilter': 'Add Filter',
  'reportBuilder.selection': 'Selection',
  'reportBuilder.saveReport': 'Save Report',
  'reportBuilder.exportAs': 'Export As:',
  'reportBuilder.reportType': 'Report Type:',
  'reportBuilder.searchByKeyword': 'Search by keyword',
  'reportBuilder.noDataFound': 'No Data Found',
  'reportBuilder.sort': 'Sort',
  'reportBuilder.sortAscending': '(Ascending)',
  'reportBuilder.sortDescending': '(Descending)',
  'reportBuilder.saveAsExcel': 'Save as Excel',
  'reportBuilder.saveAsPDF': 'Save as PDF',
  'reportBuilder.charts': 'Charts',
  'reportBuilder.tables': 'Tables',
  'reportBuilder.between': 'Between',
  'reportBuilder.currentYear': 'Current Year',
  'reportBuilder.currentMonth': 'Current Month',
  'reportBuilder.equal': 'Equal',
  'reportBuilder.notEqual': 'Not Equal',
  'reportBuilder.greaterThan': 'Greater Than',
  'reportBuilder.lessThan': 'Less Than',
  'reportBuilder.contains': 'Contains',
  'reportBuilder.notContains': 'Does Not Contain',
  'reportBuilder.value': 'Value',
  'reportBuilder.enterNumber': 'Enter number',
  'reportBuilder.startDate': 'Start Date',
  'reportBuilder.endDate': 'End Date',
  'reportBuilder.employees': 'Employees',
  'reportBuilder.chartValueLabel': 'Value',
  'reportBuilder.noChartDataMsg': 'Please select at least one category with numeric data to display the chart',
  'reportBuilder.previous': 'Previous',
  'reportBuilder.next': 'Next',
  'reportBuilder.totalRecords': 'Total {count} Records',
  'reportBuilder.page': 'Page',
  'reportBuilder.confirm': 'Confirm',
  'reportBuilder.cancel': 'Cancel',
  'reportBuilder.filtration': 'FILTRATION',
  'reportBuilder.pleaseSelectForm': 'Please Select the Form which is given below',
  'reportBuilder.filterList': 'Filter List {id}',
  'reportBuilder.selectCategory': 'Select Category',
  'reportBuilder.selectSubCategory': 'Select Sub Category',
  'reportBuilder.selectOperator': 'Select Operator',
  'reportBuilder.customiseFilter': 'Customise Filter',
  'reportBuilder.addMore': 'Add More',
  'reportBuilder.submit': 'Submit',
  'reportBuilder.saveReportTitle': 'Save Report',
  'reportBuilder.nameEn': 'Name En',
  'reportBuilder.nameAr': 'Name Ar',
  'reportBuilder.nameEnRequired': 'Name En is required',
  'reportBuilder.nameArRequired': 'Name Ar is required',
  'reportBuilder.expressionCalculator': 'Expression Calculator',
  // Categories
  'reportBuilder.category.employee': 'Employee',
  'reportBuilder.category.leaves': 'Leaves',
  'reportBuilder.category.permissions': 'Permissions',
  // Subcategories
  'reportBuilder.sub.employeeNumber': 'Employee Number',
  'reportBuilder.sub.oldEmployeeNumber': 'Old Employee Number',
  'reportBuilder.sub.employeeName': 'Employee Name',
  'reportBuilder.sub.employeeNameARB': 'Employee Name ARB',
  'reportBuilder.sub.sickLeave': 'Sick Leave',
  'reportBuilder.sub.annualLeave': 'Annual Leave',
  'reportBuilder.sub.fromDataLeave': 'From Data Leave',
  'reportBuilder.sub.startDateToEndDate': 'Start Date to End Date',
  'reportBuilder.sub.startDatetoEndDate': 'Start Date to End Date',
  'reportBuilder.sub.startDatePermission': 'Start Date Permission',
  'reportBuilder.sub.endDatePermission': 'End Date Permission',
  'reportBuilder.sub.employeeLeave': 'Employee Leave',
  'reportBuilder.sub.employeeLeaveARB': 'Employee Leave ARB',

  // Workflow Builder
  'workflow.workflowBuilder': 'Workflow Builder',
  'workflow.approvalStages': 'Approval Stages',
  'workflow.workflowFor': 'Workflow For',
  'workflow.selectWorkflow': 'Select Workflow',
  'workflow.enterPlaceholder': 'Enter Placeholder',
  'workflow.selectPlaceholder': 'Select Placeholder',
  'workflow.untitledForm': 'Untitled Form',
  'workflow.untitledField': 'Untitled Field',
  'workflow.noFormsAvailable': 'No forms available',
  'workflow.createNewForm': 'Create New Form',
  'workflow.pleaseSelectFormBelow': 'Please select form below',
  'workflow.pleaseClickToSelectTheForm': 'Please click to select the form',
  'workflow.selectForm': 'Select Form',
  'workflow.formList': 'Form List',
  'workflow.email': 'Email',
  'workflow.sms': 'SMS',
  'workflow.pushNotification': 'Push Notification',
  'workflow.all': 'All',
  'workflow.chooseAnyAction': 'Action required: Choose any action',
  'workflow.enableAll': 'Enable',
  'workflow.submitted': 'Submitted',
  'workflow.notificationConfiguration': 'Actions Configuration',
  'workflow.enableAction': 'Enable Action',
  'workflow.action': 'Action',
  'workflow.enableNotification': 'Enable Notification',
  'workflow.requiredActions': 'Required Actions',
  'workflow.attachLinkForm': 'Attach/Link Form',
  'workflow.actor': 'Actor',
  'workflow.selectWorkflowActor': 'Select Actor',
  'workflow.actorType': 'Actor Type',
  'workflow.selectActorType': 'Select Actor Type',
  'workflow.rejectionReason': 'Rejection Reason',
  'workflow.enterDaysPlaceholder': 'Enter Days',
  'workflow.noFieldsInThisForm': 'No fields in this form',
  'workflow.loadingForm': 'Loading form...',
  'workflow.comingSoon': 'Coming soon',

  // Error/Common updates
  'error.textValidation': 'Only letters, numbers, spaces, and basic punctuation are allowed',
  'common.plus': '+',
  'common.workflowBuilder': 'Workflow Builder',
  'common.form': 'Form',
  'common.actions': 'Actions',
  'common.notificationType': 'Notification Type',
  'common.escalateType': 'Escalate Type',
  'error.validPositiveNumber': 'Please enter a valid positive number',

  // Employee Calendar & Status
  'employee.upcomingHoliday': 'Upcoming Holiday',
  'employee.leaveBalance': 'Leave Balance',
  'employee.leaveSummary': 'Leave Summary',
  'common.busy': 'Busy',
  'common.appearAway': 'Appear Away',
  'common.offline': 'Offline',
  'common.outOfOffice': 'Out of Office',
  'employee.deleteContractConfirm': 'Are you sure you want to delete contract {no}?',
  'employee.lastGroupAssignmentDeleteConfirm': 'Are you sure you want to delete this employee? {name} will be removed from the {group} group and moved to the last assigned group.',
  'workflow.untitledField': 'Untitled Field',
  'workflow.enterPlaceholder': 'Enter placeholder',
  'workflow.textInput': 'Text Input',
  'workflow.enterText': '...Enter text',
  'workflow.workflowBuilder': 'Workflow Builder',
  'workflow.workflowFor': 'Workflow For',
  'workflow.selectWorkflow': '-- Select Workflow --',
  'workflow.approvalStages': 'Approval Stages',
  'workflow.rejectionReason': 'Rejection Reason Required',
  'workflow.actorType': 'Actor Type',
  'workflow.selectActorType': '-- Select Actor Type --',
  'workflow.actor': 'Actor',
  'workflow.selectWorkflowActor': '-- Select Actor --',
  'workflow.attachLinkForm': 'Attach / Link Form',
  'workflow.requiredActions': 'Required Actions',
  'workflow.noFieldsInThisForm': 'No fields in this form',
  'workflow.untitledForm': 'Untitled Form',
  'workflow.selectForm': 'Select Form',
  'workflow.pleaseClickToSelectTheForm': 'Please click to select the form',
  'workflow.formList': 'Form List',
  'workflow.pleaseSelectFormBelow': 'Please select a form below',
  'workflow.noFormsAvailable': 'No forms available',
  'workflow.createNewForm': 'Create New Form',
  'workflow.email': 'Email',
  'workflow.sms': 'SMS',
  'workflow.pushNotification': 'Push Notification',
  'workflow.all': 'All',
  'common.loading': 'Loading...',
  'common.areYouSure': 'Are You Sure ?',
  'common.delete': 'Delete',
  'common.cancel': 'Cancel',
  'common.ok': 'OK',
  'common.recordsDeletedSuccessfully': 'records deleted successfully',
  'common.pleaseSelectAtLeastOneRecordToDelete': 'Please select at least one record to delete',
  'common.deleteConfirmWithName': 'Are you sure you want to delete {name}?',
  'common.deleteConfirmMessage': 'Are you sure you want to delete {count} records?',
  'common.savedSuccessfully': 'Saved Successfully',
  'sidbar.notificationTracking': 'Notification Tracking',
  'common.resendNotification' :'Resend',
  'dashboard.actions.applyAction': 'Apply Action',
  'dashboard.actions.applyRemoteWork': 'Apply Remote Work',
  'dashboard.actions.applyLeave': 'Apply Leave',
  'dashboard.actions.applyPermission': 'Apply Permission',
  'dashboard.details.date': 'Date',
  'dashboard.details.type': 'Type',
  'dashboard.details.leaveType': 'Leave Type',
  'dashboard.details.from': 'From',
  'dashboard.details.to': 'To',
  'dashboard.details.minutes': 'Minutes',
  'dashboard.details.status': 'Status',
  'dashboard.details.action': 'Action',
  'dashboard.details.noData': 'No data found',
  'dashboard.details.loading': 'Loading...',
  'dashboard.units.days': 'Days',
  'dashboard.units.hours': 'Hours',
  'dashboard.units.times': 'Times',
  'dashboard.modal.earlyOut': 'Early Out',
  'dashboard.modal.violations': 'Violations',
  'dashboard.modal.absent': 'Absent',
  
  // Integration Builder
  'integrationBuilder.title': 'Integration Builder',
  'integrationBuilder.addIntegration': 'Add Integration',
  'integrationBuilder.editIntegration': 'Edit Integration',
  'integrationBuilder.description': 'Unified SOAP/REST integration designer with WSDL loading, dynamic parameters, token providers, loop logic, throttling, and full request preview.',
  'integrationBuilder.loadExisting': 'Load Existing Integration',
  'integrationBuilder.safeMode': 'Safe mode: no auto-delete',
  'integrationBuilder.reloadConfig': 'Reload any previously saved integration configuration.',
  'integrationBuilder.selectIntegration': 'Select Integration',
  'integrationBuilder.loadIntegration': 'Load Integration',
  'integrationBuilder.actionDetails': 'Action Details',
  'integrationBuilder.metadata': 'Metadata',
  'integrationBuilder.actionName': 'Action Name',
  'integrationBuilder.actionCode': 'Action Code',
  'integrationBuilder.description': 'Description',
  'integrationBuilder.apiTypeAuth': 'API Type & Authentication',
  'integrationBuilder.requestTarget': 'Request target',
  'integrationBuilder.apiType': 'API Type',
  'integrationBuilder.httpMethod': 'HTTP Method',
  'integrationBuilder.authentication': 'Authentication',
  'integrationBuilder.endpointUrl': 'Endpoint URL',
  'integrationBuilder.basicAuth': 'Basic Auth',
  'integrationBuilder.username': 'Username',
  'integrationBuilder.password': 'Password',
  'integrationBuilder.bearerToken': 'Bearer Token',
  'integrationBuilder.tokenValue': 'Token Value',
  'integrationBuilder.headerName': 'Header Name',
  'integrationBuilder.tokenProvider': 'Token Provider',
  'integrationBuilder.apiKey': 'API Key',
  'integrationBuilder.keyLocation': 'Key Location',
  'integrationBuilder.keyName': 'Key Name',
  'integrationBuilder.keyValue': 'Key Value',
  'integrationBuilder.tokenProviders': 'Token Providers (Click tokens to configure)',
  'integrationBuilder.defineTokenFetch': 'Define how to fetch tokens from a specific API. Any {{tokenNAME}} used in headers/body will appear here.',
  'integrationBuilder.detectedReferences': 'Detected Token References (click to open)',
  'integrationBuilder.noTokensDetected': 'No tokens detected',
  'integrationBuilder.addTokenProvider': 'Add Token Provider',
  'integrationBuilder.refreshDropdown': 'Refresh Provider Dropdown',
  'integrationBuilder.enable': 'Enable',
  'integrationBuilder.tokenName': 'Token Name',
  'integrationBuilder.tokenEndpoint': 'Token Endpoint',
  'integrationBuilder.credentialType': 'Credential Type',
  'integrationBuilder.credentialRule': 'Credential / Rule',
  'integrationBuilder.extractFrom': 'Extract From',
  'integrationBuilder.cacheMin': 'Cache (min)',
  'integrationBuilder.customHeaders': 'Custom Headers',
  'integrationBuilder.addHeader': 'Add Header',
  'integrationBuilder.headerKey': 'Header Key',
  'integrationBuilder.headerValue': 'Header Value',
  'integrationBuilder.wsdlLoader': 'WSDL Loader',
  'integrationBuilder.wsdlUrl': 'WSDL URL',
  'integrationBuilder.loadWsdl': 'Load WSDL',
  'integrationBuilder.operation': 'Operation',
  'integrationBuilder.soapAction': 'SOAPAction',
  'integrationBuilder.bodyTemplate': 'Body Template',
  'integrationBuilder.requestPayload': 'Request payload',
  'integrationBuilder.parameters': 'Parameters',
  'integrationBuilder.detectParameters': 'Detect Parameters from Request',
  'integrationBuilder.parameterName': 'Parameter Name',
  'integrationBuilder.sourceType': 'Source Type',
  'integrationBuilder.valueOrRule': 'Value or rule',
  'integrationBuilder.listParameters': 'List Parameters',
  'integrationBuilder.addListParam': 'Add List Param',
  'integrationBuilder.loopModeThrottling': 'Loop Mode & Throttling',
  'integrationBuilder.enhanced': 'Enhanced',
  'integrationBuilder.loopDescription': 'Loop can be driven by: (A) static list, (B) date range, (C) predefined codes, or (D) API that returns a list.',
  'integrationBuilder.enableLoop': 'Enable Loop Execution',
  'integrationBuilder.loopType': 'Loop Type',
  'integrationBuilder.loopVariable': 'Loop Variable Placeholder',
  'integrationBuilder.injectInto': 'Inject Into',
  'integrationBuilder.loopSource': 'Loop Source',
  'integrationBuilder.rangeFrom': 'Range From',
  'integrationBuilder.rangeTo': 'Range To',
  'integrationBuilder.rangeNotes': 'Range Notes',
  'integrationBuilder.idList': 'ID List',
  'integrationBuilder.idListName': 'ID List Name',
  'integrationBuilder.codes': 'Codes',
  'integrationBuilder.codesType': 'Codes Type',
  'integrationBuilder.dateFrom': 'Date From',
  'integrationBuilder.dateTo': 'Date To',
  'integrationBuilder.dateStep': 'Date Step',
  'integrationBuilder.listApiUrl': 'List API URL',
  'integrationBuilder.responseListPath': 'Response List Path',
  'integrationBuilder.loopValueField': 'Loop Value Field',
  'integrationBuilder.maxItems': 'Max Items (safety)',
  'integrationBuilder.listApiBody': 'List API Body Template (optional)',
  'integrationBuilder.notes': 'Notes',
  'integrationBuilder.delayBetweenCalls': 'Delay Between Calls (ms)',
  'integrationBuilder.maxRequestsPerMinute': 'Max Requests per Minute',
  'integrationBuilder.exampleNotes': 'Example Notes',
  'integrationBuilder.finalPreview': 'Final Preview (Everything)',
  'integrationBuilder.live': 'Live',
  'integrationBuilder.print': 'Print',
  'integrationBuilder.generateSend': 'Generate & Send',
  'dashboard.modal.absent': 'Absent',
  'employee.page': 'Employee',
  'employee.deleteSuccess': 'Record deleted successfully.',
  'employee.bulkDeleteSuccess': '{count} record(s) deleted successfully.',
  'error.deleteBulkTitle': 'Delete failed',
  'error.deleteBulkMessage': 'Failed to delete records.',
  'error.deleteSingleTitle': 'Delete failed',
  'error.deleteSingleMessage': 'Failed to delete record.',
  'filter.contains': 'Contains',
  'filter.startsWith': 'Starts With',
  'filter.endsWith': 'Ends With',
  'filter.equals': 'Equals',
  'filter.notEquals': 'Not Equals',
  'filter.isNull': 'Is Null',
  'filter.isNotNull': 'Is Not Null',
  'filter.before': 'Before',
  'filter.after': 'After',
  'filter.between': 'Between',
  'filter.greaterThan': 'Greater Than',
  'filter.greaterThanOrEqual': 'Greater Than or Equal',
  'filter.lessThan': 'Less Than',
  'filter.lessThanOrEqual': 'Less Than or Equal',
  'dashboard.modal.absent': 'Absent',
  // Unified Login
  'unifiedLogin.english': "English",
  'unifiedLogin.arabic': "العربية",
  'unifiedLogin.heroTitle': "Attendance, Shifts, and Approvals. ",
  'unifiedLogin.heroTitleHighlight': "Unified",
  'unifiedLogin.heroLead': "One platform for HR and operations teams to track time in real time, plan complex shifts, and run approvals through dynamic workflows — no spreadsheets, no chasing.",
  'unifiedLogin.tenantPlaceholder': "Enter your company code",
  'unifiedLogin.tenantError': "Enter your company code to continue.",
  'unifiedLogin.signInMicrosoft': "Sign in with Microsoft",
  'unifiedLogin.signInUsername': "Sign in with Username & Password",
  'unifiedLogin.backToSignIn': "← Back to sign-in options",
  'unifiedLogin.usernamePlaceholder': "Username",
  'unifiedLogin.passwordPlaceholder': "Password",
  'unifiedLogin.signIn': "Sign in",
  'unifiedLogin.signingIn': "Signing in…",
  'unifiedLogin.tenantExample1': "e.g. ACME2024",
  'unifiedLogin.tenantExample2': "e.g. NORTH-99",
  'unifiedLogin.tenantExample3': "e.g. GLOBALTECH",
  'unifiedLogin.missingCredentials': "Please enter username and password",
  'unifiedLogin.loginFailed': "Login failed",
  'unifiedLogin.ideaLeaveTitle': "Leave",
  'unifiedLogin.ideaLeaveDesc': "Request leave, track balances, and get approvals in a few taps.",
  'unifiedLogin.ideaRemoteTitle': "Remote Work",
  'unifiedLogin.ideaRemoteDesc': "Submit and approve remote work requests without the paperwork.",
  'unifiedLogin.ideaPermissionTitle': "Permission",
  'unifiedLogin.ideaPermissionDesc': "Short permissions and early-outs, routed straight to your manager.",
  'unifiedLogin.ideaPoliciesTitle': "Policies",
  'unifiedLogin.ideaPoliciesDesc': "Company rules and attendance policies, always one click away.",
  'unifiedLogin.ideaScheduleTitle': "Work Schedule",
  'unifiedLogin.ideaScheduleDesc': "Shifts, rotations, and coverage — planned and shared in one view.",
  'unifiedLogin.ideaClockTitle': "Clock In & Out",
  'unifiedLogin.ideaClockDesc': "Web, mobile, or kiosk. One tap and your attendance is logged.",
  'unifiedLogin.ideaCalendarTitle': "Calendar",
  'unifiedLogin.ideaCalendarDesc': "A full monthly view of attendance, leave, and rest days at a glance.",
  'unifiedLogin.ideaDashboardsTitle': "Dashboards",
  'unifiedLogin.ideaDashboardsDesc': "Live dashboards for attendance, absences, and labor cost.",
  'unifiedLogin.greetingMorning': "Good morning.",
  'unifiedLogin.greetingAfternoon': "Good afternoon.",
  'unifiedLogin.greetingEvening': "Good evening.",
  'unifiedLogin.weekdayFull.sun': "Sunday",
  'unifiedLogin.weekdayFull.mon': "Monday",
  'unifiedLogin.weekdayFull.tue': "Tuesday",
  'unifiedLogin.weekdayFull.wed': "Wednesday",
  'unifiedLogin.weekdayFull.thu': "Thursday",
  'unifiedLogin.weekdayFull.fri': "Friday",
  'unifiedLogin.weekdayFull.sat': "Saturday",
  'unifiedLogin.monthFull.jan': "January",
  'unifiedLogin.monthFull.feb': "February",
  'unifiedLogin.monthFull.mar': "March",
  'unifiedLogin.monthFull.apr': "April",
  'unifiedLogin.monthFull.may': "May",
  'unifiedLogin.monthFull.jun': "June",
  'unifiedLogin.monthFull.jul': "July",
  'unifiedLogin.monthFull.aug': "August",
  'unifiedLogin.monthFull.sep': "September",
  'unifiedLogin.monthFull.oct': "October",
  'unifiedLogin.monthFull.nov': "November",
  'unifiedLogin.monthFull.dec': "December",
  'unifiedLogin.liveWorkspaceTime': "Live workspace time",
  'unifiedLogin.welcomeBack': "Welcome back",
  'unifiedLogin.signInToWorkspace': "Sign in to your workspace",
  'unifiedLogin.accessDescription': "Access your attendance, schedule, and approvals.",
  'unifiedLogin.enterCredentials': "Enter your credentials",
  'unifiedLogin.usernameLabel': "Username",
  'unifiedLogin.passwordLabel': "Password",
  'unifiedLogin.orContinueWith': "or continue with",
  'unifiedLogin.reenterTenantCode': "Re enter company code",
  'unifiedLogin.companyCodeLabel': "Company Code",
  'unifiedLogin.reentryCode': "Re-enter Code",
  'notification.reportTemplate':'Report Template',
  'notification.selectReportTemplate':'Select Report Template',
  'assistant.title': 'Assistant',
  'assistant.open': 'Open assistant',
  'assistant.close': 'Close',
  'assistant.newChat': 'New chat',
  'assistant.confirm': 'Confirm',
  'assistant.cancel': 'Cancel',
  'assistant.thinking': 'Thinking…',
  'assistant.send': 'Send',
  'assistant.placeholder': 'Ask about leaves, permissions, working hours…',
  'assistant.greeting': 'Hi! Ask me about your leaves, permissions, or working hours.',
  'dashboard.superAdmin.eyebrow': 'SUPER ADMIN · TENANT INTELLIGENCE',
  'dashboard.superAdmin.title': 'Workforce Command Center',
  'dashboard.superAdmin.subtitle': 'See the organization first. Expand only what you want to investigate.',
  'dashboard.superAdmin.hero.eyebrow':'FAHR · ALL COMPANIES · 01 AUG — 17 AUG',
  'dashboard.superAdmin.hero.title':'The workforce is performing at 94.6%.',
  'dashboard.superAdmin.hero.subtitle':'5 companies · 14,208 employees',
  'dashboard.superAdmin.hero.deltaPositive':'1.2 pp vs previous period',
  'dashboard.superAdmin.filters.tenant': 'Tenant',
  'dashboard.superAdmin.filters.company': 'Company',
  'dashboard.superAdmin.filters.period': 'Period',
  'dashboard.superAdmin.metrics.employees.label': 'Employees',
  'dashboard.superAdmin.metrics.employees.sub': '{count} companies',
  'dashboard.superAdmin.metrics.attendance.label': 'Attendance',
  'dashboard.superAdmin.metrics.attendance.trend': '↑ {delta} pp · vs {target}% target',
  'dashboard.superAdmin.metrics.absent.label': 'Absent',
  'dashboard.superAdmin.metrics.absent.sub': '{percent}% of workforce',
  'dashboard.superAdmin.metrics.late.label': 'Late',
  'dashboard.superAdmin.metrics.late.sub': '{percent}% of workforce',
  'dashboard.superAdmin.metrics.violations.label': 'Violations',
  'dashboard.superAdmin.metrics.violations.sub': 'Open across tenant',
  'dashboard.superAdmin.metrics.compliance.label': 'Compliance',
  'dashboard.superAdmin.metrics.compliance.trend': '{status}',
  'dashboard.superAdmin.companyHealth.title': 'Company Health',
  'dashboard.superAdmin.companyHealth.tagline': 'Attendance · Presence · Absence · Violations',
  'dashboard.superAdmin.companyHealth.entity': 'Entity',
  'dashboard.superAdmin.companyHealth.employees': 'Employees',
  'dashboard.superAdmin.companyHealth.present': 'Present',
  'dashboard.superAdmin.companyHealth.attendance': 'Attendance',
  'dashboard.superAdmin.companyHealth.absent': 'Absent',
  'dashboard.superAdmin.companyHealth.violations': 'Violations',
  'dashboard.superAdmin.companyHealth.pending': 'Pending',
  'dashboard.superAdmin.companyHealth.status': 'Status',
  'dashboard.superAdmin.companyHealth.viewCompany': 'View company',
  'dashboard.superAdmin.orgTree.title': 'Company Health Map · Organization Tree',
  'dashboard.superAdmin.orgTree.tag': 'Click only the small ⌄ icon to see children',
  'dashboard.superAdmin.status.healthy': 'Healthy',
  'dashboard.superAdmin.status.watch': 'Watch',
  'dashboard.superAdmin.status.needsAttention': 'Needs Attention'

  , 'dashboard.superAdmin.charts.attendanceTrend.title': 'Attendance Trend'
  , 'dashboard.superAdmin.charts.attendanceTrend.period6m': '6 months'
  , 'dashboard.superAdmin.charts.workforceDistribution.title': 'Workforce Distribution'
  , 'dashboard.superAdmin.charts.workforceDistribution.selectedPeriod': 'Selected period'
  , 'dashboard.superAdmin.charts.absenceByCompany.title': 'Absence by Company'
  , 'dashboard.superAdmin.charts.absenceByCompany.subtitle': 'Absent employees within the selected period'
  , 'dashboard.superAdmin.charts.lateByCompany.title': 'Late Arrivals by Company'
  , 'dashboard.superAdmin.charts.lateByCompany.subtitle': 'Late employees within the selected period'
  , 'common.other': 'Other'

  , 'dashboard.superAdmin.opTrends.title': 'Operational Trends'
  , 'dashboard.superAdmin.opTrends.subtitle': 'Additional line-chart analytics'
  , 'dashboard.superAdmin.charts.attendanceRate.title': 'Attendance Rate by Month'
  , 'dashboard.superAdmin.charts.attendanceRate.subtitle': 'Tenant attendance performance over time'
  , 'dashboard.superAdmin.charts.attendance': 'Attendance'
  , 'dashboard.superAdmin.charts.target': 'Target'
  , 'dashboard.superAdmin.charts.absentEmployees.title': 'Absent Employees Trend'
  , 'dashboard.superAdmin.charts.absentEmployees.subtitle': 'Monthly movement in absence volume'
  , 'dashboard.superAdmin.charts.absentEmployees': 'Absent employees'
  , 'dashboard.superAdmin.charts.lateArrivals.title': 'Late Arrivals Trend'
  , 'dashboard.superAdmin.charts.lateArrivals.subtitle': 'Monthly late-arrival records'
  , 'dashboard.superAdmin.charts.lateArrivals': 'Late arrivals'
  , 'dashboard.superAdmin.charts.earlyOut.title': 'Early Out Trend'
  , 'dashboard.superAdmin.charts.earlyOut.subtitle': 'Monthly early-out records'
  , 'dashboard.superAdmin.charts.earlyOut': 'Early out'
  , 'dashboard.superAdmin.charts.compliance.title': 'Compliance Trend'
  , 'dashboard.superAdmin.charts.compliance.subtitle': 'Tenant compliance performance'
  , 'dashboard.superAdmin.charts.compliance': 'Compliance'
  , 'dashboard.superAdmin.charts.openViolations.title': 'Open Violations Trend'
  , 'dashboard.superAdmin.charts.openViolations.subtitle': 'Open attendance violations over time'
  , 'dashboard.superAdmin.charts.openViolations': 'Open violations'
  , 'common.superAdmin': 'Super Admin'

};
